(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app/test/view-test-result-button/view-test-result-button.component.html":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app/test/view-test-result-button/view-test-result-button.component.html ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"text-align: center\">\n  <nb-icon\n    (click)=\"viewResult()\"\n    icon=\"list-outline\"\n    [options]=\"{ animation: { type: 'pulse' } }\"\n  >\n  </nb-icon>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/assignment/assignment.component.html":
/*!********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/assignment/assignment.component.html ***!
  \********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nb-card>\n  <nb-card-header>Assignments </nb-card-header>\n  <nb-card-body>\n    <nb-select\n      name=\"sdf\"\n      (selectedChange)=\"getFilteredSubjects()\"\n      [(ngModel)]=\"selectedSubCourseID\"\n      fullWidth\n      placeholder=\"Select Sub Course\"\n    >\n      <nb-option\n        *ngFor=\"let subcourse of dataService.subCourses\"\n        value=\"{{ subcourse.id }}\"\n      >\n        {{ subcourse.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <nb-select\n      name=\"sdf\"\n      (selectedChange)=\"getFilteredChapters()\"\n      [(ngModel)]=\"selectedSubjectID\"\n      fullWidth\n      placeholder=\"Select Subject\"\n    >\n      <nb-option\n        *ngFor=\"let subject of filteredSubjects\"\n        value=\"{{ subject.id }}\"\n        >{{ subject.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <nb-select\n      name=\"sdf\"\n      [(ngModel)]=\"selectedChapterID\"\n      fullWidth\n      placeholder=\"Select Chapter\"\n    >\n      <nb-option\n        *ngFor=\"let chapter of filteredChapters\"\n        value=\"{{ chapter.id }}\"\n        >{{ chapter.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <!-- <input fullWidth nbInput placeholder=\"Pdf Title\" name=\"pdfTitle\" [(ngModel)]=\"pdfTitle\">\n                <br>\n                <br> -->\n\n    <form>\n      <!-- <input id=\"imageFile\"  type=\"file\" name=\"imageFile\" (change)=\"postMethod($event.target.files)\"> -->\n      <input\n        id=\"imageFile\"\n        type=\"file\"\n        name=\"imageFile\"\n        (change)=\"pdfFileSelected($event.target.files)\"\n      />\n    </form>\n    <br />\n    <button\n      style=\"width: 100%\"\n      type=\"submit\"\n      (click)=\"uploadPdf()\"\n      nbButton\n      status=\"primary\"\n    >\n      Submit\n    </button>\n  </nb-card-body>\n</nb-card>\n<div class=\"col-md-6\">\n  <nb-card>\n    <nb-card-header>All Assignments</nb-card-header>\n\n    <nb-card-body>\n      <ng2-smart-table\n        [settings]=\"pdfSettings\"\n        [source]=\"pdfs\"\n        (deleteConfirm)=\"deleteData($event)\"\n      >\n      </ng2-smart-table>\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/add-chapter/add-chapter.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/add-chapter/add-chapter.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-12\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add Chapter</nb-card-header>\n      <nb-card-body>\n        <form class=\"form-inline\">\n\n          <div class=\"columns\">\n            <div class=\"column \">\n              <nb-select (selectedChange)=\"getFilteredSubjects()\" fullWidth name=\"asdf\" placeholder=\"Select Sub Course\"\n                [(ngModel)]=\"selectedSubCourseID\">\n                <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n                <nb-option *ngFor=\"let subcourse of dataService.subCourses\" value=\"{{subcourse.id}}\">{{subcourse.name}}\n                </nb-option>\n\n              </nb-select>\n              <br>\n              <br>\n              <nb-select fullWidth name=\"asdf\" placeholder=\"Select Subject\" [(ngModel)]=\"selectedSubjectID\">\n                <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n                <nb-option *ngFor=\"let subject of filteredSubjects\" value=\"{{subject.id}}\">{{subject.name}}\n                </nb-option>\n\n              </nb-select>\n              <br>\n              <br>\n              <input fullWidth name='asdfsdf' type=\"text\" nbInput placeholder=\"Chapter Name\" [(ngModel)]=\"chapter\" />\n\n            </div>\n            <!-- <div class=\"column\"> <input fullWidth type=\"text\" nbInput placeholder=\"Subject Name\" />\n            </div> -->\n          </div>\n\n\n\n          <button (click)=\"submitChapter()\" style=\"width: 100%;\" type=\"submit\" nbButton status=\"primary\">Submit</button>\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Chapter</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"dataService.chapters\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/book-test-master/book-test-master.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/book-test-master/book-test-master.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"columns\">\n  <!-- <div class=\"column\">\n\n    <app-slot-master></app-slot-master>\n  </div> -->\n  <div class=\"column\">\n    <app-book-test></app-book-test>\n\n    <!-- <app-course></app-course> -->\n  </div>\n\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/book-test/book-test.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/book-test/book-test.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-6\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Book A Test </nb-card-header>\n      <nb-card-body>\n        <form class=\"form-inline\" style=\"text-align:center\">\n\n          <nb-select class=\"nbElement\" name=\"asdf\" placeholder=\"Select City\" [(ngModel)]=\"selectedCityID\"\n            (selectedChange)=\"citySelected($event)\">\n            <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n            <nb-option *ngFor=\"let city of cities\" value=\"{{city.id}}\">{{city.city}}</nb-option>\n\n          </nb-select>\n\n\n          <nb-select class=\"nbElement\" name=\"asdf\" placeholder=\"Select Course\" [(ngModel)]=\"selectedCourseID\"\n            (selectedChange)=\"courseSelected($event)\">\n            <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n            <nb-option *ngFor=\"let course of courses\" value=\"{{course.id}}\">{{course.course}}</nb-option>\n\n          </nb-select>\n\n          <nb-select class=\"nbElement\" name=\"asdf\" placeholder=\"Select Subject\" [(ngModel)]=\"selectedSubjectID\">\n            <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n            <nb-option *ngFor=\"let subject of subjects\" value=\"{{subject.id}}\">{{subject.subject}}</nb-option>\n\n          </nb-select>\n\n          <nb-select class=\"nbElement\" name=\"asdf\" placeholder=\"Select Center\" [(ngModel)]=\"selectedCenterID\">\n            <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n            <nb-option *ngFor=\"let center of centers\" value=\"{{center.id}}\">{{center.center}}</nb-option>\n\n          </nb-select>\n\n\n          <input class=\"nbElement\" name='asdfsdf' type=\"text\" nbInput placeholder=\"Time Slot: 14:00\"\n            [(ngModel)]=\"timeSlot\" />\n\n          <input class=\"nbElement\" name='asdfsdf' type=\"date\" nbInput placeholder=\"Subject Name\" [(ngModel)]=\"date\" />\n\n          <input class=\"nbElement\" name='asdfsdf' type=\"text\" nbInput placeholder=\"Test Price\" [(ngModel)]=\"amount\" />\n\n\n\n          <br>\n          <button style=\"margin:8px\" (click)=\"submitTest()\" type=\"submit\" nbButton status=\"primary\">Submit</button>\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Test</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"tests\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/center-master/center-master.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/center-master/center-master.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-12\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add Center</nb-card-header>\n      <nb-card-body>\n        <form class=\"form-inline\">\n\n          <div class=\"columns\">\n            <div class=\"column \">\n              <nb-select name='sdf' [(ngModel)]=\"selecteCityID\" fullWidth placeholder=\"Select City\">\n                <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n                <nb-option *ngFor=\"let city of cities\" value=\"{{city.id}}\">{{city.city}}</nb-option>\n\n              </nb-select>\n              <br>\n              <br>\n              <input fullWidth name='asdfsdf' type=\"text\" nbInput placeholder=\"Center Name\" [(ngModel)]=\"centerName\" />\n              <br>\n              <br>\n              <input fullWidth name='asdfsdfsdf' type=\"text\" nbInput placeholder=\"Center Google Map URL\"\n                [(ngModel)]=\"centerMapURL\" />\n            </div>\n            <!-- <div class=\"column\"> <input fullWidth type=\"text\" nbInput placeholder=\"Subject Name\" />\n            </div> -->\n          </div>\n\n\n\n          <button (click)=\"submit()\" style=\"width: 100%;\" type=\"submit\" nbButton status=\"primary\">Submit</button>\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Centers</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"centers\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/city-master/city-master.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/city-master/city-master.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <div class=\"columns\">\n  <div class=\"column\">\n\n    <app-city></app-city>\n  </div>\n  <div class=\"column\">\n    <app-course></app-course>\n  </div>\n\n</div>\n<div class=\"columns\">\n\n  <div class=\"column\">\n\n    <app-subject></app-subject>\n\n  </div>\n  <div class=\"column\">\n\n    <app-center-master></app-center-master>\n\n  </div>\n\n</div> -->\n<div class=\"columns\">\n  <div class=\"column\">\n\n    <app-city></app-city>\n  </div>\n  <div class=\"column\">\n    <app-center-master></app-center-master>\n\n  </div>\n\n</div>\n<div class=\"columns\">\n\n  <div class=\"column\">\n    <app-course></app-course>\n\n\n  </div>\n  <div class=\"column\">\n\n    <app-subject></app-subject>\n\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/download-report-button-component/download-report-button-component.component.html":
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/download-report-button-component/download-report-button-component.component.html ***!
  \***************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"text-align: center;\">\n\n  <a>\n    <nb-icon (click)=\"download()\" disabled icon=\"cloud-download-outline\" [options]=\"{ animation: { type: 'zoom' } }\">\n    </nb-icon>\n  </a>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/get-questions/get-questions.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/get-questions/get-questions.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"text-align: center;\">\n\n  <a>\n    <nb-icon (click)=\"getQuestions()\" icon=\"eye-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon>\n  </a>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/get-solutions/get-solutions.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/get-solutions/get-solutions.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"text-align: center;\">\n\n  <a>\n    <nb-icon (click)=\"getSolutions()\" icon=\"eye-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon>\n  </a>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/live/live.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/live/live.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-6\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Video Courses </nb-card-header>\n      <nb-card-body>\n        <nb-select name=\"sdf\" (selectedChange)=\"getFilteredSubjects()\" [(ngModel)]=\"selectedSubCourseID\" fullWidth\n          placeholder=\"Select Sub Course\">\n          <nb-option *ngFor=\"let subcourse of dataService.subCourses\" value=\"{{ subcourse.id }}\">{{ subcourse.name }}\n          </nb-option>\n        </nb-select>\n        <br />\n        <br />\n        <nb-select name=\"sdf\" [(ngModel)]=\"selectedSubjectID\" fullWidth placeholder=\"Select Subject\">\n          <nb-option *ngFor=\"let subject of filteredSubjects\" value=\"{{ subject.id }}\">{{ subject.name }}\n          </nb-option>\n        </nb-select>\n        <br />\n        <br />\n\n        <input type=\"text\" [(ngModel)]=\"name\" nbInput fullWidth placeholder=\"Video Title\" />\n        <br />\n        <br />\n        <input type=\"date\" [(ngModel)]=\"date\" nbInput fullWidth placeholder=\"Class Date\" />\n        <br />\n        <br />\n        <input type=\"text\" [(ngModel)]=\"time\" nbInput fullWidth placeholder=\"Class Time\" />\n        <br />\n        <br />\n        <input type=\"text\" [(ngModel)]=\"youtubeLink\" nbInput fullWidth placeholder=\"Youtube Link\" />\n        <br />\n\n        <br />\n        <button style=\"width: 100%;\" type=\"submit\" (click)=\"addVideo()\" nbButton status=\"primary\">\n          Submit\n        </button>\n      </nb-card-body>\n    </nb-card>\n  </div>\n\n  <div class=\"col-md-6\">\n    <nb-card>\n      <nb-card-header>All Videos</nb-card-header>\n\n      <nb-card-body>\n        <ng2-smart-table [settings]=\"videoSettings\" [source]=\"videos\" (deleteConfirm)=\"deleteData($event)\">\n        </ng2-smart-table>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/pdf-solution-upload/pdf-solution-upload.component.html":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/pdf-solution-upload/pdf-solution-upload.component.html ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form>\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n</form>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-editor/question-editor.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-editor/question-editor.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <ckeditor [editor]=\"Editor\" data=\"data\" (ready)=\"onReady($event)\"></ckeditor> -->\n<!-- <div id=\"editor\">This is some sample content.</div> -->\n<!-- <textarea #editor [name]=\"'editor'+rowData.id\" [id]=\"'editor'+rowData.id\" rows=\"3\" cols=\"40\"> {{rowData.id}}</textarea> -->\n\n\n<ng-container *ngIf=\"rowData.type=='text'; then thenTemplate; else elseTemplate\"></ng-container>\n<ng-template #thenTemplate>\n  <input style=\"width: 100%;\" type=\"text\" name=\"\" [(ngModel)]=\"rowData.value\" disabled>\n\n\n\n\n</ng-template>\n<ng-template #elseTemplate>\n\n  <form>\n    <input type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n  </form>\n\n  <img style=\"width: 50%;\" src=\"{{this.dataService.serverUrl+'uploads/solutionQuestion/'+this.rowData.id+'.png'}}\"\n    alt=\"\">\n  <!-- <img src=\"{{this.dataService.serverUrl+'uploads/solutionQuestion/'+this.rowData.id+'.'+this.imageExtension}}\" alt=\"\"> -->\n</ng-template>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-number/question-number.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-number/question-number.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<input type=\"text\" value=\"{{this.rowData.questionNumber}}\">\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-update-number/question-update-number.component.html":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-update-number/question-update-number.component.html ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<input style=\"width: 100%;\" type=\"text\" name=\"\" [(ngModel)]=\"rowData.questionNumber\" (change)=\"valueChanged()\">\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-upload-video/question-upload-video.component.html":
/*!*****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-upload-video/question-upload-video.component.html ***!
  \*****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form>\n  <input type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n</form>\n\n\n<video style=\"width: 40%;\" controls\n  src=\"{{this.dataService.serverUrl+'uploads/solutionVideo/'+this.rowData.id+'.mp4'}}\"></video>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/result-upload/result-upload.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/result-upload/result-upload.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [nbSpinner]=\"loading\">\n\n\n\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n\n</form>\n<!-- <form *ngIf=\"!loading\">\n\n\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n\n</form> -->\n\n\n\n\n\n\n\n\n<!-- <form *ngIf=\"loading\">\n\n\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n\n</form> -->\n\n\n<!-- <form *ngIf=\"!loading\">\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n\n</form> -->\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/revision-note-component/revision-note-component.component.html":
/*!*********************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/revision-note-component/revision-note-component.component.html ***!
  \*********************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<a [href]=\"pdfUrl\" target=\"_blank\">Pdf Note Link</a>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-image-testimonial/slider-image-testimonial.component.html":
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-image-testimonial/slider-image-testimonial.component.html ***!
  \***********************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"text-align: center\">\n  <img\n    style=\"width: 100px\"\n    [src]=\"url + 'uploads/sliders/' + rowData.slider\"\n    alt=\"sadf\"\n  />\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-image/slider-image.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-image/slider-image.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"this.type == 'image'\">\n  <div style=\"text-align: center\">\n    <img\n      style=\"width: 100px\"\n      [src]=\"url + 'uploads/sliders/' + rowData.name\"\n      alt=\"undefined\"\n    />\n  </div>\n</div>\n<div *ngIf=\"this.type == 'pdf'\">\n  <div style=\"text-align: center\">\n    <a\n      href=\"{{\n        this.dataService.serverUrl + 'uploads/freeNotes/' + rowData.pdfName\n      }}\"\n      >{{ rowData.name }}</a\n    >\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-thumbnail/slider-thumbnail.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-thumbnail/slider-thumbnail.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style='text-align: center;'>\n  <img style=\"width: 100px;\" [src]=\"url+'uploads/thumbnails/'+rowData.thumbnail\" alt=\"sadf\">\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-video/slider-video.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-video/slider-video.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <iframe width=\"560\" height=\"315\" [src]=\"'https://www.youtube.com/embed/'+videoID\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> -->\n\n<a [href]=\"videoURL\" target=\"_blank\">Video Link</a>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slot-master/slot-master.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/slot-master/slot-master.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-12\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add Time Slot (Remaining)</nb-card-header>\n      <nb-card-body>\n        <form class=\"form-inline\">\n\n          <div class=\"columns\">\n            <div class=\"column \">\n\n\n              <input fullWidth name='asdfsdfsdf' type=\"text\" nbInput placeholder=\"14:00 or 2:00 pm\"\n                [(ngModel)]=\"timeSlot\" />\n            </div>\n            <!-- <div class=\"column\"> <input fullWidth type=\"text\" nbInput placeholder=\"Subject Name\" />\n              </div> -->\n          </div>\n\n\n\n          <button (click)=\"submit()\" style=\"width: 100%;\" type=\"submit\" nbButton status=\"primary\">Submit</button>\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Time Slots</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"centers\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.html":
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.html ***!
  \***************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"text-align: center\">\n  <nb-icon\n    (click)=\"view()\"\n    icon=\"list-outline\"\n    [options]=\"{ animation: { type: 'pulse' } }\"\n  >\n  </nb-icon>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/student-subscription/student-subscription.component.html":
/*!***************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/student-subscription/student-subscription.component.html ***!
  \***************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nb-card>\n  <nb-card-header\n    >{{ this.dataService.subscription.selectedStudentName }} ( Subscription )\n    :</nb-card-header\n  >\n\n  <nb-card-body>\n    <form class=\"form-inline\" style=\"text-align: center\">\n      <div class=\"columns\">\n        <div class=\"column\">\n          <!-- fullWidth -->\n          <nb-select\n            (selectedChange)=\"getFilteredSubjects()\"\n            name=\"asdf\"\n            placeholder=\"Select Sub Course\"\n            [(ngModel)]=\"selectedSubCourseID\"\n          >\n            <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n            <nb-option\n              *ngFor=\"let subcourse of dataService.subCourses\"\n              value=\"{{ subcourse.id }}\"\n              >{{ subcourse.name }}\n            </nb-option>\n          </nb-select>\n          &nbsp;\n          <nb-select\n            name=\"asdf\"\n            placeholder=\"Select Subject\"\n            [(ngModel)]=\"selectedSubjectID\"\n          >\n            <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n            <nb-option\n              *ngFor=\"let subject of filteredSubjects\"\n              value=\"{{ subject.id }}\"\n              >{{ subject.name }}\n            </nb-option>\n          </nb-select>\n          &nbsp;\n          <input\n            name=\"asdfsdf\"\n            type=\"date\"\n            nbInput\n            placeholder=\"Expiry Date\"\n            [(ngModel)]=\"expiryDate\"\n          />\n          &nbsp;\n          <button (click)=\"submit()\" type=\"submit\" nbButton status=\"primary\">\n            Submit\n          </button>\n        </div>\n        <!-- <div class=\"column\"> <input fullWidth type=\"text\" nbInput placeholder=\"Subject Name\" />\n        </div> -->\n      </div>\n    </form>\n    <br />\n\n    <ng2-smart-table\n      [settings]=\"settings\"\n      [source]=\"this.dataService.subscription.studentSubjects\"\n      (deleteConfirm)=\"onDeleteConfirm($event)\"\n    >\n    </ng2-smart-table>\n  </nb-card-body>\n</nb-card>\n<nb-card>\n  <nb-card-header>Video Views :</nb-card-header>\n\n  <nb-card-body>\n    <ng2-smart-table\n      [settings]=\"tutorialViewsSettings\"\n      [source]=\"this.dataService.subscription.studentTutorialViews\"\n      (deleteConfirm)=\"deleteVideoView($event)\"\n    >\n    </ng2-smart-table>\n  </nb-card-body>\n</nb-card>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/student/student.component.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/student/student.component.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div>\n    <nb-card>\n      <nb-card-header>All Students</nb-card-header>\n\n      <nb-card-body>\n        <ng2-smart-table\n          [settings]=\"studentSettings\"\n          [source]=\"students\"\n          (deleteConfirm)=\"deleteData($event)\"\n        >\n        </ng2-smart-table>\n      </nb-card-body>\n    </nb-card>\n  </div>\n  <div>\n    <app-student-subscription\n      *ngIf=\"ds.subscription.selectedStudentID\"\n      id=\"manageSubscriptionContainer\"\n    >\n    </app-student-subscription>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/student/view-button/view-button.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/student/view-button/view-button.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <div style=\"text-align: center\">\n  <nb-icon\n    (click)=\"view()\"\n    icon=\"checkmark-square-outline\"\n    [options]=\"{ animation: { type: 'pulse' } }\"\n  >\n  </nb-icon>\n</div> -->\n\nNOT USING\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/subject-master/subject-master.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/subject-master/subject-master.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"columns\">\n\n  <div class=\"column\">\n\n    <app-subject></app-subject>\n\n  </div>\n  <div class=\"column\">\n\n    <!-- <app-subject></app-subject> -->\n    <app-center-master></app-center-master>\n\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/upload-report-button/upload-report-button.component.html":
/*!***************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/upload-report-button/upload-report-button.component.html ***!
  \***************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <div style=\"text-align: center;\">\n\n\n  <input type=\"file\" (change)=\"fileChangeEvent($event)\" placeholder=\"Upload file...\" />\n\n\n\n  <nb-icon (click)=\"upload()\" icon=\"cloud-upload-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon>\n\n</div> -->\n<!-- \n\n<form #uploadForm action=\"http://localhost:8080/report/upload\" method=\"post\" enctype=\"multipart/form-data\">\n  <input name=\"foo\" type=\"file\" />\n  <nb-icon (click)=\"upload()\" icon=\"cloud-upload-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon>\n</form> -->\n\n\n\n<form>\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n</form>\n<!-- <nb-icon (click)=\"upload()\" icon=\"cloud-upload-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon> -->\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/upload-solution-csv/upload-solution-csv.component.html":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/upload-solution-csv/upload-solution-csv.component.html ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <div style=\"text-align: center;\">\n\n\n  <input type=\"file\" (change)=\"fileChangeEvent($event)\" placeholder=\"Upload file...\" />\n\n\n\n  <nb-icon (click)=\"upload()\" icon=\"cloud-upload-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon>\n\n</div> -->\n<!-- \n\n<form #uploadForm action=\"http://localhost:8080/report/upload\" method=\"post\" enctype=\"multipart/form-data\">\n  <input name=\"foo\" type=\"file\" />\n  <nb-icon (click)=\"upload()\" icon=\"cloud-upload-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon>\n</form> -->\n\n\n\n<form>\n  <input id=\"myForm\" type=\"text\" name=\"file\" [(ngModel)]=\"numberOfQuestions\" style=\"width: 4rem;text-align: center;\">\n  &nbsp;\n  <button (click)=\"add()\">Add</button>\n\n\n  <!-- <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\"> -->\n</form>\n<!-- <nb-icon (click)=\"upload()\" icon=\"cloud-upload-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon> -->\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/uploads/uploads.component.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/uploads/uploads.component.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\n  <nb-tabset fullWidth>\n    <nb-tab tabTitle=\"Quiz\" tabIcon=\"credit-card-outline\" responsive>\n      <app-add-test></app-add-test>\n      <!-- <app-add-test-question></app-add-test-question> -->\n    </nb-tab>\n    <nb-tab tabTitle=\"Video/E Library\" tabIcon=\"book-outline\" responsive>\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <nb-card class=\"inline-form-card\">\n            <nb-card-header>Pdf Library </nb-card-header>\n            <nb-card-body>\n              <nb-select\n                name=\"sdf\"\n                (selectedChange)=\"getFilteredSubjects()\"\n                [(ngModel)]=\"selectedSubCourseID\"\n                fullWidth\n                placeholder=\"Select Sub Course\"\n              >\n                <nb-option\n                  *ngFor=\"let subcourse of dataService.subCourses\"\n                  value=\"{{ subcourse.id }}\"\n                >\n                  {{ subcourse.name }}\n                </nb-option>\n              </nb-select>\n              <br />\n              <br />\n              <nb-select\n                name=\"sdf\"\n                (selectedChange)=\"getFilteredChapters()\"\n                [(ngModel)]=\"selectedSubjectID\"\n                fullWidth\n                placeholder=\"Select Subject\"\n              >\n                <nb-option\n                  *ngFor=\"let subject of filteredSubjects\"\n                  value=\"{{ subject.id }}\"\n                  >{{ subject.name }}\n                </nb-option>\n              </nb-select>\n              <br />\n              <br />\n              <nb-select\n                name=\"sdf\"\n                [(ngModel)]=\"selectedChapterID\"\n                fullWidth\n                placeholder=\"Select Chapter\"\n              >\n                <nb-option\n                  *ngFor=\"let chapter of filteredChapters\"\n                  value=\"{{ chapter.id }}\"\n                  >{{ chapter.name }}\n                </nb-option>\n              </nb-select>\n              <br />\n              <br />\n              <!-- <input fullWidth nbInput placeholder=\"Pdf Title\" name=\"pdfTitle\" [(ngModel)]=\"pdfTitle\">\n              <br>\n              <br> -->\n\n              <form>\n                <!-- <input id=\"imageFile\"  type=\"file\" name=\"imageFile\" (change)=\"postMethod($event.target.files)\"> -->\n                <input\n                  id=\"imageFile\"\n                  type=\"file\"\n                  name=\"imageFile\"\n                  (change)=\"pdfFileSelected($event.target.files)\"\n                />\n              </form>\n              <br />\n              <button\n                style=\"width: 100%\"\n                type=\"submit\"\n                (click)=\"uploadPdf()\"\n                nbButton\n                status=\"primary\"\n              >\n                Submit\n              </button>\n            </nb-card-body>\n          </nb-card>\n        </div>\n\n        <div class=\"col-md-6\">\n          <nb-card>\n            <nb-card-header>All PDF</nb-card-header>\n\n            <nb-card-body>\n              <ng2-smart-table\n                [settings]=\"pdfSettings\"\n                [source]=\"pdfs\"\n                (deleteConfirm)=\"deleteData($event)\"\n              >\n              </ng2-smart-table>\n            </nb-card-body>\n          </nb-card>\n        </div>\n      </div>\n      <div class=\"row\">\n        <app-important-questions></app-important-questions>\n      </div>\n      <div class=\"row\">\n        <app-progress></app-progress>\n      </div>\n      <div class=\"row\"><app-assignment></app-assignment></div>\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <nb-card class=\"inline-form-card\">\n            <nb-card-header>Video Courses </nb-card-header>\n            <nb-card-body>\n              <nb-select\n                name=\"sdf\"\n                (selectedChange)=\"getFilteredSubjects()\"\n                [(ngModel)]=\"selectedSubCourseID\"\n                fullWidth\n                placeholder=\"Select Sub Course\"\n              >\n                <nb-option\n                  *ngFor=\"let subcourse of dataService.subCourses\"\n                  value=\"{{ subcourse.id }}\"\n                >\n                  {{ subcourse.name }}\n                </nb-option>\n              </nb-select>\n              <br />\n              <br />\n              <nb-select\n                name=\"sdf\"\n                (selectedChange)=\"getFilteredChapters()\"\n                [(ngModel)]=\"selectedSubjectID\"\n                fullWidth\n                placeholder=\"Select Subject\"\n              >\n                <nb-option\n                  *ngFor=\"let subject of filteredSubjects\"\n                  value=\"{{ subject.id }}\"\n                  >{{ subject.name }}\n                </nb-option>\n              </nb-select>\n              <br />\n              <br />\n              <nb-select\n                name=\"sdf\"\n                [(ngModel)]=\"selectedChapterID\"\n                fullWidth\n                placeholder=\"Select Chapter\"\n              >\n                <nb-option\n                  *ngFor=\"let chapter of filteredChapters\"\n                  value=\"{{ chapter.id }}\"\n                  >{{ chapter.name }}\n                </nb-option>\n              </nb-select>\n              <br />\n              <br />\n              <input\n                type=\"text\"\n                [(ngModel)]=\"videoTitle\"\n                nbInput\n                fullWidth\n                placeholder=\"Video Title\"\n              />\n              <br />\n              <br />\n              <input\n                type=\"text\"\n                [(ngModel)]=\"youtubeLink\"\n                nbInput\n                fullWidth\n                placeholder=\"Youtube Link\"\n              />\n              <br />\n\n              <br />\n              <button\n                style=\"width: 100%\"\n                type=\"submit\"\n                (click)=\"addVideo()\"\n                nbButton\n                status=\"primary\"\n              >\n                Submit\n              </button>\n            </nb-card-body>\n          </nb-card>\n        </div>\n\n        <div class=\"col-md-6\">\n          <nb-card>\n            <nb-card-header>All Videos</nb-card-header>\n\n            <nb-card-body>\n              <ng2-smart-table\n                [settings]=\"videoSettings\"\n                [source]=\"videos\"\n                (deleteConfirm)=\"deleteData($event, 'video')\"\n              >\n              </ng2-smart-table>\n            </nb-card-body>\n          </nb-card>\n        </div>\n      </div>\n    </nb-tab>\n    <nb-tab tabTitle=\"Live Class\" tabIcon=\"video-outline\" responsive>\n      <!-- <p>List of <strong>orders</strong>.</p> -->\n      <app-live></app-live>\n    </nb-tab>\n    <nb-tab tabTitle=\"Students\" tabIcon=\"person-outline\" responsive>\n      <!-- <p>List of <strong>Students</strong>.</p> -->\n      <app-student></app-student>\n    </nb-tab>\n    <nb-tab tabTitle=\"Home \" tabIcon=\"home-outline\" responsive>\n      <app-free-videos></app-free-videos>\n      <app-slider></app-slider>\n      <app-free-notes></app-free-notes>\n      <!-- <p>List of <strong>Students</strong>.</p> -->\n\n      <!-- <div>\n\n\n        <div class=\"columns\">\n          <div class=\"column\">\n            <app-free-notes></app-free-notes>\n\n\n\n          </div>\n          <div class=\"column\">\n            <app-free-notes></app-free-notes>\n\n          </div>\n\n        </div>\n\n\n\n\n      </div> -->\n    </nb-tab>\n    <!-- <nb-tab tabTitle=\"Payments\" tabIcon=\"credit-card-outline\" responsive>\n\n      <iframe src=\"https://dashboard.razorpay.com/app/payments\" style=\"width: 100%; height:900px\"\n        frameborder=\"0\"></iframe>\n    </nb-tab> -->\n  </nb-tabset>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/video-upload/video-upload.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/video-upload/video-upload.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form>\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n</form>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-library-pdf/view-library-pdf.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-library-pdf/view-library-pdf.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<a href=\"{{ url }}\" target=\"_blank\">View Pdf</a>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-report-button-component/view-report-button-component.component.html":
/*!*******************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-report-button-component/view-report-button-component.component.html ***!
  \*******************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"text-align: center;\">\n\n  <a>\n    <nb-icon (click)=\"viewStudents()\" icon=\"eye-outline\" [options]=\"{ animation: { type: 'zoom' } }\"></nb-icon>\n  </a>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-video/view-video.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-video/view-video.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<a href=\"{{youtubeLink}}\" target=\"_blank\">View on Youtube</a>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/important-questions/important-questions.component.html":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/important-questions/important-questions.component.html ***!
  \**************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nb-card>\n  <nb-card-header>Important Questions </nb-card-header>\n  <nb-card-body>\n    <nb-select\n      name=\"sdf\"\n      (selectedChange)=\"getFilteredSubjects()\"\n      [(ngModel)]=\"selectedSubCourseID\"\n      fullWidth\n      placeholder=\"Select Sub Course\"\n    >\n      <nb-option\n        *ngFor=\"let subcourse of dataService.subCourses\"\n        value=\"{{ subcourse.id }}\"\n      >\n        {{ subcourse.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <nb-select\n      name=\"sdf\"\n      (selectedChange)=\"getFilteredChapters()\"\n      [(ngModel)]=\"selectedSubjectID\"\n      fullWidth\n      placeholder=\"Select Subject\"\n    >\n      <nb-option\n        *ngFor=\"let subject of filteredSubjects\"\n        value=\"{{ subject.id }}\"\n        >{{ subject.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <nb-select\n      name=\"sdf\"\n      [(ngModel)]=\"selectedChapterID\"\n      fullWidth\n      placeholder=\"Select Chapter\"\n    >\n      <nb-option\n        *ngFor=\"let chapter of filteredChapters\"\n        value=\"{{ chapter.id }}\"\n        >{{ chapter.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <!-- <input fullWidth nbInput placeholder=\"Pdf Title\" name=\"pdfTitle\" [(ngModel)]=\"pdfTitle\">\n              <br>\n              <br> -->\n\n    <form>\n      <!-- <input id=\"imageFile\"  type=\"file\" name=\"imageFile\" (change)=\"postMethod($event.target.files)\"> -->\n      <input\n        id=\"imageFile\"\n        type=\"file\"\n        name=\"imageFile\"\n        (change)=\"pdfFileSelected($event.target.files)\"\n      />\n    </form>\n    <br />\n    <button\n      style=\"width: 100%\"\n      type=\"submit\"\n      (click)=\"uploadPdf()\"\n      nbButton\n      status=\"primary\"\n    >\n      Submit\n    </button>\n  </nb-card-body>\n</nb-card>\n<div class=\"col-md-6\">\n  <nb-card>\n    <nb-card-header>All Important Questions</nb-card-header>\n\n    <nb-card-body>\n      <ng2-smart-table\n        [settings]=\"pdfSettings\"\n        [source]=\"pdfs\"\n        (deleteConfirm)=\"deleteData($event)\"\n      >\n      </ng2-smart-table>\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/masters/free-notes/free-notes.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/masters/free-notes/free-notes.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-6\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add Home notes (.pdf)</nb-card-header>\n      <nb-card-body>\n        <!-- <form class=\"form-inline\">\n          <input fullWidth type=\"text\" name=\"city\" [(ngModel)]=\"city\" nbInput placeholder=\"City Name\" />\n\n\n          <br>\n          <br>\n\n          <button style=\"width:100%\" type=\"submit\" (click)=\"submitCity()\" nbButton status=\"primary\">Submit</button>\n        </form> -->\n\n        <form>\n          <input\n            id=\"imageFile\"\n            type=\"file\"\n            name=\"imageFile\"\n            (change)=\"postMethod($event.target.files)\"\n          />\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n\n  <div class=\"col-md-6\">\n    <nb-card>\n      <nb-card-header>All Home Notes</nb-card-header>\n\n      <nb-card-body>\n        <ng2-smart-table\n          [settings]=\"settings\"\n          [source]=\"data\"\n          (deleteConfirm)=\"onDeleteConfirm($event)\"\n        >\n        </ng2-smart-table>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/masters/free-videos/free-videos.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/masters/free-videos/free-videos.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <div class=\"row\">\n  <div class=\"col-md-6\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Home Video </nb-card-header>\n      <nb-card-body>\n        <input fullWidth nbInput placeholder=\"Video Title\" name=\"pdfTitle\" [(ngModel)]=\"name\">\n        <br>\n        <br>\n        <input fullWidth nbInput placeholder=\"Video Link\" name=\"pdfTitle\" [(ngModel)]=\"youtubeLink\">\n        <br>\n        <br>\n        <button style=\"width: 100%;\" type=\"submit\" (click)=\"postVideo()\" nbButton status=\"primary\">\n          Submit\n        </button>\n      </nb-card-body>\n    </nb-card>\n  </div>\n  <div class=\"col-md-6\">\n    <nb-card>\n      <nb-card-header>All Home Video</nb-card-header>\n\n      <nb-card-body>\n        <ng2-smart-table [settings]=\"videoSettings\" [source]=\"data\" (deleteConfirm)=\"deleteVideo($event)\">\n        </ng2-smart-table>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div> -->\n\n<nb-card class=\"inline-form-card\">\n  <nb-card-header>Home Video </nb-card-header>\n  <nb-card-body>\n    <input\n      fullWidth\n      nbInput\n      placeholder=\"Video Title\"\n      name=\"pdfTitle\"\n      [(ngModel)]=\"name\"\n    />\n    <br />\n    <br />\n    <input\n      fullWidth\n      nbInput\n      placeholder=\"Video Link\"\n      name=\"pdfTitle\"\n      [(ngModel)]=\"youtubeLink\"\n    />\n    <br />\n    <br />\n    <button\n      style=\"width: 100%\"\n      type=\"submit\"\n      (click)=\"postVideo()\"\n      nbButton\n      status=\"primary\"\n    >\n      Submit\n    </button>\n  </nb-card-body>\n</nb-card>\n<nb-card>\n  <nb-card-header>All Home Video</nb-card-header>\n\n  <nb-card-body>\n    <ng2-smart-table\n      [settings]=\"videoSettings\"\n      [source]=\"data\"\n      (deleteConfirm)=\"deleteVideo($event)\"\n    >\n    </ng2-smart-table>\n  </nb-card-body>\n</nb-card>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/masters/masters.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/masters/masters.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\n  <nb-tabset fullWidth>\n    <nb-tab tabTitle=\"Course / Sub Course\" tabIcon=\"book-outline\" responsive>\n\n\n      <div class=\"columns\">\n        <div class=\"column\">\n\n\n          <app-course></app-course>\n        </div>\n        <div class=\"column\">\n          <app-sub-course></app-sub-course>\n\n        </div>\n\n      </div>\n\n    </nb-tab>\n    <nb-tab tabTitle=\"Subject\" tabIcon=\"video-outline\" responsive>\n\n      <app-subject></app-subject>\n    </nb-tab>\n    <nb-tab tabTitle=\"Chapter\" tabIcon=\"person-outline\" responsive>\n      <app-add-chapter></app-add-chapter>\n\n    </nb-tab>\n  </nb-tabset>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/city/city.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/city/city.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-12\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add City</nb-card-header>\n      <nb-card-body>\n        <form class=\"form-inline\">\n          <input fullWidth type=\"text\" name=\"city\" [(ngModel)]=\"city\" nbInput placeholder=\"City Name\" />\n\n\n          <br>\n          <br>\n\n          <button style=\"width:100%\" type=\"submit\" (click)=\"submitCity()\" nbButton status=\"primary\">Submit</button>\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n\n<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Cities</nb-card-header>\n\n    <nb-card-body>\n\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"cities\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/course/course.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/course/course.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-12\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add Course</nb-card-header>\n      <nb-card-body>\n        <form class=\"form-inline\">\n          <input fullWidth type=\"text\" name=\"course\" [(ngModel)]=\"course\" nbInput placeholder=\"Course Name\" />\n          <br>\n          <br>\n\n          <button style=\"width:100%\" type=\"submit\" (click)=\"submitCourse()\" nbButton status=\"primary\">Submit</button>\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n\n<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Course</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"this.dataService.courses\"\n        (deleteConfirm)=\"onDeleteConfirm($event)\">\n        <!-- <ng2-smart-table [settings]=\"settings\" [source]=\"data\" (deleteConfirm)=\"onDeleteConfirm($event)\"> -->\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/create-test/create-test.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/create-test/create-test.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"columns\">\n  <div class=\"column\">\n\n    <app-city></app-city>\n  </div>\n  <div class=\"column\">\n    <app-center-master></app-center-master>\n\n  </div>\n\n</div>\n<div class=\"columns\">\n\n  <div class=\"column\">\n    <app-course></app-course>\n\n\n  </div>\n  <div class=\"column\">\n\n    <app-subject></app-subject>\n\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/dashboard/dashboard.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/dashboard/dashboard.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nb-layout>\n  <nb-layout-header fixed style=\"text-align: center\">\n    <!-- <img src=\"assets/images/logo.png\" style=\"max-width: 50px;\" alt=\"\"> -->\n    <div>Dashboad</div>\n  </nb-layout-header>\n\n  <nb-sidebar state=\"compacted\" style=\"background-color: #fafafa\">\n    <nb-menu [items]=\"items\"> </nb-menu>\n  </nb-sidebar>\n\n  <nb-layout-column class=\"colored-column-success\">\n    <!-- <app-city></app-city> -->\n    <router-outlet></router-outlet>\n  </nb-layout-column>\n</nb-layout>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/home/home.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/home/home.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>home works!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div\n  class=\"login-page\"\n  style=\"background-color: #304972; height: 100%; width: 100%\"\n>\n  <div class=\"form\">\n    <h3 style=\"font-size: 2em\">\n      <!-- <img src=\"assets/images/logo.png\" style=\"max-width: 200px;\" alt=\"\"> -->\n      <div>Login</div>\n    </h3>\n    <br />\n    <form class=\"login-form\">\n      <!-- <input type=\"text\" placeholder=\"username\" /> -->\n      <input\n        type=\"password\"\n        name=\"password\"\n        placeholder=\"password\"\n        [(ngModel)]=\"this.dataService.password\"\n      />\n      <button (click)=\"submit()\" name=\"password\">Verify</button>\n    </form>\n  </div>\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n  <br />\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/report/report.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/report/report.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Test</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"tests\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n<div class=\"col-md-12\" *ngIf=\"students.length!=0\">\n  <nb-card>\n    <nb-card-header>All Students</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"studentSettings\" [source]=\"students\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/result/result.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/result/result.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Test</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"tests\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n<div class=\"col-md-12\" *ngIf=\"students.length!=0\">\n  <nb-card>\n    <nb-card-header>All Students</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"studentSettings\" [source]=\"students\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/slider/slider.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/slider/slider.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-6\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add Slider (.png)</nb-card-header>\n      <nb-card-body>\n        <!-- <form class=\"form-inline\">\n          <input fullWidth type=\"text\" name=\"city\" [(ngModel)]=\"city\" nbInput placeholder=\"City Name\" />\n\n\n          <br>\n          <br>\n\n          <button style=\"width:100%\" type=\"submit\" (click)=\"submitCity()\" nbButton status=\"primary\">Submit</button>\n        </form> -->\n\n        <form>\n          <input\n            id=\"imageFile\"\n            type=\"file\"\n            name=\"imageFile\"\n            (change)=\"postMethod($event.target.files)\"\n          />\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n\n  <div class=\"col-md-6\">\n    <nb-card>\n      <nb-card-header>All Sliders</nb-card-header>\n\n      <nb-card-body>\n        <ng2-smart-table\n          [settings]=\"settings\"\n          [source]=\"sliders\"\n          (deleteConfirm)=\"onDeleteConfirm($event)\"\n        >\n        </ng2-smart-table>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/sub-course/sub-course.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/sub-course/sub-course.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-12\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add Sub Course</nb-card-header>\n      <nb-card-body>\n        <form class=\"form-inline\">\n          <nb-select name='sdf' [(ngModel)]=\"selectedCourseID\" fullWidth placeholder=\"Select Course\">\n            <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n            <nb-option *ngFor=\"let course of dataService.courses\" value=\"{{course.id}}\">{{course.name}}</nb-option>\n\n          </nb-select>\n          <br>\n          <br>\n\n          <input fullWidth type=\"text\" name=\"course\" [(ngModel)]=\"subCourse\" nbInput placeholder=\"Sub Course Name\" />\n          <br>\n          <br>\n\n          <button style=\"width:100%\" type=\"submit\" (click)=\"submitSubCourse()\" nbButton status=\"primary\">Submit</button>\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n\n<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Sub Course</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"this.dataService.subCourses\"\n        (deleteConfirm)=\"onDeleteConfirm($event)\">\n        <!-- <ng2-smart-table [settings]=\"settings\" [source]=\"data\" (deleteConfirm)=\"onDeleteConfirm($event)\"> -->\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/subject/subject.component.html":
/*!********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/subject/subject.component.html ***!
  \********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div class=\"col-md-12\">\n    <nb-card class=\"inline-form-card\">\n      <nb-card-header>Add Subject</nb-card-header>\n      <nb-card-body>\n        <form class=\"form-inline\">\n\n          <div class=\"columns\">\n            <div class=\"column \">\n              <nb-select fullWidth name=\"asdf\" placeholder=\"Select Sub Course\" [(ngModel)]=\"selectedSubCourseID\">\n                <!-- <nb-select placeholder=\"Select Course\" [(selected)]=\"selectedCourse\"> -->\n                <nb-option *ngFor=\"let subcourse of dataService.subCourses\" value=\"{{subcourse.id}}\">{{subcourse.name}}\n                </nb-option>\n\n              </nb-select>\n              <br>\n              <br>\n              <input fullWidth name='asdfsdf' type=\"text\" nbInput placeholder=\"Subject Name\" [(ngModel)]=\"subject\" />\n              <!-- <br>\n              <br>\n              <input fullWidth name='asdfsdf' type=\"number\" nbInput placeholder=\"Subject Amount\" [(ngModel)]=\"amount\" /> -->\n              <div style=\"text-align: center;\">\n\n                <br>\n\n                <!-- First Installment :\n                <input name='asdfsdf' type=\"date\" nbInput placeholder=\"1st Installment Date\"\n                  [(ngModel)]=\"firstInstallmentDate\" />\n                &nbsp;\n                <input name='asdfsdf' type=\"number\" nbInput placeholder=\"Amount\" [(ngModel)]=\"firstInstallmentAmount\" />\n                <br>\n                <br>\n                Second Installment :\n                <input name='asdfsdf' type=\"date\" nbInput placeholder=\"2nd Installment Date\"\n                  [(ngModel)]=\"secondInstallmentDate\" />\n                &nbsp;\n                <input name='asdfsdf' type=\"number\" nbInput placeholder=\"Amount\"\n                  [(ngModel)]=\"secondInstallmentAmount\" />\n                <br>\n                <br> -->\n                Full Installment :\n                <input name='asdfsdf' type=\"date\" nbInput placeholder=\"Full Installment Date\"\n                  [(ngModel)]=\"fullInstallmentDate\" />\n                &nbsp;\n                <input name='asdfsdf' type=\"number\" nbInput placeholder=\"Amount\" [(ngModel)]=\"fullInstallmentAmount\" />\n              </div>\n            </div>\n            <!-- <div class=\"column\"> <input fullWidth type=\"text\" nbInput placeholder=\"Subject Name\" />\n            </div> -->\n          </div>\n\n\n\n          <button (click)=\"submitSubject()\" style=\"width: 100%;\" type=\"submit\" nbButton status=\"primary\">Submit</button>\n        </form>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Subjects</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"dataService.subjects\" (editConfirm)=\"onEdit($event)\"\n        (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/test-report/test-report.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/test-report/test-report.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"background-color: white; width: 100%; height: 100%\">\n  <br />\n  <br />\n  <br />\n\n  <table style=\"background-color: aliceblue; margin: auto; padding: 2rem\">\n    <br />\n    <tr>\n      <th style=\"width: 10rem; text-align: center\">Rank</th>\n      <th style=\"width: 20rem; text-align: left\">Name</th>\n      <th style=\"width: 10rem; text-align: center\">Marks</th>\n    </tr>\n    <tr *ngFor=\"let student of finalList; let i = index\">\n      <td style=\"width: 10rem; text-align: center\">{{ i + 1 }}.</td>\n      <td style=\"width: 20rem; text-align: left\">{{ student.student.name }}</td>\n      <td style=\"width: 10rem; text-align: center\">\n        {{ student.marks | number }}\n      </td>\n    </tr>\n    <br />\n  </table>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/video/video.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/video/video.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"col-md-12\">\n  <nb-card>\n    <nb-card-header>All Test</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"settings\" [source]=\"tests\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n<div class=\"col-md-12\" *ngIf=\"showQuestions\">\n\n  <nb-card>\n    <nb-card-header>All Questions</nb-card-header>\n\n    <nb-card-body>\n\n      <ng2-smart-table [settings]=\"questionSettings\" [source]=\"questions\" (deleteConfirm)=\"onDeleteConfirm($event)\">\n      </ng2-smart-table>\n\n\n\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/progress/progress.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/progress/progress.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nb-card>\n  <nb-card-header>Progress Pdf's </nb-card-header>\n  <nb-card-body>\n    <nb-select\n      name=\"sdf\"\n      (selectedChange)=\"getFilteredSubjects()\"\n      [(ngModel)]=\"selectedSubCourseID\"\n      fullWidth\n      placeholder=\"Select Sub Course\"\n    >\n      <nb-option\n        *ngFor=\"let subcourse of dataService.subCourses\"\n        value=\"{{ subcourse.id }}\"\n      >\n        {{ subcourse.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <nb-select\n      name=\"sdf\"\n      (selectedChange)=\"getFilteredChapters()\"\n      [(ngModel)]=\"selectedSubjectID\"\n      fullWidth\n      placeholder=\"Select Subject\"\n    >\n      <nb-option\n        *ngFor=\"let subject of filteredSubjects\"\n        value=\"{{ subject.id }}\"\n        >{{ subject.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <nb-select\n      name=\"sdf\"\n      [(ngModel)]=\"selectedChapterID\"\n      fullWidth\n      placeholder=\"Select Chapter\"\n    >\n      <nb-option\n        *ngFor=\"let chapter of filteredChapters\"\n        value=\"{{ chapter.id }}\"\n        >{{ chapter.name }}\n      </nb-option>\n    </nb-select>\n    <br />\n    <br />\n    <!-- <input fullWidth nbInput placeholder=\"Pdf Title\" name=\"pdfTitle\" [(ngModel)]=\"pdfTitle\">\n              <br>\n              <br> -->\n\n    <form>\n      <!-- <input id=\"imageFile\"  type=\"file\" name=\"imageFile\" (change)=\"postMethod($event.target.files)\"> -->\n      <input\n        id=\"imageFile\"\n        type=\"file\"\n        name=\"imageFile\"\n        (change)=\"pdfFileSelected($event.target.files)\"\n      />\n    </form>\n    <br />\n    <button\n      style=\"width: 100%\"\n      type=\"submit\"\n      (click)=\"uploadPdf()\"\n      nbButton\n      status=\"primary\"\n    >\n      Submit\n    </button>\n  </nb-card-body>\n</nb-card>\n<div class=\"col-md-6\">\n  <nb-card>\n    <nb-card-header>All Progress Pdf's</nb-card-header>\n\n    <nb-card-body>\n      <ng2-smart-table\n        [settings]=\"pdfSettings\"\n        [source]=\"pdfs\"\n        (deleteConfirm)=\"deleteData($event)\"\n      >\n      </ng2-smart-table>\n    </nb-card-body>\n  </nb-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/test/add-test-question/add-test-question.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/test/add-test-question/add-test-question.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n\n  <div>\n    <nb-card>\n      <nb-card-header>Add Test Question</nb-card-header>\n\n      <nb-card-body>\n        <nb-select name=\"sdf\" (selectedChange)=\"getFilteredSubjects()\" [(ngModel)]=\"selectedSubCourseID\" fullWidth\n        placeholder=\"Select Sub Course\">\n        <nb-option *ngFor=\"let subcourse of dataService.subCourses\" value=\"{{ subcourse.id }}\">\n          {{ subcourse.name }}\n        </nb-option>\n      </nb-select>\n      <br />\n      <br />\n      <nb-select name=\"sdf\" (selectedChange)=\"getFilteredChapters()\" [(ngModel)]=\"selectedSubjectID\" fullWidth\n        placeholder=\"Select Subject\">\n        <nb-option *ngFor=\"let subject of filteredSubjects\" value=\"{{ subject.id }}\">{{ subject.name }}\n        </nb-option>\n      </nb-select>\n      <br />\n      <br />\n      <nb-select name=\"sdf\" (selectedChange)=\"getQuizChapterQuestion()\" [(ngModel)]=\"selectedChapterID\" fullWidth placeholder=\"Select Chapter\">\n        <nb-option *ngFor=\"let chapter of filteredChapters\" value=\"{{ chapter.id }}\">{{ chapter.name }}\n        </nb-option>\n      </nb-select>\n      <br />\n      <br />\n        <input type=\"text\" [(ngModel)]=\"textQuestion\" nbInput fullWidth status=\"basic\" placeholder=\"Text Question\">\n\n      <br />\n      <br />\n        <input type=\"text\" [(ngModel)]=\"firstOption\" nbInput fullWidth status=\"basic\" placeholder=\"First Option\">\n\n      <br />\n      <br />\n        <input type=\"text\" [(ngModel)]=\"secondOption\" nbInput fullWidth status=\"basic\" placeholder=\"Second Option\">\n\n      <br />\n      <br />\n        <input type=\"text\" [(ngModel)]=\"thirdOption\" nbInput fullWidth status=\"basic\" placeholder=\"Third Option\">\n\n      <br />\n      <br />\n        <input type=\"text\" [(ngModel)]=\"fourthOption\" nbInput fullWidth status=\"basic\" placeholder=\"Fourth Option\">\n\n      <br />\n      <br />\n        <input type=\"number\" [(ngModel)]=\"correctOption\" nbInput fullWidth status=\"basic\" placeholder=\"Correct Option\">\n\n      <br />\n      <br />\n      <!-- <input fullWidth nbInput placeholder=\"Pdf Title\" name=\"pdfTitle\" [(ngModel)]=\"pdfTitle\">\n      <br>\n      <br> -->\n\n      <form>\n        <!-- <input id=\"imageFile\"  type=\"file\" name=\"imageFile\" (change)=\"postMethod($event.target.files)\"> -->\n        <input id=\"imageFile\" type=\"file\" name=\"imageFile\" (change)=\"quizImageSelected($event.target.files)\" />\n      </form>\n      <br />\n\n      <button style=\"width: 100%;\" type=\"submit\" (click)=\"submitQuestion()\" nbButton status=\"primary\">\n        Submit\n      </button>\n      </nb-card-body>\n\n      <br>\n      <br>\n      <div style=\"padding:8px ;\">\n      <ng2-smart-table [settings]=\"settings\" [source]=\"quizChapterQuestions\" (deleteConfirm)=\"deleteQuestion($event)\">\n      </ng2-smart-table>\n    </div>\n    </nb-card>\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/test/add-test/add-test.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/test/add-test/add-test.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n  <div>\n    <nb-card>\n      <nb-card-header>All Test </nb-card-header>\n\n      <nb-card-body>\n        <div style=\"padding: 8px\">\n          <ng2-smart-table\n            [settings]=\"settings\"\n            [source]=\"tests\"\n            (deleteConfirm)=\"deleteTest($event)\"\n          >\n          </ng2-smart-table>\n        </div>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n<div class=\"row\">\n  <div>\n    <nb-card>\n      <nb-card-header>Add Test</nb-card-header>\n\n      <nb-card-body>\n        <nb-select\n          style=\"margin-top: 1rem\"\n          name=\"sdf\"\n          (selectedChange)=\"getFilteredSubjects()\"\n          [(ngModel)]=\"selectedSubCourseID\"\n          placeholder=\"Select Sub Course\"\n        >\n          <nb-option\n            *ngFor=\"let subcourse of dataService.subCourses\"\n            value=\"{{ subcourse.id }}\"\n          >\n            {{ subcourse.name }}\n          </nb-option>\n        </nb-select>\n        &nbsp;\n        <nb-select\n          style=\"margin-top: 1rem\"\n          name=\"sdf\"\n          [(ngModel)]=\"selectedSubjectID\"\n          placeholder=\"Select Subject\"\n        >\n          <nb-option\n            *ngFor=\"let subject of filteredSubjects\"\n            value=\"{{ subject.id }}\"\n          >\n            {{ subject.name }}\n          </nb-option>\n        </nb-select>\n        &nbsp;\n        <input\n          style=\"margin-top: 1rem\"\n          type=\"text\"\n          [(ngModel)]=\"title\"\n          nbInput\n          status=\"basic\"\n          placeholder=\"Test Name\"\n        />\n\n        &nbsp;\n        <input\n          style=\"margin-top: 1rem\"\n          type=\"datetime-local\"\n          [(ngModel)]=\"startDateTime\"\n          nbInput\n          status=\"basic\"\n          placeholder=\"Start Date Time\"\n        />\n\n        &nbsp;\n        <input\n          style=\"margin-top: 1rem\"\n          type=\"datetime-local\"\n          [(ngModel)]=\"endDateTime\"\n          nbInput\n          status=\"basic\"\n          placeholder=\"End Date Time\"\n        />\n\n        &nbsp;\n        <input\n          style=\"margin-top: 1rem\"\n          type=\"number\"\n          [(ngModel)]=\"positiveMarks\"\n          nbInput\n          status=\"basic\"\n          placeholder=\"Positive Marks\"\n        />\n        &nbsp;\n        <input\n          style=\"margin-top: 1rem\"\n          type=\"number\"\n          [(ngModel)]=\"minutes\"\n          nbInput\n          status=\"basic\"\n          placeholder=\"Time in Minues\"\n        />\n        &nbsp;\n        <input\n          style=\"margin-top: 1rem\"\n          type=\"number\"\n          [(ngModel)]=\"negativeMarks\"\n          nbInput\n          status=\"basic\"\n          placeholder=\"Negative Marks\"\n        />\n\n        <br />\n        <br />\n\n        <form>\n          <b style=\"font-weight: bold\">Upload Question Paper ( PDF )</b>\n          &nbsp; &nbsp;\n          <input\n            accept=\"application/pdf\"\n            id=\"imageFile\"\n            type=\"file\"\n            name=\"imageFile\"\n            (change)=\"testPaperSelected($event.target.files)\"\n          />\n        </form>\n\n        <br />\n        <form>\n          <b style=\"font-weight: bold\"> Upload Answer Paper ( PDF )</b>&nbsp;\n          &nbsp;\n          <input\n            accept=\"application/pdf\"\n            id=\"imaasfdgeFile\"\n            type=\"file\"\n            name=\"asdf\"\n            (change)=\"answerPaperSelected($event.target.files)\"\n          />\n        </form>\n        <br />\n        <input\n          type=\"number\"\n          [(ngModel)]=\"numberOfQuestions\"\n          nbInput\n          status=\"basic\"\n          placeholder=\"Number Of Questions\"\n          max=\"100\"\n        />\n        &nbsp;\n\n        <button\n          type=\"submit\"\n          (click)=\"addQuestions()\"\n          nbButton\n          status=\"primary\"\n        >\n          Add Question\n        </button>\n\n        <br />\n        <br />\n\n        <div *ngFor=\"let question of questions; let i = index\">\n          Question {{ i + 1 }}. &nbsp;\n          <button\n            style=\"margin-right: 1rem\"\n            *ngFor=\"let answer of [1, 2, 3, 4]; let j = index\"\n            type=\"submit\"\n            (click)=\"answerSelected(i, j)\"\n            nbButton\n            [status]=\"question[j] == j + 1 ? 'primary' : ''\"\n          >\n            Option {{ j + 1 }}\n          </button>\n          &nbsp;\n\n          <input\n            [(ngModel)]=\"questionsPositiveMarks[i]\"\n            type=\"number\"\n            nbInput\n            status=\"basic\"\n            placeholder=\"Positive Marks\"\n            max=\"100\"\n          />\n          &nbsp;\n          <input\n            [(ngModel)]=\"questionsNegativeMarks[i]\"\n            type=\"number\"\n            nbInput\n            status=\"basic\"\n            placeholder=\"Negative Marks\"\n            max=\"100\"\n          />\n          &nbsp;\n\n          <br />\n          <br />\n        </div>\n\n        <button\n          style=\"width: 15rem\"\n          type=\"submit\"\n          (click)=\"createTest()\"\n          nbButton\n          status=\"primary\"\n        >\n          Submit\n        </button>\n      </nb-card-body>\n    </nb-card>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _pages_dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./pages/dashboard/dashboard.component */ "./src/app/pages/dashboard/dashboard.component.ts");
/* harmony import */ var _nebular_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @nebular/theme */ "./node_modules/@nebular/theme/fesm2015/index.js");
/* harmony import */ var _pages_login_login_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./pages/login/login.component */ "./src/app/pages/login/login.component.ts");
/* harmony import */ var ng2_smart_table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ng2-smart-table */ "./node_modules/ng2-smart-table/fesm2015/ng2-smart-table.js");
/* harmony import */ var _masters_masters_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./masters/masters.component */ "./src/app/masters/masters.component.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _components_book_test_master_book_test_master_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/book-test-master/book-test-master.component */ "./src/app/components/book-test-master/book-test-master.component.ts");
/* harmony import */ var _pages_report_report_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pages/report/report.component */ "./src/app/pages/report/report.component.ts");
/* harmony import */ var _pages_result_result_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./pages/result/result.component */ "./src/app/pages/result/result.component.ts");
/* harmony import */ var _pages_video_video_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./pages/video/video.component */ "./src/app/pages/video/video.component.ts");
/* harmony import */ var _pages_create_test_create_test_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./pages/create-test/create-test.component */ "./src/app/pages/create-test/create-test.component.ts");
/* harmony import */ var _components_uploads_uploads_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/uploads/uploads.component */ "./src/app/components/uploads/uploads.component.ts");
/* harmony import */ var _pages_test_report_test_report_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./pages/test-report/test-report.component */ "./src/app/pages/test-report/test-report.component.ts");
















const routes = [
    {
        path: "",
        component: _pages_login_login_component__WEBPACK_IMPORTED_MODULE_5__["LoginComponent"],
    },
    {
        path: "testreport/:testId",
        component: _pages_test_report_test_report_component__WEBPACK_IMPORTED_MODULE_15__["TestReportComponent"],
    },
    {
        path: "dashboard",
        // canActivate: [AuthGuard],
        component: _pages_dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_3__["DashboardComponent"],
        children: [
            {
                path: "masters",
                component: _masters_masters_component__WEBPACK_IMPORTED_MODULE_7__["MastersComponent"],
            },
            // {
            //   path: "subject",
            //   component: SubjectMasterComponent
            // },
            {
                path: "masters",
                // path: "testPrepare",
                component: _pages_create_test_create_test_component__WEBPACK_IMPORTED_MODULE_13__["CreateTestComponent"],
            },
            {
                path: "book",
                component: _components_book_test_master_book_test_master_component__WEBPACK_IMPORTED_MODULE_9__["BookTestMasterComponent"],
            },
            // {
            //   path: "course",
            //   component: CourseComponent
            // },
            // {
            //   path: "subject",
            //   component: SubjectComponent
            // },
            {
                path: "report",
                component: _pages_report_report_component__WEBPACK_IMPORTED_MODULE_10__["ReportComponent"],
            },
            // {
            //   path: "slider",
            //   component: SliderComponent,
            // },
            {
                path: "uploads",
                component: _components_uploads_uploads_component__WEBPACK_IMPORTED_MODULE_14__["UploadsComponent"],
            },
            {
                path: "result",
                component: _pages_result_result_component__WEBPACK_IMPORTED_MODULE_11__["ResultComponent"],
            },
            // {
            //   path: 'video',
            //   component: VideoComponent
            // },
            {
                path: "solution",
                component: _pages_video_video_component__WEBPACK_IMPORTED_MODULE_12__["VideoComponent"],
            },
            {
                path: "**",
                redirectTo: "uploads",
            },
        ],
    },
    {
        path: "**",
        redirectTo: "/",
    },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_forms__WEBPACK_IMPORTED_MODULE_8__["FormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes),
            _nebular_theme__WEBPACK_IMPORTED_MODULE_4__["NbSidebarModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_4__["NbMenuModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_4__["NbCardModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_4__["NbSpinnerModule"],
            // NbTabsetModule,
            _nebular_theme__WEBPACK_IMPORTED_MODULE_4__["NbCheckboxModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_4__["NbInputModule"],
            ng2_smart_table__WEBPACK_IMPORTED_MODULE_6__["Ng2SmartTableModule"],
        ],
        declarations: [],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]],
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



let AppComponent = class AppComponent {
    constructor(http) {
        this.http = http;
        this.title = "testwaleAdmin";
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-root",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ng2_smart_table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng2-smart-table */ "./node_modules/ng2-smart-table/fesm2015/ng2-smart-table.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _nebular_theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @nebular/theme */ "./node_modules/@nebular/theme/fesm2015/index.js");
/* harmony import */ var _nebular_eva_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @nebular/eva-icons */ "./node_modules/@nebular/eva-icons/fesm2015/index.js");
/* harmony import */ var _pages_dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./pages/dashboard/dashboard.component */ "./src/app/pages/dashboard/dashboard.component.ts");
/* harmony import */ var _pages_city_city_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pages/city/city.component */ "./src/app/pages/city/city.component.ts");
/* harmony import */ var _pages_home_home_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./pages/home/home.component */ "./src/app/pages/home/home.component.ts");
/* harmony import */ var _pages_login_login_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./pages/login/login.component */ "./src/app/pages/login/login.component.ts");
/* harmony import */ var _pages_course_course_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./pages/course/course.component */ "./src/app/pages/course/course.component.ts");
/* harmony import */ var _pages_subject_subject_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./pages/subject/subject.component */ "./src/app/pages/subject/subject.component.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _masters_masters_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./masters/masters.component */ "./src/app/masters/masters.component.ts");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _components_city_master_city_master_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/city-master/city-master.component */ "./src/app/components/city-master/city-master.component.ts");
/* harmony import */ var _components_subject_master_subject_master_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/subject-master/subject-master.component */ "./src/app/components/subject-master/subject-master.component.ts");
/* harmony import */ var _components_center_master_center_master_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/center-master/center-master.component */ "./src/app/components/center-master/center-master.component.ts");
/* harmony import */ var _components_book_test_book_test_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/book-test/book-test.component */ "./src/app/components/book-test/book-test.component.ts");
/* harmony import */ var _components_book_test_master_book_test_master_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/book-test-master/book-test-master.component */ "./src/app/components/book-test-master/book-test-master.component.ts");
/* harmony import */ var _components_slot_master_slot_master_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./components/slot-master/slot-master.component */ "./src/app/components/slot-master/slot-master.component.ts");
/* harmony import */ var _pages_report_report_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./pages/report/report.component */ "./src/app/pages/report/report.component.ts");
/* harmony import */ var _components_upload_report_button_upload_report_button_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/upload-report-button/upload-report-button.component */ "./src/app/components/upload-report-button/upload-report-button.component.ts");
/* harmony import */ var _components_view_report_button_component_view_report_button_component_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/view-report-button-component/view-report-button-component.component */ "./src/app/components/view-report-button-component/view-report-button-component.component.ts");
/* harmony import */ var _components_download_report_button_component_download_report_button_component_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/download-report-button-component/download-report-button-component.component */ "./src/app/components/download-report-button-component/download-report-button-component.component.ts");
/* harmony import */ var _pages_slider_slider_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./pages/slider/slider.component */ "./src/app/pages/slider/slider.component.ts");
/* harmony import */ var _components_slider_image_slider_image_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/slider-image/slider-image.component */ "./src/app/components/slider-image/slider-image.component.ts");
/* harmony import */ var _pages_result_result_component__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./pages/result/result.component */ "./src/app/pages/result/result.component.ts");
/* harmony import */ var _components_result_upload_result_upload_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/result-upload/result-upload.component */ "./src/app/components/result-upload/result-upload.component.ts");
/* harmony import */ var _pages_video_video_component__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./pages/video/video.component */ "./src/app/pages/video/video.component.ts");
/* harmony import */ var _components_video_upload_video_upload_component__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./components/video-upload/video-upload.component */ "./src/app/components/video-upload/video-upload.component.ts");
/* harmony import */ var src_app_components_pdf_solution_upload_pdf_solution_upload_component__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! src/app/components/pdf-solution-upload/pdf-solution-upload.component */ "./src/app/components/pdf-solution-upload/pdf-solution-upload.component.ts");
/* harmony import */ var _components_get_questions_get_questions_component__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./components/get-questions/get-questions.component */ "./src/app/components/get-questions/get-questions.component.ts");
/* harmony import */ var _components_question_editor_question_editor_component__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./components/question-editor/question-editor.component */ "./src/app/components/question-editor/question-editor.component.ts");
/* harmony import */ var _components_question_number_question_number_component__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./components/question-number/question-number.component */ "./src/app/components/question-number/question-number.component.ts");
/* harmony import */ var _pages_create_test_create_test_component__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./pages/create-test/create-test.component */ "./src/app/pages/create-test/create-test.component.ts");
/* harmony import */ var _components_upload_solution_csv_upload_solution_csv_component__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./components/upload-solution-csv/upload-solution-csv.component */ "./src/app/components/upload-solution-csv/upload-solution-csv.component.ts");
/* harmony import */ var _components_get_solutions_get_solutions_component__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./components/get-solutions/get-solutions.component */ "./src/app/components/get-solutions/get-solutions.component.ts");
/* harmony import */ var _components_question_upload_video_question_upload_video_component__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./components/question-upload-video/question-upload-video.component */ "./src/app/components/question-upload-video/question-upload-video.component.ts");
/* harmony import */ var _components_question_update_number_question_update_number_component__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./components/question-update-number/question-update-number.component */ "./src/app/components/question-update-number/question-update-number.component.ts");
/* harmony import */ var _components_slider_thumbnail_slider_thumbnail_component__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./components/slider-thumbnail/slider-thumbnail.component */ "./src/app/components/slider-thumbnail/slider-thumbnail.component.ts");
/* harmony import */ var _components_slider_video_slider_video_component__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./components/slider-video/slider-video.component */ "./src/app/components/slider-video/slider-video.component.ts");
/* harmony import */ var _components_slider_image_testimonial_slider_image_testimonial_component__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./components/slider-image-testimonial/slider-image-testimonial.component */ "./src/app/components/slider-image-testimonial/slider-image-testimonial.component.ts");
/* harmony import */ var _components_revision_note_component_revision_note_component_component__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./components/revision-note-component/revision-note-component.component */ "./src/app/components/revision-note-component/revision-note-component.component.ts");
/* harmony import */ var _pages_sub_course_sub_course_component__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./pages/sub-course/sub-course.component */ "./src/app/pages/sub-course/sub-course.component.ts");
/* harmony import */ var _components_add_chapter_add_chapter_component__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./components/add-chapter/add-chapter.component */ "./src/app/components/add-chapter/add-chapter.component.ts");
/* harmony import */ var _components_uploads_uploads_component__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./components/uploads/uploads.component */ "./src/app/components/uploads/uploads.component.ts");
/* harmony import */ var _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./components/view-library-pdf/view-library-pdf.component */ "./src/app/components/view-library-pdf/view-library-pdf.component.ts");
/* harmony import */ var _components_view_video_view_video_component__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./components/view-video/view-video.component */ "./src/app/components/view-video/view-video.component.ts");
/* harmony import */ var _components_live_live_component__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./components/live/live.component */ "./src/app/components/live/live.component.ts");
/* harmony import */ var _components_student_student_component__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./components/student/student.component */ "./src/app/components/student/student.component.ts");
/* harmony import */ var _components_student_subscription_student_subscription_component__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./components/student-subscription/student-subscription.component */ "./src/app/components/student-subscription/student-subscription.component.ts");
/* harmony import */ var _components_student_subscription_edit_button_student_subscription_edit_button_component__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./components/student-subscription-edit-button/student-subscription-edit-button.component */ "./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.ts");
/* harmony import */ var _services_auth_guard__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./services/auth.guard */ "./src/app/services/auth.guard.ts");
/* harmony import */ var _masters_free_notes_free_notes_component__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./masters/free-notes/free-notes.component */ "./src/app/masters/free-notes/free-notes.component.ts");
/* harmony import */ var _masters_free_videos_free_videos_component__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./masters/free-videos/free-videos.component */ "./src/app/masters/free-videos/free-videos.component.ts");
/* harmony import */ var _test_add_test_question_add_test_question_component__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./test/add-test-question/add-test-question.component */ "./src/app/test/add-test-question/add-test-question.component.ts");
/* harmony import */ var _test_add_test_add_test_component__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./test/add-test/add-test.component */ "./src/app/test/add-test/add-test.component.ts");
/* harmony import */ var _important_questions_important_questions_component__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./important-questions/important-questions.component */ "./src/app/important-questions/important-questions.component.ts");
/* harmony import */ var _assignment_assignment_component__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./assignment/assignment.component */ "./src/app/assignment/assignment.component.ts");
/* harmony import */ var _progress_progress_component__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./progress/progress.component */ "./src/app/progress/progress.component.ts");
/* harmony import */ var _pages_test_report_test_report_component__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./pages/test-report/test-report.component */ "./src/app/pages/test-report/test-report.component.ts");
/* harmony import */ var _components_student_view_button_view_button_component__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./components/student/view-button/view-button.component */ "./src/app/components/student/view-button/view-button.component.ts");
/* harmony import */ var _app_test_view_test_result_button_view_test_result_button_component__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./app/test/view-test-result-button/view-test-result-button.component */ "./src/app/app/test/view-test-result-button/view-test-result-button.component.ts");





































// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';































let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"],
            _pages_dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_9__["DashboardComponent"],
            _pages_report_report_component__WEBPACK_IMPORTED_MODULE_25__["ReportComponent"],
            _pages_city_city_component__WEBPACK_IMPORTED_MODULE_10__["CityComponent"],
            _pages_home_home_component__WEBPACK_IMPORTED_MODULE_11__["HomeComponent"],
            _pages_login_login_component__WEBPACK_IMPORTED_MODULE_12__["LoginComponent"],
            _pages_course_course_component__WEBPACK_IMPORTED_MODULE_13__["CourseComponent"],
            _pages_subject_subject_component__WEBPACK_IMPORTED_MODULE_14__["SubjectComponent"],
            _masters_masters_component__WEBPACK_IMPORTED_MODULE_16__["MastersComponent"],
            _components_city_master_city_master_component__WEBPACK_IMPORTED_MODULE_19__["CityMasterComponent"],
            _components_subject_master_subject_master_component__WEBPACK_IMPORTED_MODULE_20__["SubjectMasterComponent"],
            _components_center_master_center_master_component__WEBPACK_IMPORTED_MODULE_21__["CenterMasterComponent"],
            _components_book_test_book_test_component__WEBPACK_IMPORTED_MODULE_22__["BookTestComponent"],
            _components_book_test_master_book_test_master_component__WEBPACK_IMPORTED_MODULE_23__["BookTestMasterComponent"],
            _components_slot_master_slot_master_component__WEBPACK_IMPORTED_MODULE_24__["SlotMasterComponent"],
            _pages_report_report_component__WEBPACK_IMPORTED_MODULE_25__["ReportComponent"],
            _components_upload_report_button_upload_report_button_component__WEBPACK_IMPORTED_MODULE_26__["UploadReportButtonComponent"],
            _components_view_report_button_component_view_report_button_component_component__WEBPACK_IMPORTED_MODULE_27__["ViewReportButtonComponentComponent"],
            _components_download_report_button_component_download_report_button_component_component__WEBPACK_IMPORTED_MODULE_28__["DownloadReportButtonComponentComponent"],
            _pages_slider_slider_component__WEBPACK_IMPORTED_MODULE_29__["SliderComponent"],
            _components_slider_thumbnail_slider_thumbnail_component__WEBPACK_IMPORTED_MODULE_44__["SliderThumbnailComponent"],
            _components_slider_video_slider_video_component__WEBPACK_IMPORTED_MODULE_45__["SliderVideoComponent"],
            _components_slider_image_slider_image_component__WEBPACK_IMPORTED_MODULE_30__["SliderImageComponent"],
            _components_revision_note_component_revision_note_component_component__WEBPACK_IMPORTED_MODULE_47__["RevisionNoteComponentComponent"],
            _components_slider_image_testimonial_slider_image_testimonial_component__WEBPACK_IMPORTED_MODULE_46__["SliderImageTestimonialComponent"],
            _pages_result_result_component__WEBPACK_IMPORTED_MODULE_31__["ResultComponent"],
            _components_result_upload_result_upload_component__WEBPACK_IMPORTED_MODULE_32__["ResultUploadComponent"],
            _pages_video_video_component__WEBPACK_IMPORTED_MODULE_33__["VideoComponent"],
            _components_student_student_component__WEBPACK_IMPORTED_MODULE_54__["StudentComponent"],
            _components_video_upload_video_upload_component__WEBPACK_IMPORTED_MODULE_34__["VideoUploadComponent"],
            src_app_components_pdf_solution_upload_pdf_solution_upload_component__WEBPACK_IMPORTED_MODULE_35__["PdfSolutionUploadComponent"],
            _components_get_questions_get_questions_component__WEBPACK_IMPORTED_MODULE_36__["GetQuestionsComponent"],
            _components_question_editor_question_editor_component__WEBPACK_IMPORTED_MODULE_37__["QuestionEditorComponent"],
            _components_question_number_question_number_component__WEBPACK_IMPORTED_MODULE_38__["QuestionNumberComponent"],
            _pages_create_test_create_test_component__WEBPACK_IMPORTED_MODULE_39__["CreateTestComponent"],
            _components_upload_solution_csv_upload_solution_csv_component__WEBPACK_IMPORTED_MODULE_40__["UploadSolutionCSVComponent"],
            _components_get_solutions_get_solutions_component__WEBPACK_IMPORTED_MODULE_41__["GetSolutionsComponent"],
            _components_question_upload_video_question_upload_video_component__WEBPACK_IMPORTED_MODULE_42__["QuestionUploadVideoComponent"],
            _components_question_update_number_question_update_number_component__WEBPACK_IMPORTED_MODULE_43__["QuestionUpdateNumberComponent"],
            _components_slider_thumbnail_slider_thumbnail_component__WEBPACK_IMPORTED_MODULE_44__["SliderThumbnailComponent"],
            _components_slider_video_slider_video_component__WEBPACK_IMPORTED_MODULE_45__["SliderVideoComponent"],
            _components_slider_image_testimonial_slider_image_testimonial_component__WEBPACK_IMPORTED_MODULE_46__["SliderImageTestimonialComponent"],
            _components_revision_note_component_revision_note_component_component__WEBPACK_IMPORTED_MODULE_47__["RevisionNoteComponentComponent"],
            _pages_sub_course_sub_course_component__WEBPACK_IMPORTED_MODULE_48__["SubCourseComponent"],
            _components_add_chapter_add_chapter_component__WEBPACK_IMPORTED_MODULE_49__["AddChapterComponent"],
            _components_uploads_uploads_component__WEBPACK_IMPORTED_MODULE_50__["UploadsComponent"],
            _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_51__["ViewLibraryPdfComponent"],
            _components_view_video_view_video_component__WEBPACK_IMPORTED_MODULE_52__["ViewVideoComponent"],
            _components_live_live_component__WEBPACK_IMPORTED_MODULE_53__["LiveComponent"],
            _components_student_student_component__WEBPACK_IMPORTED_MODULE_54__["StudentComponent"],
            _components_student_subscription_student_subscription_component__WEBPACK_IMPORTED_MODULE_55__["StudentSubscriptionComponent"],
            _components_student_subscription_edit_button_student_subscription_edit_button_component__WEBPACK_IMPORTED_MODULE_56__["StudentSubscriptionEditButtonComponent"],
            _masters_free_notes_free_notes_component__WEBPACK_IMPORTED_MODULE_58__["FreeNotesComponent"],
            _masters_free_videos_free_videos_component__WEBPACK_IMPORTED_MODULE_59__["FreeVideosComponent"],
            _test_add_test_question_add_test_question_component__WEBPACK_IMPORTED_MODULE_60__["AddTestQuestionComponent"],
            _test_add_test_add_test_component__WEBPACK_IMPORTED_MODULE_61__["AddTestComponent"],
            _important_questions_important_questions_component__WEBPACK_IMPORTED_MODULE_62__["ImportantQuestionsComponent"],
            _assignment_assignment_component__WEBPACK_IMPORTED_MODULE_63__["AssignmentComponent"],
            _progress_progress_component__WEBPACK_IMPORTED_MODULE_64__["ProgressComponent"],
            _pages_test_report_test_report_component__WEBPACK_IMPORTED_MODULE_65__["TestReportComponent"],
            _components_student_view_button_view_button_component__WEBPACK_IMPORTED_MODULE_66__["ViewButtonComponent"],
            _app_test_view_test_result_button_view_test_result_button_component__WEBPACK_IMPORTED_MODULE_67__["ViewTestResultButtonComponent"],
        ],
        imports: [
            _angular_forms__WEBPACK_IMPORTED_MODULE_18__["FormsModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbTabsetModule"],
            ng2_smart_table__WEBPACK_IMPORTED_MODULE_3__["Ng2SmartTableModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_15__["HttpClientModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbSidebarModule"].forRoot(),
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbMenuModule"].forRoot(),
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbCheckboxModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbCardModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbInputModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbThemeModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbInputModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbCardModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbSpinnerModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbSpinnerModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbButtonModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbActionsModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbUserModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbCheckboxModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbRadioModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbDatepickerModule"],
            // FormsRoutingModule,
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbSelectModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbIconModule"],
            // ngFormsModule,
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__["BrowserAnimationsModule"],
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbThemeModule"].forRoot({ name: "default" }),
            _nebular_theme__WEBPACK_IMPORTED_MODULE_7__["NbLayoutModule"],
            _nebular_eva_icons__WEBPACK_IMPORTED_MODULE_8__["NbEvaIconsModule"],
        ],
        providers: [_services_data_service__WEBPACK_IMPORTED_MODULE_17__["DataService"], _services_auth_guard__WEBPACK_IMPORTED_MODULE_57__["AuthGuard"]],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]],
        entryComponents: [
            _app_test_view_test_result_button_view_test_result_button_component__WEBPACK_IMPORTED_MODULE_67__["ViewTestResultButtonComponent"],
            _components_student_subscription_edit_button_student_subscription_edit_button_component__WEBPACK_IMPORTED_MODULE_56__["StudentSubscriptionEditButtonComponent"],
            _components_student_subscription_student_subscription_component__WEBPACK_IMPORTED_MODULE_55__["StudentSubscriptionComponent"],
            _components_upload_report_button_upload_report_button_component__WEBPACK_IMPORTED_MODULE_26__["UploadReportButtonComponent"],
            _components_download_report_button_component_download_report_button_component_component__WEBPACK_IMPORTED_MODULE_28__["DownloadReportButtonComponentComponent"],
            _components_view_report_button_component_view_report_button_component_component__WEBPACK_IMPORTED_MODULE_27__["ViewReportButtonComponentComponent"],
            _components_video_upload_video_upload_component__WEBPACK_IMPORTED_MODULE_34__["VideoUploadComponent"],
            _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_51__["ViewLibraryPdfComponent"],
            _components_student_view_button_view_button_component__WEBPACK_IMPORTED_MODULE_66__["ViewButtonComponent"],
            _components_result_upload_result_upload_component__WEBPACK_IMPORTED_MODULE_32__["ResultUploadComponent"],
            _components_slider_image_slider_image_component__WEBPACK_IMPORTED_MODULE_30__["SliderImageComponent"],
            _components_revision_note_component_revision_note_component_component__WEBPACK_IMPORTED_MODULE_47__["RevisionNoteComponentComponent"],
            _components_slider_image_testimonial_slider_image_testimonial_component__WEBPACK_IMPORTED_MODULE_46__["SliderImageTestimonialComponent"],
            _components_slider_thumbnail_slider_thumbnail_component__WEBPACK_IMPORTED_MODULE_44__["SliderThumbnailComponent"],
            _components_slider_video_slider_video_component__WEBPACK_IMPORTED_MODULE_45__["SliderVideoComponent"],
            src_app_components_pdf_solution_upload_pdf_solution_upload_component__WEBPACK_IMPORTED_MODULE_35__["PdfSolutionUploadComponent"],
            _components_question_editor_question_editor_component__WEBPACK_IMPORTED_MODULE_37__["QuestionEditorComponent"],
            _components_question_number_question_number_component__WEBPACK_IMPORTED_MODULE_38__["QuestionNumberComponent"],
            _components_upload_solution_csv_upload_solution_csv_component__WEBPACK_IMPORTED_MODULE_40__["UploadSolutionCSVComponent"],
            _components_question_upload_video_question_upload_video_component__WEBPACK_IMPORTED_MODULE_42__["QuestionUploadVideoComponent"],
            _components_get_solutions_get_solutions_component__WEBPACK_IMPORTED_MODULE_41__["GetSolutionsComponent"],
            _components_question_update_number_question_update_number_component__WEBPACK_IMPORTED_MODULE_43__["QuestionUpdateNumberComponent"],
            _components_get_questions_get_questions_component__WEBPACK_IMPORTED_MODULE_36__["GetQuestionsComponent"],
            _components_view_video_view_video_component__WEBPACK_IMPORTED_MODULE_52__["ViewVideoComponent"],
            _components_student_student_component__WEBPACK_IMPORTED_MODULE_54__["StudentComponent"],
        ],
    })
], AppModule);



/***/ }),

/***/ "./src/app/app/test/view-test-result-button/view-test-result-button.component.css":
/*!****************************************************************************************!*\
  !*** ./src/app/app/test/view-test-result-button/view-test-result-button.component.css ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC90ZXN0L3ZpZXctdGVzdC1yZXN1bHQtYnV0dG9uL3ZpZXctdGVzdC1yZXN1bHQtYnV0dG9uLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/app/test/view-test-result-button/view-test-result-button.component.ts":
/*!***************************************************************************************!*\
  !*** ./src/app/app/test/view-test-result-button/view-test-result-button.component.ts ***!
  \***************************************************************************************/
/*! exports provided: ViewTestResultButtonComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewTestResultButtonComponent", function() { return ViewTestResultButtonComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ViewTestResultButtonComponent = class ViewTestResultButtonComponent {
    constructor() { }
    ngOnInit() { }
    viewResult() {
        window.open(window.location.origin + "/testreport/" + this.rowData.id, "_blank");
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ViewTestResultButtonComponent.prototype, "rowData", void 0);
ViewTestResultButtonComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-view-test-result-button",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./view-test-result-button.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app/test/view-test-result-button/view-test-result-button.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./view-test-result-button.component.css */ "./src/app/app/test/view-test-result-button/view-test-result-button.component.css")).default]
    })
], ViewTestResultButtonComponent);



/***/ }),

/***/ "./src/app/assignment/assignment.component.css":
/*!*****************************************************!*\
  !*** ./src/app/assignment/assignment.component.css ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Fzc2lnbm1lbnQvYXNzaWdubWVudC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/assignment/assignment.component.ts":
/*!****************************************************!*\
  !*** ./src/app/assignment/assignment.component.ts ***!
  \****************************************************/
/*! exports provided: AssignmentComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssignmentComponent", function() { return AssignmentComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../components/view-library-pdf/view-library-pdf.component */ "./src/app/components/view-library-pdf/view-library-pdf.component.ts");





let AssignmentComponent = class AssignmentComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.filteredSubjects = [];
        this.filteredChapters = [];
        this.pdfs = [];
        this.videos = [];
        this.videoTitle = "";
        this.youtubeLink = "";
        this.noteTitle = "";
        this.notes = [];
        this.slidersTestimonial = [];
        this.slidersVideo = [];
        this.pdfSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                subjectName: {
                    title: "Subject Name",
                },
                chapterName: {
                    title: "Chapter Name",
                },
                name: {
                    title: "Pdf Title",
                },
                sliderImage: {
                    title: "View Pdf",
                    type: "custom",
                    renderComponent: _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_4__["ViewLibraryPdfComponent"],
                },
            },
        };
        this.videoSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                title: {
                    title: "Video Title",
                },
                sliderImage: {
                    title: "Link Video",
                    type: "custom",
                },
            },
        };
        this.getPdfs();
        this.getVideos();
    }
    pdfFileSelected(files) {
        this.pdfFile = files;
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    getFilteredChapters() {
        this.http
            .get(this.dataService.serverUrl + "chapter", {
            params: { subjectID: this.selectedSubjectID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED CHAPTER :", data);
            this.filteredChapters = data.data;
        });
    }
    ngOnInit() { }
    // postMethod(files: FileList) {
    uploadPdf() {
        console.log(this.pdfFile);
        this.fileToUpload = this.pdfFile.item(0);
        // this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        formData.append("pdfTitle", this.pdfTitle);
        formData.append("chapterID", this.selectedChapterID);
        this.http
            .post(this.dataService.serverUrl + "assignment", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload slider");
            }
            else {
                this.getPdfs();
            }
        });
        return false;
    }
    getPdfs() {
        this.http
            .get(this.dataService.serverUrl + "assignment")
            .toPromise()
            .then((data) => {
            console.log("GET assignment questions", data);
            if (!data.status) {
                alert("Error getting assignment questions");
                return;
            }
            this.pdfs = data.data;
            // this.sliders = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getVideos() {
        this.http
            .get(this.dataService.serverUrl + "video")
            .toPromise()
            .then((data) => {
            console.log("GET VIDEO", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.videos = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    deleteData(event, endpoint = 'assignment') {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + `${endpoint}/` + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    this.getPdfs();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the slider");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
AssignmentComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
AssignmentComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-assignment',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./assignment.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/assignment/assignment.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./assignment.component.css */ "./src/app/assignment/assignment.component.css")).default]
    })
], AssignmentComponent);



/***/ }),

/***/ "./src/app/components/add-chapter/add-chapter.component.css":
/*!******************************************************************!*\
  !*** ./src/app/components/add-chapter/add-chapter.component.css ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvYWRkLWNoYXB0ZXIvYWRkLWNoYXB0ZXIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/add-chapter/add-chapter.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/components/add-chapter/add-chapter.component.ts ***!
  \*****************************************************************/
/*! exports provided: AddChapterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddChapterComponent", function() { return AddChapterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let AddChapterComponent = class AddChapterComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.filteredSubjects = [];
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: true,
            actions: {
                edit: false,
                position: "right",
            },
            columns: {
                subCourseName: {
                    title: "Subcourse ",
                },
                subjectName: {
                    title: "Subject ",
                },
                name: {
                    title: "Chapter ",
                },
            },
        };
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    submitChapter() {
        // console.log("submitting");
        this.http
            .post(this.dataService.serverUrl + "chapter", {
            subjectID: this.selectedSubjectID + "",
            chapter: this.chapter + "",
        })
            .toPromise()
            .then((data) => {
            console.log(data);
            if (data.status) {
                this.dataService.getChapters();
            }
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    ngOnInit() { }
    onDeleteConfirm(event) {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + "chapter/" + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    this.dataService.getChapters();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the course");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
AddChapterComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
AddChapterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-add-chapter",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./add-chapter.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/add-chapter/add-chapter.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./add-chapter.component.css */ "./src/app/components/add-chapter/add-chapter.component.css")).default]
    })
], AddChapterComponent);



/***/ }),

/***/ "./src/app/components/book-test-master/book-test-master.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/components/book-test-master/book-test-master.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvYm9vay10ZXN0LW1hc3Rlci9ib29rLXRlc3QtbWFzdGVyLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/book-test-master/book-test-master.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/components/book-test-master/book-test-master.component.ts ***!
  \***************************************************************************/
/*! exports provided: BookTestMasterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookTestMasterComponent", function() { return BookTestMasterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let BookTestMasterComponent = class BookTestMasterComponent {
    constructor() { }
    ngOnInit() {
    }
};
BookTestMasterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-book-test-master',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./book-test-master.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/book-test-master/book-test-master.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./book-test-master.component.css */ "./src/app/components/book-test-master/book-test-master.component.css")).default]
    })
], BookTestMasterComponent);



/***/ }),

/***/ "./src/app/components/book-test/book-test.component.css":
/*!**************************************************************!*\
  !*** ./src/app/components/book-test/book-test.component.css ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".nbElement {\n  margin: 8px\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9ib29rLXRlc3QvYm9vay10ZXN0LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtBQUNGIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9ib29rLXRlc3QvYm9vay10ZXN0LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubmJFbGVtZW50IHtcbiAgbWFyZ2luOiA4cHhcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/components/book-test/book-test.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/components/book-test/book-test.component.ts ***!
  \*************************************************************/
/*! exports provided: BookTestComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookTestComponent", function() { return BookTestComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




let BookTestComponent = class BookTestComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.tests = [];
        this.cities = [];
        this.courses = [];
        this.subjects = [];
        this.centers = [];
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true
            },
            hideSubHeader: true,
            actions: {
                edit: false,
                position: "right"
            },
            columns: {
                city: {
                    title: "city"
                },
                center: {
                    title: "Center "
                },
                course: {
                    title: "Course"
                },
                subject: {
                    title: "Subject"
                },
                timeSlot: {
                    title: "Time"
                },
                date: {
                    title: "Date"
                },
                amount: {
                    title: "Amount"
                }
            }
        };
        this.getTests();
        this.getCities();
        this.getCourses();
        // this.getSubjects();
        // console.log(this.dataService.courses);
        // this.dataService.coursesUpdated.subscribe(data => {
        //   this.courses = this.dataService.courses;
        // });
    }
    getCities() {
        this.http.get(this.dataService.serverUrl + 'city', {}).toPromise().then((data) => {
            console.log(data);
            this.cities = data;
        });
    }
    getCourses() {
        this.http.get(this.dataService.serverUrl + "course", {}).toPromise().then((data) => {
            console.log(data);
            this.courses = data;
        });
    }
    getSubjects(courseID) {
        this.http
            .get(this.dataService.serverUrl + "subject?courseID=" + courseID, {})
            .toPromise()
            .then((data) => {
            this.subjects = data;
            // // update the service courses
            // this.dataService.courses = data;
            // // emit the event coursesUpdate
            // this.dataService.coursesUpdated.emit();
            // console.log(this.dataService.courses);
            // this.courses = this.dataService.courses;
        })
            .catch(err => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getCenters(cityID) {
        this.http.get(this.dataService.serverUrl + "center?cityID=" + cityID, {}).toPromise().then((data) => {
            console.log(data);
            this.centers = data;
        });
    }
    getTests() {
        this.http.get(this.dataService.serverUrl + "test", {}).toPromise().then((data) => {
            console.log(data);
            this.tests = data;
        });
    }
    submitTest() {
        this.http.post(this.dataService.serverUrl + "test", {
            cityID: this.selectedCityID + "",
            courseID: this.selectedCourseID + "",
            subjectID: this.selectedSubjectID + "",
            centerID: this.selectedCenterID + "",
            timeSlot: this.timeSlot + "",
            date: this.date + "",
            amount: this.amount + ""
        }).toPromise().then((data) => {
            console.log(data);
            this.getTests();
        });
    }
    // submitSubject() {
    //   // console.log("submitting");
    //   this.http
    //     .post(this.dataService.serverUrl + "subject", {
    //       courseID: this.selectedCourseID + "",
    //       subject: this.subject
    //     })
    //     .toPromise()
    //     .then((data: any) => {
    //       console.log(data);
    //       if (data.status === "success") {
    //         this.getSubjects();
    //       }
    //     })
    //     .catch(err => {
    //       alert("Connection Error");
    //       console.log(err);
    //     });
    // }
    ngOnInit() { }
    onDeleteConfirm(event) {
        console.log("Delete Event In Console");
        console.log(event.data.id);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + "test/" + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    // this.getCourses();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the course");
            })
                .catch(err => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
    citySelected(cityID) {
        // alert(cityID)
        this.getCenters(cityID);
    }
    courseSelected(courseID) {
        // alert(courseID)
        this.getSubjects(courseID);
    }
};
BookTestComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] }
];
BookTestComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-book-test",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./book-test.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/book-test/book-test.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./book-test.component.css */ "./src/app/components/book-test/book-test.component.css")).default]
    })
], BookTestComponent);



/***/ }),

/***/ "./src/app/components/center-master/center-master.component.css":
/*!**********************************************************************!*\
  !*** ./src/app/components/center-master/center-master.component.css ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvY2VudGVyLW1hc3Rlci9jZW50ZXItbWFzdGVyLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/center-master/center-master.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/center-master/center-master.component.ts ***!
  \*********************************************************************/
/*! exports provided: CenterMasterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CenterMasterComponent", function() { return CenterMasterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let CenterMasterComponent = class CenterMasterComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.cities = [];
        this.centerMapURL = "";
        this.centerLat = "";
        this.centerLng = "";
        this.subjects = [];
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: true,
            actions: {
                edit: false,
                position: "right",
            },
            columns: {
                city: {
                    title: "City",
                },
                center: {
                    title: "Center ",
                },
            },
        };
        this.dataService.citiesUpdated.subscribe((data) => {
            // this.cities = this.dataService.cities
        });
        // this.cities = this.dataService.cities
        // this.getCities();
        this.getCenters();
        // console.log(this.dataService.courses);
        // this.dataService.coursesUpdated.subscribe(data => {
        //   this.courses = this.dataService.courses;
        // });
        this.courses = this.dataService.courses;
    }
    getCenters() {
        this.http
            .get(this.dataService.serverUrl + "center", {})
            .toPromise()
            .then((data) => {
            console.log(data);
            this.centers = data;
            // this.subjects = data;
            // // update the service courses
            // this.dataService.courses = data;
            // // emit the event coursesUpdate
            // this.dataService.coursesUpdated.emit();
            // console.log(this.dataService.courses);
            // this.courses = this.dataService.courses;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getCities() {
        // this.cities = this.dataService.cities;
        // console.log(this.dataService.cities);
        console.log(this.cities);
    }
    submit() {
        const regex = new RegExp("@(.*),(.*),");
        const latLngMatch = this.centerMapURL.match(regex);
        if (latLngMatch) {
            this.centerLat = latLngMatch[1];
            this.centerLng = latLngMatch[2];
        }
        console.log(latLngMatch);
        // console.log("submitting");
        this.http
            .post(this.dataService.serverUrl + "center", {
            cityID: this.selecteCityID + "",
            name: this.centerName + "",
            mapURL: this.centerMapURL + "",
        })
            .toPromise()
            .then((data) => {
            console.log(data);
            if (data.status) {
                this.getCenters();
            }
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    ngOnInit() { }
    onDeleteConfirm(event) {
        // alert(event.data.id);
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + "center/" + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    // this.getCourses();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the course");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
CenterMasterComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
CenterMasterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-center-master",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./center-master.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/center-master/center-master.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./center-master.component.css */ "./src/app/components/center-master/center-master.component.css")).default]
    })
], CenterMasterComponent);



/***/ }),

/***/ "./src/app/components/city-master/city-master.component.css":
/*!******************************************************************!*\
  !*** ./src/app/components/city-master/city-master.component.css ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvY2l0eS1tYXN0ZXIvY2l0eS1tYXN0ZXIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/city-master/city-master.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/components/city-master/city-master.component.ts ***!
  \*****************************************************************/
/*! exports provided: CityMasterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CityMasterComponent", function() { return CityMasterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CityMasterComponent = class CityMasterComponent {
    constructor() { }
    ngOnInit() {
    }
};
CityMasterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-city-master',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./city-master.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/city-master/city-master.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./city-master.component.css */ "./src/app/components/city-master/city-master.component.css")).default]
    })
], CityMasterComponent);



/***/ }),

/***/ "./src/app/components/download-report-button-component/download-report-button-component.component.css":
/*!************************************************************************************************************!*\
  !*** ./src/app/components/download-report-button-component/download-report-button-component.component.css ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZG93bmxvYWQtcmVwb3J0LWJ1dHRvbi1jb21wb25lbnQvZG93bmxvYWQtcmVwb3J0LWJ1dHRvbi1jb21wb25lbnQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/download-report-button-component/download-report-button-component.component.ts":
/*!***********************************************************************************************************!*\
  !*** ./src/app/components/download-report-button-component/download-report-button-component.component.ts ***!
  \***********************************************************************************************************/
/*! exports provided: DownloadReportButtonComponentComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DownloadReportButtonComponentComponent", function() { return DownloadReportButtonComponentComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




let DownloadReportButtonComponentComponent = class DownloadReportButtonComponentComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
    }
    ngOnInit() {
    }
    download() {
        console.log(this.rowData);
        // alert("will download")
        window.open(this.dataService.serverUrl + `uploads/reports/${this.rowData.id}.pdf`, "_blank");
        // this.http.get(this.dataService.serverUrl + `uploads/reports/${this.rowData.report}`, { responseType: 'blob' })
        //   .toPromise().then(data => {
        //     console.log(data);
        //   }).catch(err => {
        //     alert("Error Download Report !")
        //     console.log(err);
        //   });
    }
};
DownloadReportButtonComponentComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], DownloadReportButtonComponentComponent.prototype, "rowData", void 0);
DownloadReportButtonComponentComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-download-report-button-component',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./download-report-button-component.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/download-report-button-component/download-report-button-component.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./download-report-button-component.component.css */ "./src/app/components/download-report-button-component/download-report-button-component.component.css")).default]
    })
], DownloadReportButtonComponentComponent);



/***/ }),

/***/ "./src/app/components/get-questions/get-questions.component.css":
/*!**********************************************************************!*\
  !*** ./src/app/components/get-questions/get-questions.component.css ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZ2V0LXF1ZXN0aW9ucy9nZXQtcXVlc3Rpb25zLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/get-questions/get-questions.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/get-questions/get-questions.component.ts ***!
  \*********************************************************************/
/*! exports provided: GetQuestionsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GetQuestionsComponent", function() { return GetQuestionsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let GetQuestionsComponent = class GetQuestionsComponent {
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
    }
    // @Output() save: EventEmitter<any> = new EventEmitter();
    ngOnInit() {
        // this.renderValue = this.value.toString().toUpperCase();
        console.log('get questions component row data', this.rowData);
    }
    //   this.dataService.getQuestionsEvent.emit(this.rowData.id)
    getQuestions() {
        // alert(this.rowData.id)
        // this
        // this.dataService.report.testSelected = this.rowData.id
        // this.dataService.report.testSelected.emit(this.rowData.id)
        this.http.get(this.dataService.serverUrl + "solution?testID=" + this.rowData.id, {}).toPromise().then(data => {
            console.log(data);
            this.dataService.getQuestionsEvent.emit(data);
        }).catch(err => {
            alert("Error getting Solutions");
            console.log(err);
        });
    }
};
GetQuestionsComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], GetQuestionsComponent.prototype, "rowData", void 0);
GetQuestionsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-get-questions',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./get-questions.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/get-questions/get-questions.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./get-questions.component.css */ "./src/app/components/get-questions/get-questions.component.css")).default]
    })
], GetQuestionsComponent);



/***/ }),

/***/ "./src/app/components/get-solutions/get-solutions.component.css":
/*!**********************************************************************!*\
  !*** ./src/app/components/get-solutions/get-solutions.component.css ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZ2V0LXNvbHV0aW9ucy9nZXQtc29sdXRpb25zLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/get-solutions/get-solutions.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/get-solutions/get-solutions.component.ts ***!
  \*********************************************************************/
/*! exports provided: GetSolutionsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GetSolutionsComponent", function() { return GetSolutionsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let GetSolutionsComponent = class GetSolutionsComponent {
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
    }
    // @Output() save: EventEmitter<any> = new EventEmitter();
    ngOnInit() {
        // this.renderValue = this.value.toString().toUpperCase();
        console.log(this.rowData);
    }
    getSolutions() {
        // alert(this.rowData.id)
        // this
        // this.dataService.report.testSelected = this.rowData.id
        // this.dataService.report.testSelected.emit(this.rowData.id)
        this.http.get(this.dataService.serverUrl + "solution/" + this.rowData.id, {}).toPromise().then(data => {
            console.log(data);
        }).catch(err => {
            alert("Error getting Solutions");
            console.log(err);
        });
    }
};
GetSolutionsComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], GetSolutionsComponent.prototype, "rowData", void 0);
GetSolutionsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-get-solutions',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./get-solutions.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/get-solutions/get-solutions.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./get-solutions.component.css */ "./src/app/components/get-solutions/get-solutions.component.css")).default]
    })
], GetSolutionsComponent);



/***/ }),

/***/ "./src/app/components/live/live.component.css":
/*!****************************************************!*\
  !*** ./src/app/components/live/live.component.css ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvbGl2ZS9saXZlLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/live/live.component.ts":
/*!***************************************************!*\
  !*** ./src/app/components/live/live.component.ts ***!
  \***************************************************/
/*! exports provided: LiveComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiveComponent", function() { return LiveComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




let LiveComponent = class LiveComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.filteredSubjects = [];
        this.filteredChapters = [];
        this.videos = [];
        this.youtubeLink = "";
        this.videoSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                subcourseName: {
                    title: "Sub Course",
                },
                subjectName: {
                    title: "Subject",
                },
                name: {
                    title: "Class Title",
                },
                date: {
                    title: "Date",
                },
                time: {
                    title: "Time",
                },
                youtubeLink: {
                    title: "Link",
                },
            },
        };
        this.getVideos();
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    getFilteredChapters() {
        this.http
            .get(this.dataService.serverUrl + "chapter", {
            params: { subjectID: this.selectedSubjectID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED CHAPTER :", data);
            this.filteredChapters = data.data;
        });
    }
    ngOnInit() { }
    getVideos() {
        this.http
            .get(this.dataService.serverUrl + "live")
            .toPromise()
            .then((data) => {
            console.log("GET LIVE", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.videos = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    addVideo() {
        // alert("asdf");
        this.http
            .post(this.dataService.serverUrl + "live", {
            subjectID: this.selectedSubjectID,
            name: this.name,
            date: this.date,
            time: this.time,
            youtubeLink: this.youtubeLink,
        })
            .subscribe((data) => {
            console.log("POST LIBRARY", data);
            this.getVideos();
        }, (error) => {
            alert("Error Adding Video");
        });
    }
    deleteData(event) {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + `live/` + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // this.getVideos();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the live class");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
LiveComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] }
];
LiveComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-live",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./live.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/live/live.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./live.component.css */ "./src/app/components/live/live.component.css")).default]
    })
], LiveComponent);



/***/ }),

/***/ "./src/app/components/pdf-solution-upload/pdf-solution-upload.component.css":
/*!**********************************************************************************!*\
  !*** ./src/app/components/pdf-solution-upload/pdf-solution-upload.component.css ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcGRmLXNvbHV0aW9uLXVwbG9hZC9wZGYtc29sdXRpb24tdXBsb2FkLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/pdf-solution-upload/pdf-solution-upload.component.ts":
/*!*********************************************************************************!*\
  !*** ./src/app/components/pdf-solution-upload/pdf-solution-upload.component.ts ***!
  \*********************************************************************************/
/*! exports provided: PdfSolutionUploadComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PdfSolutionUploadComponent", function() { return PdfSolutionUploadComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");





let PdfSolutionUploadComponent = class PdfSolutionUploadComponent {
    constructor(dataService, fb, http) {
        this.dataService = dataService;
        this.fb = fb;
        this.http = http;
        this.filesToUpload = [];
        console.log(this.rowData);
    }
    ngOnInit() {
    }
    // onFileChange(event) {
    //   let reader = new FileReader();
    //   if (event.target.files && event.target.files.length > 0) {
    //     let file = event.target.files[0];
    //     reader.readAsDataURL(file);
    //     reader.onload = () => {
    //       this.form.get('avatar').setValue({
    //         filename: file.name,
    //         filetype: file.type,
    //         value: reader.result.split(',')[1]
    //       })
    //     };
    //   }
    // }
    postMethod(files) {
        console.log(this.rowData);
        this.fileToUpload = files.item(0);
        const formData = new FormData();
        formData.append('file', this.fileToUpload, `${this.rowData.id}.pdf`);
        // formData.append('abc', "def");
        this.http.post(this.dataService.serverUrl + "pdfSolution/upload", formData).subscribe((val) => {
            console.log(val);
            if (val.status) {
                alert("PDF Solution Uploaded !");
                return;
            }
            alert("Failed to Upload Video Solution !");
        });
        return false;
    }
    upload() {
        // alert("sadf")
        console.log(this.uploadForm);
        this.uploadForm.nativeElement.submit();
    }
};
PdfSolutionUploadComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("uploadForm", { static: false })
], PdfSolutionUploadComponent.prototype, "uploadForm", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], PdfSolutionUploadComponent.prototype, "rowData", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('fileInput', { static: false })
], PdfSolutionUploadComponent.prototype, "fileInput", void 0);
PdfSolutionUploadComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-pdf-solution-upload',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./pdf-solution-upload.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/pdf-solution-upload/pdf-solution-upload.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./pdf-solution-upload.component.css */ "./src/app/components/pdf-solution-upload/pdf-solution-upload.component.css")).default]
    })
], PdfSolutionUploadComponent);



/***/ }),

/***/ "./src/app/components/question-editor/question-editor.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/components/question-editor/question-editor.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("input:disabled {\n  background-color: white;\n  padding: 4px\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9xdWVzdGlvbi1lZGl0b3IvcXVlc3Rpb24tZWRpdG9yLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSx1QkFBdUI7RUFDdkI7QUFDRiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcXVlc3Rpb24tZWRpdG9yL3F1ZXN0aW9uLWVkaXRvci5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiaW5wdXQ6ZGlzYWJsZWQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTtcbiAgcGFkZGluZzogNHB4XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/components/question-editor/question-editor.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/question-editor/question-editor.component.ts ***!
  \*************************************************************************/
/*! exports provided: QuestionEditorComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionEditorComponent", function() { return QuestionEditorComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




// import * as Editor from '../../../assets/ckeditor.js';
let QuestionEditorComponent = class QuestionEditorComponent {
    // imageExtension
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
        this.data = 'abc';
    }
    ngOnInit() {
        // console.log('editory el', this.editor);
        console.log("rowdata of individual question", this.rowData);
        // CKEDITOR.replace(this.editor.nativeElement);
        // ClassicEditor
        //   .create(document.querySelector('#editor'))
        //   .then(editor => {
        //     console.log(editor);
        //   })01
        //   .catch(error => {
        //     console.error(error);
        //   });
    }
    onReady(editor) {
        editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    }
    postMethod(files) {
        // alert("asdf")
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        console.log(this.fileToUpload);
        // alert()
        // this.imageExtension = this.fileToUpload.name.split('.')[this.fileToUpload.name.split('.').length - 1]
        formData.append('file', this.fileToUpload, `${this.rowData.id}.${'png'}`);
        // formData.append('file', this.fileToUpload, `${this.rowData.id}.${this.imageExtension}`);
        // formData.append('abc', "def");
        this.http.post(this.dataService.serverUrl + "solution/upload/question", formData).subscribe((val) => {
            console.log(val);
            if (val.status) {
                alert("Question Uploaded !");
                return;
            }
            alert("Failed to Upload Report  !");
        });
        return false;
    }
};
QuestionEditorComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('editor', null)
], QuestionEditorComponent.prototype, "editor", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])('rowData')
], QuestionEditorComponent.prototype, "rowData", void 0);
QuestionEditorComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-question-editor',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./question-editor.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-editor/question-editor.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./question-editor.component.css */ "./src/app/components/question-editor/question-editor.component.css")).default]
    })
], QuestionEditorComponent);



/***/ }),

/***/ "./src/app/components/question-number/question-number.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/components/question-number/question-number.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcXVlc3Rpb24tbnVtYmVyL3F1ZXN0aW9uLW51bWJlci5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/question-number/question-number.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/question-number/question-number.component.ts ***!
  \*************************************************************************/
/*! exports provided: QuestionNumberComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionNumberComponent", function() { return QuestionNumberComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let QuestionNumberComponent = class QuestionNumberComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])('rowData')
], QuestionNumberComponent.prototype, "rowData", void 0);
QuestionNumberComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-question-number',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./question-number.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-number/question-number.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./question-number.component.css */ "./src/app/components/question-number/question-number.component.css")).default]
    })
], QuestionNumberComponent);



/***/ }),

/***/ "./src/app/components/question-update-number/question-update-number.component.css":
/*!****************************************************************************************!*\
  !*** ./src/app/components/question-update-number/question-update-number.component.css ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcXVlc3Rpb24tdXBkYXRlLW51bWJlci9xdWVzdGlvbi11cGRhdGUtbnVtYmVyLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/question-update-number/question-update-number.component.ts":
/*!***************************************************************************************!*\
  !*** ./src/app/components/question-update-number/question-update-number.component.ts ***!
  \***************************************************************************************/
/*! exports provided: QuestionUpdateNumberComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionUpdateNumberComponent", function() { return QuestionUpdateNumberComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




let QuestionUpdateNumberComponent = class QuestionUpdateNumberComponent {
    // imageExtension
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
    }
    ngOnInit() {
        // console.log('editory el', this.editor);
        // console.log("rowdata of individual question", this.rowData)
        // CKEDITOR.replace(this.editor.nativeElement);
        // ClassicEditor
        //   .create(document.querySelector('#editor'))
        //   .then(editor => {
        //     console.log(editor);
        //   })01
        //   .catch(error => {
        //     console.error(error);
        //   });
    }
    onReady(editor) {
        editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    }
    valueChanged() {
        // alert('asdf')
        this.http.post(this.dataService.serverUrl + "solution/updateQuestionNumber", { questionID: this.rowData.id, questionNumber: this.rowData.questionNumber }).toPromise().then(data => {
            console.log('question number updated', data);
        }).catch(err => {
            alert("Unable to update question Number !");
            console.log(err);
        });
    }
    postMethod(files) {
        // alert("asdf")
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        console.log(this.fileToUpload);
        // alert()
        // this.imageExtension = this.fileToUpload.name.split('.')[this.fileToUpload.name.split('.').length - 1]
        formData.append('file', this.fileToUpload, `${this.rowData.id}.${'jpg'}`);
        // formData.append('file', this.fileToUpload, `${this.rowData.id}.${this.imageExtension}`);
        // formData.append('abc', "def");
        this.http.post(this.dataService.serverUrl + "solution/upload/question", formData).subscribe((val) => {
            console.log(val);
            if (val.status) {
                alert("Report Uploaded !");
                return;
            }
            alert("Failed to Upload Report  !");
        });
        return false;
    }
};
QuestionUpdateNumberComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('editor', null)
], QuestionUpdateNumberComponent.prototype, "editor", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])('rowData')
], QuestionUpdateNumberComponent.prototype, "rowData", void 0);
QuestionUpdateNumberComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-question-update-number',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./question-update-number.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-update-number/question-update-number.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./question-update-number.component.css */ "./src/app/components/question-update-number/question-update-number.component.css")).default]
    })
], QuestionUpdateNumberComponent);



/***/ }),

/***/ "./src/app/components/question-upload-video/question-upload-video.component.css":
/*!**************************************************************************************!*\
  !*** ./src/app/components/question-upload-video/question-upload-video.component.css ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcXVlc3Rpb24tdXBsb2FkLXZpZGVvL3F1ZXN0aW9uLXVwbG9hZC12aWRlby5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/question-upload-video/question-upload-video.component.ts":
/*!*************************************************************************************!*\
  !*** ./src/app/components/question-upload-video/question-upload-video.component.ts ***!
  \*************************************************************************************/
/*! exports provided: QuestionUploadVideoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionUploadVideoComponent", function() { return QuestionUploadVideoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




let QuestionUploadVideoComponent = class QuestionUploadVideoComponent {
    // imageExtension
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
        this.data = 'abc';
    }
    ngOnInit() {
        // console.log('editory el', this.editor);
        console.log("rowdata of individual question for video solution", this.rowData);
        // CKEDITOR.replace(this.editor.nativeElement);
        // ClassicEditor
        //   .create(document.querySelector('#editor'))
        //   .then(editor => {
        //     console.log(editor);
        //   })01
        //   .catch(error => {
        //     console.error(error);
        //   });
    }
    onReady(editor) {
        editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    }
    postMethod(files) {
        // alert("asdf")
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        console.log(this.fileToUpload);
        // alert()
        // this.imageExtension = this.fileToUpload.name.split('.')[this.fileToUpload.name.split('.').length - 1]
        formData.append('file', this.fileToUpload, `${this.rowData.id}.${'mp4'}`);
        // formData.append('file', this.fileToUpload, `${this.rowData.id}.${this.imageExtension}`);
        // formData.append('abc', "def");
        this.http.post(this.dataService.serverUrl + "solution/upload/solution", formData).subscribe((val) => {
            console.log(val);
            if (val.status) {
                alert("Video Solution Uploaded !");
                return;
            }
            alert("Failed to Upload Video  !");
        });
        return false;
    }
};
QuestionUploadVideoComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('editor', null)
], QuestionUploadVideoComponent.prototype, "editor", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])('rowData')
], QuestionUploadVideoComponent.prototype, "rowData", void 0);
QuestionUploadVideoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-question-upload-video',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./question-upload-video.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/question-upload-video/question-upload-video.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./question-upload-video.component.css */ "./src/app/components/question-upload-video/question-upload-video.component.css")).default]
    })
], QuestionUploadVideoComponent);



/***/ }),

/***/ "./src/app/components/result-upload/result-upload.component.css":
/*!**********************************************************************!*\
  !*** ./src/app/components/result-upload/result-upload.component.css ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcmVzdWx0LXVwbG9hZC9yZXN1bHQtdXBsb2FkLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/result-upload/result-upload.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/result-upload/result-upload.component.ts ***!
  \*********************************************************************/
/*! exports provided: ResultUploadComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResultUploadComponent", function() { return ResultUploadComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");





let ResultUploadComponent = class ResultUploadComponent {
    constructor(dataService, fb, http) {
        this.dataService = dataService;
        this.fb = fb;
        this.http = http;
        this.loading = false;
        this.filesToUpload = [];
        console.log(this.rowData);
    }
    ngOnInit() {
    }
    // onFileChange(event) {
    //   let reader = new FileReader();
    //   if (event.target.files && event.target.files.length > 0) {
    //     let file = event.target.files[0];
    //     reader.readAsDataURL(file);
    //     reader.onload = () => {
    //       this.form.get('avatar').setValue({
    //         filename: file.name,
    //         filetype: file.type,
    //         value: reader.result.split(',')[1]
    //       })
    //     };
    //   }
    // }
    postMethod(files) {
        this.loading = true;
        console.log(this.rowData);
        this.fileToUpload = files.item(0);
        const formData = new FormData();
        formData.append('file', this.fileToUpload, `${this.rowData.id}.pdf`);
        formData.append('abc', "def");
        this.http.post(this.dataService.serverUrl + "result/upload", formData).toPromise().then((val) => {
            this.loading = false;
            // console.log(this.loading);
            console.log(val);
            if (val.status) {
                // alert("Result Uploaded !");
                return;
            }
            // setTimeout(() => {
            //   this.loading = false;
            // }, 5000);
            alert("Failed to Upload Result !");
        });
        // .subscribe((val: any) => {
        //   console.log(this.loading);
        //   console.log(val);
        //   if (val.status) {
        //     // alert("Result Uploaded !");
        //     return
        //   }
        //   // setTimeout(() => {
        //   //   this.loading = false;
        //   // }, 5000);
        //   alert("Failed to Upload Result !")
        // });
        return false;
    }
    upload() {
        // alert("sadf")
        console.log(this.uploadForm);
        this.uploadForm.nativeElement.submit();
    }
};
ResultUploadComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("uploadForm", { static: false })
], ResultUploadComponent.prototype, "uploadForm", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ResultUploadComponent.prototype, "rowData", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('fileInput', { static: false })
], ResultUploadComponent.prototype, "fileInput", void 0);
ResultUploadComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-result-upload',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./result-upload.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/result-upload/result-upload.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./result-upload.component.css */ "./src/app/components/result-upload/result-upload.component.css")).default]
    })
], ResultUploadComponent);



/***/ }),

/***/ "./src/app/components/revision-note-component/revision-note-component.component.css":
/*!******************************************************************************************!*\
  !*** ./src/app/components/revision-note-component/revision-note-component.component.css ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcmV2aXNpb24tbm90ZS1jb21wb25lbnQvcmV2aXNpb24tbm90ZS1jb21wb25lbnQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/revision-note-component/revision-note-component.component.ts":
/*!*****************************************************************************************!*\
  !*** ./src/app/components/revision-note-component/revision-note-component.component.ts ***!
  \*****************************************************************************************/
/*! exports provided: RevisionNoteComponentComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RevisionNoteComponentComponent", function() { return RevisionNoteComponentComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");




let RevisionNoteComponentComponent = class RevisionNoteComponentComponent {
    constructor(dataService, domSanitizer) {
        this.dataService = dataService;
        this.domSanitizer = domSanitizer;
        this.url = this.dataService.serverUrl;
    }
    ngOnInit() {
        this.pdfUrl = this.domSanitizer.bypassSecurityTrustUrl(this.url + "uploads/revisionNotes/" + this.rowData.fileName);
    }
};
RevisionNoteComponentComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["DomSanitizer"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], RevisionNoteComponentComponent.prototype, "rowData", void 0);
RevisionNoteComponentComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-revision-note-component",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./revision-note-component.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/revision-note-component/revision-note-component.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./revision-note-component.component.css */ "./src/app/components/revision-note-component/revision-note-component.component.css")).default]
    })
], RevisionNoteComponentComponent);



/***/ }),

/***/ "./src/app/components/slider-image-testimonial/slider-image-testimonial.component.css":
/*!********************************************************************************************!*\
  !*** ./src/app/components/slider-image-testimonial/slider-image-testimonial.component.css ***!
  \********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc2xpZGVyLWltYWdlLXRlc3RpbW9uaWFsL3NsaWRlci1pbWFnZS10ZXN0aW1vbmlhbC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/slider-image-testimonial/slider-image-testimonial.component.ts":
/*!*******************************************************************************************!*\
  !*** ./src/app/components/slider-image-testimonial/slider-image-testimonial.component.ts ***!
  \*******************************************************************************************/
/*! exports provided: SliderImageTestimonialComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliderImageTestimonialComponent", function() { return SliderImageTestimonialComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");



let SliderImageTestimonialComponent = class SliderImageTestimonialComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.url = this.dataService.serverUrl;
    }
    ngOnInit() { }
};
SliderImageTestimonialComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SliderImageTestimonialComponent.prototype, "rowData", void 0);
SliderImageTestimonialComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-slider-image-testimonial",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./slider-image-testimonial.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-image-testimonial/slider-image-testimonial.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./slider-image-testimonial.component.css */ "./src/app/components/slider-image-testimonial/slider-image-testimonial.component.css")).default]
    })
], SliderImageTestimonialComponent);



/***/ }),

/***/ "./src/app/components/slider-image/slider-image.component.css":
/*!********************************************************************!*\
  !*** ./src/app/components/slider-image/slider-image.component.css ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc2xpZGVyLWltYWdlL3NsaWRlci1pbWFnZS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/slider-image/slider-image.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/slider-image/slider-image.component.ts ***!
  \*******************************************************************/
/*! exports provided: SliderImageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliderImageComponent", function() { return SliderImageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");



let SliderImageComponent = class SliderImageComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.type = "image";
        this.url = this.dataService.serverUrl;
    }
    ngOnInit() {
        if (this.rowData.pdfName.includes(".pdf"))
            this.type = "pdf";
    }
};
SliderImageComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SliderImageComponent.prototype, "rowData", void 0);
SliderImageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-slider-image",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./slider-image.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-image/slider-image.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./slider-image.component.css */ "./src/app/components/slider-image/slider-image.component.css")).default]
    })
], SliderImageComponent);



/***/ }),

/***/ "./src/app/components/slider-thumbnail/slider-thumbnail.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/components/slider-thumbnail/slider-thumbnail.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc2xpZGVyLXRodW1ibmFpbC9zbGlkZXItdGh1bWJuYWlsLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/slider-thumbnail/slider-thumbnail.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/components/slider-thumbnail/slider-thumbnail.component.ts ***!
  \***************************************************************************/
/*! exports provided: SliderThumbnailComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliderThumbnailComponent", function() { return SliderThumbnailComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");



let SliderThumbnailComponent = class SliderThumbnailComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.url = this.dataService.serverUrl;
    }
    ngOnInit() {
        console.log('rowdata', this.rowData);
    }
};
SliderThumbnailComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SliderThumbnailComponent.prototype, "rowData", void 0);
SliderThumbnailComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-slider-thumbnail',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./slider-thumbnail.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-thumbnail/slider-thumbnail.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./slider-thumbnail.component.css */ "./src/app/components/slider-thumbnail/slider-thumbnail.component.css")).default]
    })
], SliderThumbnailComponent);



/***/ }),

/***/ "./src/app/components/slider-video/slider-video.component.css":
/*!********************************************************************!*\
  !*** ./src/app/components/slider-video/slider-video.component.css ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc2xpZGVyLXZpZGVvL3NsaWRlci12aWRlby5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/slider-video/slider-video.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/slider-video/slider-video.component.ts ***!
  \*******************************************************************/
/*! exports provided: SliderVideoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliderVideoComponent", function() { return SliderVideoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");



let SliderVideoComponent = class SliderVideoComponent {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    ngOnInit() {
        this.videoURL = this.domSanitizer.bypassSecurityTrustUrl(this.rowData.youtubeLink);
        console.log('youtube video id', this.videoURL);
    }
};
SliderVideoComponent.ctorParameters = () => [
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["DomSanitizer"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SliderVideoComponent.prototype, "rowData", void 0);
SliderVideoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-slider-video',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./slider-video.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider-video/slider-video.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./slider-video.component.css */ "./src/app/components/slider-video/slider-video.component.css")).default]
    })
], SliderVideoComponent);



/***/ }),

/***/ "./src/app/components/slot-master/slot-master.component.css":
/*!******************************************************************!*\
  !*** ./src/app/components/slot-master/slot-master.component.css ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc2xvdC1tYXN0ZXIvc2xvdC1tYXN0ZXIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/slot-master/slot-master.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/components/slot-master/slot-master.component.ts ***!
  \*****************************************************************/
/*! exports provided: SlotMasterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SlotMasterComponent", function() { return SlotMasterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SlotMasterComponent = class SlotMasterComponent {
    constructor() {
        this.cities = [];
        this.centerMapURL = "";
        this.centerLat = "";
        this.centerLng = "";
        this.subjects = [];
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true
            },
            hideSubHeader: true,
            actions: {
                edit: false,
                position: "right"
            },
            columns: {
                city: {
                    title: "City"
                },
                name: {
                    title: "Course "
                }
            }
        };
    }
    submit() { }
    onDeleteConfirm(event) { }
    ngOnInit() { }
};
SlotMasterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-slot-master",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./slot-master.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slot-master/slot-master.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./slot-master.component.css */ "./src/app/components/slot-master/slot-master.component.css")).default]
    })
], SlotMasterComponent);



/***/ }),

/***/ "./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.css":
/*!************************************************************************************************************!*\
  !*** ./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.css ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3R1ZGVudC1zdWJzY3JpcHRpb24tZWRpdC1idXR0b24vc3R1ZGVudC1zdWJzY3JpcHRpb24tZWRpdC1idXR0b24uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.ts":
/*!***********************************************************************************************************!*\
  !*** ./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.ts ***!
  \***********************************************************************************************************/
/*! exports provided: StudentSubscriptionEditButtonComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StudentSubscriptionEditButtonComponent", function() { return StudentSubscriptionEditButtonComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let StudentSubscriptionEditButtonComponent = class StudentSubscriptionEditButtonComponent {
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
    }
    ngOnInit() { }
    view() {
        // alert(JSON.stringify(this.rowData));
        this.dataService.subscription.selectedStudentID = this.rowData.id;
        this.dataService.subscription.selectedStudentName = this.rowData.name;
        this.dataService.getStudentSubjects();
        this.dataService.getStudentTutorialViews(this.rowData.id);
    }
};
StudentSubscriptionEditButtonComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])("rowData")
], StudentSubscriptionEditButtonComponent.prototype, "rowData", void 0);
StudentSubscriptionEditButtonComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-student-subscription-edit-button",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./student-subscription-edit-button.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./student-subscription-edit-button.component.css */ "./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.css")).default]
    })
], StudentSubscriptionEditButtonComponent);



/***/ }),

/***/ "./src/app/components/student-subscription/student-subscription.component.css":
/*!************************************************************************************!*\
  !*** ./src/app/components/student-subscription/student-subscription.component.css ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3R1ZGVudC1zdWJzY3JpcHRpb24vc3R1ZGVudC1zdWJzY3JpcHRpb24uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/student-subscription/student-subscription.component.ts":
/*!***********************************************************************************!*\
  !*** ./src/app/components/student-subscription/student-subscription.component.ts ***!
  \***********************************************************************************/
/*! exports provided: StudentSubscriptionComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StudentSubscriptionComponent", function() { return StudentSubscriptionComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let StudentSubscriptionComponent = class StudentSubscriptionComponent {
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
        this.filteredSubjects = [];
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: true,
            actions: {
                edit: false,
                position: "right",
            },
            edit: {
                editButtonContent: '<i class="nb-edit"></i>',
                cancelButtonContent: '<i class="nb-close-circled"></i>',
                saveButtonContent: '<i class="nb-checkmark-circle"></i>',
                confirmSave: true,
            },
            editor: {},
            columns: {
                subcourseName: {
                    editable: false,
                    title: "Subcourse ",
                },
                subjectName: {
                    editable: false,
                    title: "Subject ",
                },
                expiry: {
                    title: "Expiry",
                },
            },
        };
        this.tutorialViewsSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: true,
            actions: {
                edit: false,
                position: "right",
            },
            edit: {
                editButtonContent: '<i class="nb-edit"></i>',
                cancelButtonContent: '<i class="nb-close-circled"></i>',
                saveButtonContent: '<i class="nb-checkmark-circle"></i>',
                confirmSave: true,
            },
            editor: {},
            columns: {
                tutorialName: {
                    title: "Tutorial ",
                },
                created_at: {
                    title: "Viewed At ",
                },
            },
        };
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    submit() {
        // alert(this.dataService.subscription.selectedStudentID)
        // alert(this.selectedSubjectID)
        // alert(this.expiryDate)
        this.http
            .post(this.dataService.serverUrl + "subscription", {
            subjectIDs: JSON.stringify([this.selectedSubjectID]),
            studentID: this.dataService.subscription.selectedStudentID,
            paymentID: "from panel",
            expiryDates: JSON.stringify([this.expiryDate]),
        })
            .subscribe((data) => {
            console.log("POST SUBSCRIPTION", data);
            //REFRESH DATA
            this.dataService.getStudentSubjects();
        }, (error) => {
            console.log("ERROR POST SUBSCRIPTION", error);
        });
    }
    onDeleteConfirm(event) {
        this.http
            .delete(this.dataService.serverUrl + "subscription/" + event.data.id)
            .subscribe((data) => {
            if (!data.status) {
                alert("Failed to Delete Record");
                return;
            }
            event.confirm.resolve();
        }, (error) => {
            alert("Connectino err");
            console.log(error);
            event.confirm.reject();
        });
    }
    deleteVideoView(event) {
        // console.log(event);
        // alert(event.data.id);
        this.http
            .delete(this.dataService.strapiServerUrl + "student-tutorials/" + event.data.id)
            .subscribe((data) => {
            // if (!data.status) {
            //   alert("Failed to Delete Record");
            //   return;
            // }
            event.confirm.resolve();
        }, (error) => {
            alert("Connectino err");
            console.log(error);
            event.confirm.reject();
        });
    }
    ngOnInit() { }
};
StudentSubscriptionComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
StudentSubscriptionComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-student-subscription",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./student-subscription.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/student-subscription/student-subscription.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./student-subscription.component.css */ "./src/app/components/student-subscription/student-subscription.component.css")).default]
    })
], StudentSubscriptionComponent);



/***/ }),

/***/ "./src/app/components/student/student.component.css":
/*!**********************************************************!*\
  !*** ./src/app/components/student/student.component.css ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3R1ZGVudC9zdHVkZW50LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/student/student.component.ts":
/*!*********************************************************!*\
  !*** ./src/app/components/student/student.component.ts ***!
  \*********************************************************/
/*! exports provided: StudentComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StudentComponent", function() { return StudentComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _student_subscription_edit_button_student_subscription_edit_button_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../student-subscription-edit-button/student-subscription-edit-button.component */ "./src/app/components/student-subscription-edit-button/student-subscription-edit-button.component.ts");





let StudentComponent = class StudentComponent {
    constructor(http, ds) {
        this.http = http;
        this.ds = ds;
        this.students = [];
        this.studentSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: false,
            actions: {
                columnTitle: "",
                add: false,
                delete: false,
                edit: false,
                position: "right",
            },
            columns: {
                name: {
                    title: "Student Name",
                },
                phone: {
                    title: "Phone",
                },
                parentPhone: {
                    title: "Parents Phone",
                },
                wantCourse: {
                    title: "Course Interested",
                },
                video_views: {
                    title: "Views",
                },
                // city: {
                //   title: "City",
                // },
                // views: {
                //   filter: false,
                //   type: "custom",
                //   title: "",
                //   renderComponent: ViewButtonComponent,
                // },
                subscription: {
                    filter: false,
                    type: "custom",
                    title: "",
                    renderComponent: _student_subscription_edit_button_student_subscription_edit_button_component__WEBPACK_IMPORTED_MODULE_4__["StudentSubscriptionEditButtonComponent"],
                },
            },
        };
        this.getStudents();
    }
    deleteData(abc) { }
    getStudents() {
        this.http.get(this.ds.serverUrl + "student").subscribe((data) => {
            console.log("GET STUDNETS ", data);
            this.students = data.data;
        });
    }
    ngOnInit() { }
};
StudentComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] }
];
StudentComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-student",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./student.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/student/student.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./student.component.css */ "./src/app/components/student/student.component.css")).default]
    })
], StudentComponent);



/***/ }),

/***/ "./src/app/components/student/view-button/view-button.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/components/student/view-button/view-button.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3R1ZGVudC92aWV3LWJ1dHRvbi92aWV3LWJ1dHRvbi5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/student/view-button/view-button.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/student/view-button/view-button.component.ts ***!
  \*************************************************************************/
/*! exports provided: ViewButtonComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewButtonComponent", function() { return ViewButtonComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




let ViewButtonComponent = class ViewButtonComponent {
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
    }
    ngOnInit() { }
    view() {
        // alert(JSON.stringify(this.rowData));
        this.dataService.subscription.selectedStudentID = this.rowData.id;
        this.dataService.subscription.selectedStudentName = this.rowData.name;
        this.dataService.getStudentSubjects();
    }
};
ViewButtonComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Input"])("rowData")
], ViewButtonComponent.prototype, "rowData", void 0);
ViewButtonComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: "app-view-button",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./view-button.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/student/view-button/view-button.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./view-button.component.css */ "./src/app/components/student/view-button/view-button.component.css")).default]
    })
], ViewButtonComponent);



/***/ }),

/***/ "./src/app/components/subject-master/subject-master.component.css":
/*!************************************************************************!*\
  !*** ./src/app/components/subject-master/subject-master.component.css ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3ViamVjdC1tYXN0ZXIvc3ViamVjdC1tYXN0ZXIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/subject-master/subject-master.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/subject-master/subject-master.component.ts ***!
  \***********************************************************************/
/*! exports provided: SubjectMasterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubjectMasterComponent", function() { return SubjectMasterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SubjectMasterComponent = class SubjectMasterComponent {
    constructor() { }
    ngOnInit() {
    }
};
SubjectMasterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-subject-master',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./subject-master.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/subject-master/subject-master.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./subject-master.component.css */ "./src/app/components/subject-master/subject-master.component.css")).default]
    })
], SubjectMasterComponent);



/***/ }),

/***/ "./src/app/components/upload-report-button/upload-report-button.component.css":
/*!************************************************************************************!*\
  !*** ./src/app/components/upload-report-button/upload-report-button.component.css ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdXBsb2FkLXJlcG9ydC1idXR0b24vdXBsb2FkLXJlcG9ydC1idXR0b24uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/components/upload-report-button/upload-report-button.component.ts":
/*!***********************************************************************************!*\
  !*** ./src/app/components/upload-report-button/upload-report-button.component.ts ***!
  \***********************************************************************************/
/*! exports provided: UploadReportButtonComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UploadReportButtonComponent", function() { return UploadReportButtonComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");





let UploadReportButtonComponent = class UploadReportButtonComponent {
    constructor(dataService, fb, http) {
        this.dataService = dataService;
        this.fb = fb;
        this.http = http;
        this.filesToUpload = [];
        console.log(this.rowData);
    }
    ngOnInit() {
    }
    // onFileChange(event) {
    //   let reader = new FileReader();
    //   if (event.target.files && event.target.files.length > 0) {
    //     let file = event.target.files[0];
    //     reader.readAsDataURL(file);
    //     reader.onload = () => {
    //       this.form.get('avatar').setValue({
    //         filename: file.name,
    //         filetype: file.type,
    //         value: reader.result.split(',')[1]
    //       })
    //     };
    //   }
    // }
    postMethod(files) {
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append('file', this.fileToUpload, `${this.rowData.id}.pdf`);
        formData.append('abc', "def");
        this.http.post(this.dataService.serverUrl + "report/upload", formData).subscribe((val) => {
            console.log(val);
            if (val.status) {
                alert("Report Uploaded !");
                return;
            }
            alert("Failed to Upload Report  !");
        });
        return false;
    }
};
UploadReportButtonComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("uploadForm", { static: false })
], UploadReportButtonComponent.prototype, "uploadForm", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], UploadReportButtonComponent.prototype, "rowData", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('fileInput', { static: false })
], UploadReportButtonComponent.prototype, "fileInput", void 0);
UploadReportButtonComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-upload-report-button',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./upload-report-button.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/upload-report-button/upload-report-button.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./upload-report-button.component.css */ "./src/app/components/upload-report-button/upload-report-button.component.css")).default]
    })
], UploadReportButtonComponent);



/***/ }),

/***/ "./src/app/components/upload-solution-csv/upload-solution-csv.component.css":
/*!**********************************************************************************!*\
  !*** ./src/app/components/upload-solution-csv/upload-solution-csv.component.css ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdXBsb2FkLXNvbHV0aW9uLWNzdi91cGxvYWQtc29sdXRpb24tY3N2LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/upload-solution-csv/upload-solution-csv.component.ts":
/*!*********************************************************************************!*\
  !*** ./src/app/components/upload-solution-csv/upload-solution-csv.component.ts ***!
  \*********************************************************************************/
/*! exports provided: UploadSolutionCSVComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UploadSolutionCSVComponent", function() { return UploadSolutionCSVComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");





let UploadSolutionCSVComponent = class UploadSolutionCSVComponent {
    constructor(dataService, fb, http) {
        this.dataService = dataService;
        this.fb = fb;
        this.http = http;
        this.numberOfQuestions = 0;
        console.log(this.rowData);
    }
    add() {
        this.http.post(this.dataService.serverUrl + "solution/numberOfQuestions", { numberOfQuestions: this.numberOfQuestions, testID: this.rowData.id }).subscribe((val) => {
            console.log(val);
            if (val.status) {
                alert("Question Added  !");
                return;
            }
            alert("Error updating the question number !");
        }, (error => {
            alert("Error updating the question number");
            console.log(error);
        }));
        return false;
    }
    ngOnInit() {
    }
    // onFileChange(event) {
    //   let reader = new FileReader();
    //   if (event.target.files && event.target.files.length > 0) {
    //     let file = event.target.files[0];
    //     reader.readAsDataURL(file);
    //     reader.onload = () => {
    //       this.form.get('avatar').setValue({
    //         filename: file.name,
    //         filetype: file.type,
    //         value: reader.result.split(',')[1]
    //       })
    //     };
    //   }
    // }
    // postMethod(files: FileList) {
    //   this.fileToUpload = files.item(0);
    //   let formData = new FormData();
    //   console.log(files);
    //   formData.append('file', this.fileToUpload, `${this.rowData.id}.csv`);
    //   // formData.append('abc', "def");
    //   // upload the csv solution
    //   this.http.post(this.dataService.serverUrl + "solution/upload", formData).subscribe((val: any) => {
    //     console.log(val);
    //     if (val.status) {
    //       alert("CSV Uploaded !");
    //       return
    //     }
    //     alert("Failed to Upload CSV  !")
    //   }, (error => {
    //     alert("Failed to Upload Error, Server Problem. Please contact the developer")
    //   }));
    //   return false;
    // }
    upload() {
        // alert("sadf")
        console.log(this.uploadForm);
        this.uploadForm.nativeElement.submit();
    }
};
UploadSolutionCSVComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("uploadForm", { static: false })
], UploadSolutionCSVComponent.prototype, "uploadForm", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], UploadSolutionCSVComponent.prototype, "rowData", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('fileInput', { static: false })
], UploadSolutionCSVComponent.prototype, "fileInput", void 0);
UploadSolutionCSVComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-upload-solution-csv',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./upload-solution-csv.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/upload-solution-csv/upload-solution-csv.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./upload-solution-csv.component.css */ "./src/app/components/upload-solution-csv/upload-solution-csv.component.css")).default]
    })
], UploadSolutionCSVComponent);



/***/ }),

/***/ "./src/app/components/uploads/uploads.component.css":
/*!**********************************************************!*\
  !*** ./src/app/components/uploads/uploads.component.css ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdXBsb2Fkcy91cGxvYWRzLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/uploads/uploads.component.ts":
/*!*********************************************************!*\
  !*** ./src/app/components/uploads/uploads.component.ts ***!
  \*********************************************************/
/*! exports provided: UploadsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UploadsComponent", function() { return UploadsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../view-library-pdf/view-library-pdf.component */ "./src/app/components/view-library-pdf/view-library-pdf.component.ts");
/* harmony import */ var _view_video_view_video_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../view-video/view-video.component */ "./src/app/components/view-video/view-video.component.ts");






let UploadsComponent = class UploadsComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.filteredSubjects = [];
        this.filteredChapters = [];
        this.pdfs = [];
        this.videos = [];
        this.videoTitle = "";
        this.youtubeLink = "";
        this.noteTitle = "";
        this.notes = [];
        this.slidersTestimonial = [];
        this.slidersVideo = [];
        this.pdfSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                subjectName: {
                    title: "Subject Name",
                },
                chapterName: {
                    title: "Chapter Name",
                },
                name: {
                    title: "Pdf Title",
                },
                sliderImage: {
                    title: "View Pdf",
                    type: "custom",
                    renderComponent: _view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_4__["ViewLibraryPdfComponent"],
                },
            },
        };
        this.videoSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                title: {
                    title: "Video Title",
                },
                sliderImage: {
                    title: "Link Video",
                    type: "custom",
                    renderComponent: _view_video_view_video_component__WEBPACK_IMPORTED_MODULE_5__["ViewVideoComponent"],
                },
            },
        };
        this.getPdfs();
        this.getVideos();
    }
    pdfFileSelected(files) {
        this.pdfFile = files;
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    getFilteredChapters() {
        this.http
            .get(this.dataService.serverUrl + "chapter", {
            params: { subjectID: this.selectedSubjectID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED CHAPTER :", data);
            this.filteredChapters = data.data;
        });
    }
    ngOnInit() { }
    // postMethod(files: FileList) {
    uploadPdf() {
        console.log(this.pdfFile);
        this.fileToUpload = this.pdfFile.item(0);
        // this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        formData.append("pdfTitle", this.pdfTitle);
        formData.append("chapterID", this.selectedChapterID);
        this.http
            .post(this.dataService.serverUrl + "library", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload slider");
            }
            else {
                this.getPdfs();
            }
        });
        return false;
    }
    getPdfs() {
        this.http
            .get(this.dataService.serverUrl + "library")
            .toPromise()
            .then((data) => {
            console.log("GET LIBRARY", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.pdfs = data.data;
            // this.sliders = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getVideos() {
        this.http
            .get(this.dataService.serverUrl + "video")
            .toPromise()
            .then((data) => {
            console.log("GET VIDEO", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.videos = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    addVideo() {
        // alert("asdf");
        this.http
            .post(this.dataService.serverUrl + "video", {
            chapterID: this.selectedChapterID,
            youtubeLink: this.youtubeLink,
            title: this.videoTitle,
        })
            .subscribe((data) => {
            console.log("POST LIBRARY", data);
            this.getVideos();
        }, (error) => {
            alert("Error Adding Video");
        });
    }
    deleteData(event, endpoint = 'library') {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + `${endpoint}/` + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    switch (endpoint) {
                        case 'library':
                            this.getPdfs();
                            break;
                        case 'video':
                            this.getVideos();
                            break;
                        default:
                            break;
                    }
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the slider");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
UploadsComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] }
];
UploadsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-uploads",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./uploads.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/uploads/uploads.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./uploads.component.css */ "./src/app/components/uploads/uploads.component.css")).default]
    })
], UploadsComponent);



/***/ }),

/***/ "./src/app/components/video-upload/video-upload.component.css":
/*!********************************************************************!*\
  !*** ./src/app/components/video-upload/video-upload.component.css ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdmlkZW8tdXBsb2FkL3ZpZGVvLXVwbG9hZC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/video-upload/video-upload.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/video-upload/video-upload.component.ts ***!
  \*******************************************************************/
/*! exports provided: VideoUploadComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VideoUploadComponent", function() { return VideoUploadComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");





let VideoUploadComponent = class VideoUploadComponent {
    constructor(dataService, fb, http) {
        this.dataService = dataService;
        this.fb = fb;
        this.http = http;
        this.filesToUpload = [];
        console.log(this.rowData);
    }
    ngOnInit() {
    }
    // onFileChange(event) {
    //   let reader = new FileReader();
    //   if (event.target.files && event.target.files.length > 0) {
    //     let file = event.target.files[0];
    //     reader.readAsDataURL(file);
    //     reader.onload = () => {
    //       this.form.get('avatar').setValue({
    //         filename: file.name,
    //         filetype: file.type,
    //         value: reader.result.split(',')[1]
    //       })
    //     };
    //   }
    // }
    postMethod(files) {
        console.log(this.rowData);
        this.fileToUpload = files.item(0);
        const formData = new FormData();
        formData.append('file', this.fileToUpload, `${this.rowData.id}.mp4`);
        // formData.append('abc', "def");
        this.http.post(this.dataService.serverUrl + "video/upload", formData).subscribe((val) => {
            console.log(val);
            if (val.status) {
                alert("Video Solution Uploaded !");
                return;
            }
            alert("Failed to Upload Video Solution !");
        });
        return false;
    }
    upload() {
        // alert("sadf")
        console.log(this.uploadForm);
        this.uploadForm.nativeElement.submit();
    }
};
VideoUploadComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("uploadForm", { static: false })
], VideoUploadComponent.prototype, "uploadForm", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], VideoUploadComponent.prototype, "rowData", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('fileInput', { static: false })
], VideoUploadComponent.prototype, "fileInput", void 0);
VideoUploadComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-video-upload',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./video-upload.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/video-upload/video-upload.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./video-upload.component.css */ "./src/app/components/video-upload/video-upload.component.css")).default]
    })
], VideoUploadComponent);



/***/ }),

/***/ "./src/app/components/view-library-pdf/view-library-pdf.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/components/view-library-pdf/view-library-pdf.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdmlldy1saWJyYXJ5LXBkZi92aWV3LWxpYnJhcnktcGRmLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/view-library-pdf/view-library-pdf.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/components/view-library-pdf/view-library-pdf.component.ts ***!
  \***************************************************************************/
/*! exports provided: ViewLibraryPdfComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewLibraryPdfComponent", function() { return ViewLibraryPdfComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");



let ViewLibraryPdfComponent = class ViewLibraryPdfComponent {
    constructor(dataService) {
        this.dataService = dataService;
    }
    ngOnInit() {
        // if (this.rowData.source == 'important')
        //   this.url = this.dataService.serverUrl + 'uploads/important/' + this.rowData.name
        // else
        this.url = this.dataService.serverUrl + `uploads/${this.rowData.source}/` + this.rowData.name;
    }
};
ViewLibraryPdfComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ViewLibraryPdfComponent.prototype, "rowData", void 0);
ViewLibraryPdfComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-view-library-pdf',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./view-library-pdf.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-library-pdf/view-library-pdf.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./view-library-pdf.component.css */ "./src/app/components/view-library-pdf/view-library-pdf.component.css")).default]
    })
], ViewLibraryPdfComponent);



/***/ }),

/***/ "./src/app/components/view-report-button-component/view-report-button-component.component.css":
/*!****************************************************************************************************!*\
  !*** ./src/app/components/view-report-button-component/view-report-button-component.component.css ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdmlldy1yZXBvcnQtYnV0dG9uLWNvbXBvbmVudC92aWV3LXJlcG9ydC1idXR0b24tY29tcG9uZW50LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/view-report-button-component/view-report-button-component.component.ts":
/*!***************************************************************************************************!*\
  !*** ./src/app/components/view-report-button-component/view-report-button-component.component.ts ***!
  \***************************************************************************************************/
/*! exports provided: ViewReportButtonComponentComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewReportButtonComponentComponent", function() { return ViewReportButtonComponentComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");



let ViewReportButtonComponentComponent = class ViewReportButtonComponentComponent {
    constructor(dataService) {
        this.dataService = dataService;
    }
    // @Output() save: EventEmitter<any> = new EventEmitter();
    ngOnInit() {
        // this.renderValue = this.value.toString().toUpperCase();
        console.log(this.rowData);
    }
    viewStudents() {
        // alert(this.rowData.id)
        // this
        // this.dataService.report.testSelected = this.rowData.id
        this.dataService.report.testSelected.emit(this.rowData.id);
    }
};
ViewReportButtonComponentComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ViewReportButtonComponentComponent.prototype, "rowData", void 0);
ViewReportButtonComponentComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-view-report-button-component',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./view-report-button-component.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-report-button-component/view-report-button-component.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./view-report-button-component.component.css */ "./src/app/components/view-report-button-component/view-report-button-component.component.css")).default]
    })
], ViewReportButtonComponentComponent);



/***/ }),

/***/ "./src/app/components/view-video/view-video.component.css":
/*!****************************************************************!*\
  !*** ./src/app/components/view-video/view-video.component.css ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdmlldy12aWRlby92aWV3LXZpZGVvLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/components/view-video/view-video.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/components/view-video/view-video.component.ts ***!
  \***************************************************************/
/*! exports provided: ViewVideoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewVideoComponent", function() { return ViewVideoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ViewVideoComponent = class ViewVideoComponent {
    constructor() { }
    ngOnInit() {
        this.youtubeLink = this.rowData.youtubeLink;
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ViewVideoComponent.prototype, "rowData", void 0);
ViewVideoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-view-video',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./view-video.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/view-video/view-video.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./view-video.component.css */ "./src/app/components/view-video/view-video.component.css")).default]
    })
], ViewVideoComponent);



/***/ }),

/***/ "./src/app/important-questions/important-questions.component.css":
/*!***********************************************************************!*\
  !*** ./src/app/important-questions/important-questions.component.css ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2ltcG9ydGFudC1xdWVzdGlvbnMvaW1wb3J0YW50LXF1ZXN0aW9ucy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/important-questions/important-questions.component.ts":
/*!**********************************************************************!*\
  !*** ./src/app/important-questions/important-questions.component.ts ***!
  \**********************************************************************/
/*! exports provided: ImportantQuestionsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImportantQuestionsComponent", function() { return ImportantQuestionsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../components/view-library-pdf/view-library-pdf.component */ "./src/app/components/view-library-pdf/view-library-pdf.component.ts");





let ImportantQuestionsComponent = class ImportantQuestionsComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.filteredSubjects = [];
        this.filteredChapters = [];
        this.pdfs = [];
        this.videos = [];
        this.videoTitle = "";
        this.youtubeLink = "";
        this.noteTitle = "";
        this.notes = [];
        this.slidersTestimonial = [];
        this.slidersVideo = [];
        this.pdfSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                subjectName: {
                    title: "Subject Name",
                },
                chapterName: {
                    title: "Chapter Name",
                },
                name: {
                    title: "Pdf Title",
                },
                sliderImage: {
                    title: "View Pdf",
                    type: "custom",
                    renderComponent: _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_4__["ViewLibraryPdfComponent"],
                },
            },
        };
        this.videoSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                title: {
                    title: "Video Title",
                },
                sliderImage: {
                    title: "Link Video",
                    type: "custom",
                },
            },
        };
        this.getPdfs();
        this.getVideos();
    }
    pdfFileSelected(files) {
        this.pdfFile = files;
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    getFilteredChapters() {
        this.http
            .get(this.dataService.serverUrl + "chapter", {
            params: { subjectID: this.selectedSubjectID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED CHAPTER :", data);
            this.filteredChapters = data.data;
        });
    }
    ngOnInit() { }
    // postMethod(files: FileList) {
    uploadPdf() {
        console.log(this.pdfFile);
        this.fileToUpload = this.pdfFile.item(0);
        // this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        formData.append("pdfTitle", this.pdfTitle);
        formData.append("chapterID", this.selectedChapterID);
        this.http
            .post(this.dataService.serverUrl + "important", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload slider");
            }
            else {
                this.getPdfs();
            }
        });
        return false;
    }
    getPdfs() {
        this.http
            .get(this.dataService.serverUrl + "important")
            .toPromise()
            .then((data) => {
            console.log("GET important questions", data);
            if (!data.status) {
                alert("Error getting important questions");
                return;
            }
            this.pdfs = data.data;
            // this.sliders = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getVideos() {
        this.http
            .get(this.dataService.serverUrl + "video")
            .toPromise()
            .then((data) => {
            console.log("GET VIDEO", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.videos = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    addVideo() {
        // alert("asdf");
        this.http
            .post(this.dataService.serverUrl + "video", {
            chapterID: this.selectedChapterID,
            youtubeLink: this.youtubeLink,
            title: this.videoTitle,
        })
            .subscribe((data) => {
            console.log("POST important", data);
            this.getVideos();
        }, (error) => {
            alert("Error Adding Video");
        });
    }
    deleteData(event, endpoint = 'important') {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + `${endpoint}/` + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    this.getPdfs();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the slider");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
ImportantQuestionsComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
ImportantQuestionsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-important-questions',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./important-questions.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/important-questions/important-questions.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./important-questions.component.css */ "./src/app/important-questions/important-questions.component.css")).default]
    })
], ImportantQuestionsComponent);



/***/ }),

/***/ "./src/app/masters/free-notes/free-notes.component.css":
/*!*************************************************************!*\
  !*** ./src/app/masters/free-notes/free-notes.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21hc3RlcnMvZnJlZS1ub3Rlcy9mcmVlLW5vdGVzLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/masters/free-notes/free-notes.component.ts":
/*!************************************************************!*\
  !*** ./src/app/masters/free-notes/free-notes.component.ts ***!
  \************************************************************/
/*! exports provided: FreeNotesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FreeNotesComponent", function() { return FreeNotesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_components_slider_image_slider_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/components/slider-image/slider-image.component */ "./src/app/components/slider-image/slider-image.component.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var src_app_components_slider_thumbnail_slider_thumbnail_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/components/slider-thumbnail/slider-thumbnail.component */ "./src/app/components/slider-thumbnail/slider-thumbnail.component.ts");
/* harmony import */ var src_app_components_slider_video_slider_video_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/components/slider-video/slider-video.component */ "./src/app/components/slider-video/slider-video.component.ts");
/* harmony import */ var src_app_components_revision_note_component_revision_note_component_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/components/revision-note-component/revision-note-component.component */ "./src/app/components/revision-note-component/revision-note-component.component.ts");








let FreeNotesComponent = class FreeNotesComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.youtubeLink = "";
        this.noteTitle = "";
        this.notes = [];
        this.data = [];
        this.slidersTestimonial = [];
        this.slidersVideo = [];
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            add: {
                addButtonContent: "",
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                sliderImage: {
                    title: "Slider Image",
                    type: "custom",
                    renderComponent: src_app_components_slider_image_slider_image_component__WEBPACK_IMPORTED_MODULE_2__["SliderImageComponent"],
                },
            },
        };
        this.settingsNotes = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            add: {
                addButtonContent: "",
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                title: {
                    title: "Tittle",
                },
                sliderImage: {
                    title: "Slider Image",
                    type: "custom",
                    renderComponent: src_app_components_revision_note_component_revision_note_component_component__WEBPACK_IMPORTED_MODULE_7__["RevisionNoteComponentComponent"],
                },
            },
        };
        this.settingsVideo = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            add: {
                addButtonContent: "",
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                thumbnail: {
                    title: "Thumbnail Image (.png)",
                    type: "custom",
                    renderComponent: src_app_components_slider_thumbnail_slider_thumbnail_component__WEBPACK_IMPORTED_MODULE_5__["SliderThumbnailComponent"],
                },
                video: {
                    title: "Youtube Link ",
                    type: "custom",
                    renderComponent: src_app_components_slider_video_slider_video_component__WEBPACK_IMPORTED_MODULE_6__["SliderVideoComponent"],
                },
            },
        };
        this.getFreeNotes();
        // this.getSliderVideos();
        // this.getSlidersTestimonials();
        // this.getNotes();
    }
    ngOnInit() { }
    postMethod(files) {
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        this.http
            .post(this.dataService.serverUrl + "freeNotes", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload slider");
            }
            else {
                this.getFreeNotes();
            }
        });
        return false;
    }
    postMethodTestimonial(files) {
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        this.http
            .post(this.dataService.serverUrl + "slider/uploadImageTestimonial", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload slider");
            }
            else {
                this.getSlidersTestimonials();
            }
        });
        return false;
    }
    postMethodVideo(files) {
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        formData.append("youtubeLink", this.youtubeLink);
        this.http
            .post(this.dataService.serverUrl + "slider/uploadVideo", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload video");
            }
            else {
                this.getSliderVideos();
            }
        });
        return false;
    }
    getFreeNotes() {
        this.http
            .get(this.dataService.serverUrl + "freeNotes")
            .toPromise()
            .then((data) => {
            console.log("slider images", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.data = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getNotes() {
        this.http
            .get(this.dataService.serverUrl + "note")
            .toPromise()
            .then((data) => {
            console.log("get note response ", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.notes = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getSlidersTestimonials() {
        this.http
            .get(this.dataService.serverUrl + "slider/testimonial")
            .toPromise()
            .then((data) => {
            console.log("slider images", data);
            if (!data.status) {
                alert("Error getting testimonial");
                return;
            }
            this.slidersTestimonial = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getSliderVideos() {
        this.http
            .get(this.dataService.serverUrl + "freeNotes")
            .toPromise()
            .then((data) => {
            console.log("slider videos", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.slidersVideo = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    onDeleteConfirm(event, deleteRevisionNote = false) {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + `freeNotes/` + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    this.getFreeNotes();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the slider");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
FreeNotesComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"] }
];
FreeNotesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-free-notes",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./free-notes.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/masters/free-notes/free-notes.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./free-notes.component.css */ "./src/app/masters/free-notes/free-notes.component.css")).default]
    })
], FreeNotesComponent);



/***/ }),

/***/ "./src/app/masters/free-videos/free-videos.component.css":
/*!***************************************************************!*\
  !*** ./src/app/masters/free-videos/free-videos.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21hc3RlcnMvZnJlZS12aWRlb3MvZnJlZS12aWRlb3MuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/masters/free-videos/free-videos.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/masters/free-videos/free-videos.component.ts ***!
  \**************************************************************/
/*! exports provided: FreeVideosComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FreeVideosComponent", function() { return FreeVideosComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




let FreeVideosComponent = class FreeVideosComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.videoSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                name: {
                    title: "Video Name",
                },
                youtubeLink: {
                    title: "Video Link",
                },
            },
        };
        this.data = [];
        this.name = "";
        this.youtubeLink = "";
        this.getVideos();
    }
    ngOnInit() { }
    postVideo() {
        this.http
            .post(this.dataService.serverUrl + "freeVideos", {
            name: this.name,
            youtubeLink: this.youtubeLink,
        })
            .subscribe((data) => {
            console.log("POST FREE VIDEO", data);
            this.getVideos();
        });
    }
    getVideos() {
        this.http
            .get(this.dataService.serverUrl + "freeVideos")
            .subscribe((data) => {
            console.log("GET FREE VIDEOS", data);
            this.data = data.data;
        });
    }
    deleteVideo(event) {
        console.log(event);
        this.http
            .delete(this.dataService.serverUrl + "freeVideos/" + event.data.id)
            .subscribe((data) => {
            console.log("DELETE FREE VIDEOS", data);
            this.getVideos();
        });
    }
};
FreeVideosComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] }
];
FreeVideosComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: "app-free-videos",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./free-videos.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/masters/free-videos/free-videos.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./free-videos.component.css */ "./src/app/masters/free-videos/free-videos.component.css")).default]
    })
], FreeVideosComponent);



/***/ }),

/***/ "./src/app/masters/masters.component.css":
/*!***********************************************!*\
  !*** ./src/app/masters/masters.component.css ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21hc3RlcnMvbWFzdGVycy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/masters/masters.component.ts":
/*!**********************************************!*\
  !*** ./src/app/masters/masters.component.ts ***!
  \**********************************************/
/*! exports provided: MastersComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MastersComponent", function() { return MastersComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let MastersComponent = class MastersComponent {
    constructor() { }
    ngOnInit() {
    }
};
MastersComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-masters',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./masters.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/masters/masters.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./masters.component.css */ "./src/app/masters/masters.component.css")).default]
    })
], MastersComponent);



/***/ }),

/***/ "./src/app/pages/city/city.component.css":
/*!***********************************************!*\
  !*** ./src/app/pages/city/city.component.css ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".ng2-smart-title {\n  text-align: center !important;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvY2l0eS9jaXR5LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSw2QkFBNkI7QUFDL0IiLCJmaWxlIjoic3JjL2FwcC9wYWdlcy9jaXR5L2NpdHkuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5uZzItc21hcnQtdGl0bGUge1xuICB0ZXh0LWFsaWduOiBjZW50ZXIgIWltcG9ydGFudDtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/pages/city/city.component.ts":
/*!**********************************************!*\
  !*** ./src/app/pages/city/city.component.ts ***!
  \**********************************************/
/*! exports provided: CityComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CityComponent", function() { return CityComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let CityComponent = class CityComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.cities = this.dataService.cities;
        this.city = "";
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true
            },
            add: {
                addButtonContent: ""
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right"
            },
            columns: {
                city: {
                    title: "City Name"
                }
            }
        };
        this.getCities();
    }
    onDeleteConfirm(event) {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + "city/" + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    this.getCities();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the city");
            })
                .catch(err => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
    getCities() {
        this.http
            .get(this.dataService.serverUrl + "city", {})
            .toPromise()
            .then((data) => {
            console.log(data);
            this.dataService.cities = data;
            // console.log(this.cities);
            this.cities = this.dataService.cities;
            this.dataService.citiesUpdated.emit();
        })
            .catch(err => {
            alert("Connection Error");
            console.log(err);
        });
    }
    submitCity() {
        console.log("submitting");
        this.http
            .post(this.dataService.serverUrl + "city", { city: this.city })
            .toPromise()
            .then((data) => {
            console.log(data);
            if (data.status === "success") {
                this.getCities();
            }
        })
            .catch(err => {
            alert("Connection Error");
            console.log(err);
        });
    }
    ngOnInit() { }
};
CityComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
CityComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-city",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./city.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/city/city.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./city.component.css */ "./src/app/pages/city/city.component.css")).default]
    })
], CityComponent);



/***/ }),

/***/ "./src/app/pages/course/course.component.css":
/*!***************************************************!*\
  !*** ./src/app/pages/course/course.component.css ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table,\nth,\ntd {\n  border: 1px solid rgb(180, 180, 180);\n  border-collapse: collapse;\n  padding: 8px\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvY291cnNlL2NvdXJzZS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7RUFHRSxvQ0FBb0M7RUFDcEMseUJBQXlCO0VBQ3pCO0FBQ0YiLCJmaWxlIjoic3JjL2FwcC9wYWdlcy9jb3Vyc2UvY291cnNlLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJ0YWJsZSxcbnRoLFxudGQge1xuICBib3JkZXI6IDFweCBzb2xpZCByZ2IoMTgwLCAxODAsIDE4MCk7XG4gIGJvcmRlci1jb2xsYXBzZTogY29sbGFwc2U7XG4gIHBhZGRpbmc6IDhweFxufVxuIl19 */");

/***/ }),

/***/ "./src/app/pages/course/course.component.ts":
/*!**************************************************!*\
  !*** ./src/app/pages/course/course.component.ts ***!
  \**************************************************/
/*! exports provided: CourseComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CourseComponent", function() { return CourseComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let CourseComponent = class CourseComponent {
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
        this.course = "";
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                name: {
                    title: "Course Name",
                },
            },
        };
    }
    ngOnInit() { }
    submitCourse() {
        this.http
            .post(this.dataService.serverUrl + "course", { course: this.course })
            .toPromise()
            .then((data) => {
            console.log("POST COURSE : ", data);
            if (data.status) {
                this.dataService.getCourses();
            }
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    onDeleteConfirm(event) {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + "course/" + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    this.dataService.getCourses();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the course");
            })
                .catch((err) => {
                alert("Connection Error");
                event.confirm.reject();
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
CourseComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
CourseComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-course",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./course.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/course/course.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./course.component.css */ "./src/app/pages/course/course.component.css")).default]
    })
], CourseComponent);



/***/ }),

/***/ "./src/app/pages/create-test/create-test.component.css":
/*!*************************************************************!*\
  !*** ./src/app/pages/create-test/create-test.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2NyZWF0ZS10ZXN0L2NyZWF0ZS10ZXN0LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/create-test/create-test.component.ts":
/*!************************************************************!*\
  !*** ./src/app/pages/create-test/create-test.component.ts ***!
  \************************************************************/
/*! exports provided: CreateTestComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateTestComponent", function() { return CreateTestComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CreateTestComponent = class CreateTestComponent {
    constructor() { }
    ngOnInit() {
    }
};
CreateTestComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-create-test',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./create-test.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/create-test/create-test.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./create-test.component.css */ "./src/app/pages/create-test/create-test.component.css")).default]
    })
], CreateTestComponent);



/***/ }),

/***/ "./src/app/pages/dashboard/dashboard.component.css":
/*!*********************************************************!*\
  !*** ./src/app/pages/dashboard/dashboard.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2Rhc2hib2FyZC9kYXNoYm9hcmQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/pages/dashboard/dashboard.component.ts":
/*!********************************************************!*\
  !*** ./src/app/pages/dashboard/dashboard.component.ts ***!
  \********************************************************/
/*! exports provided: DashboardComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DashboardComponent", function() { return DashboardComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DashboardComponent = class DashboardComponent {
    constructor() {
        this.items = [
            {
                title: "Masters",
                icon: "edit-2",
                link: "masters",
            },
            {
                title: "Uploads",
                icon: "image-outline",
                link: "uploads",
            },
            // {
            //   title: "Students",
            //   icon: "file-text-outline",
            //   link: "report",
            // },
            // {
            //   title: "Upload Solution",
            //   icon: "checkmark-square-outline",
            //   link: "solution",
            // },
            // {
            //   title: "Publish Result",
            //   icon: "trending-up-outline",
            //   link: "result",
            // },
            // {
            //   title: "Change Password",
            //   icon: "lock-outline",
            //   // link: []
            // },
            {
                title: "Logout",
                icon: "corner-down-left-outline",
                link: "../",
            },
        ];
    }
    ngOnInit() { }
};
DashboardComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-dashboard",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dashboard.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/dashboard/dashboard.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dashboard.component.css */ "./src/app/pages/dashboard/dashboard.component.css")).default]
    })
], DashboardComponent);



/***/ }),

/***/ "./src/app/pages/home/home.component.css":
/*!***********************************************!*\
  !*** ./src/app/pages/home/home.component.css ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2hvbWUvaG9tZS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/pages/home/home.component.ts":
/*!**********************************************!*\
  !*** ./src/app/pages/home/home.component.ts ***!
  \**********************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HomeComponent = class HomeComponent {
    constructor() { }
    ngOnInit() {
    }
};
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.css */ "./src/app/pages/home/home.component.css")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/app/pages/login/login.component.css":
/*!*************************************************!*\
  !*** ./src/app/pages/login/login.component.css ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("@import url(https://fonts.googleapis.com/css?family=Roboto:300);\n\n.login-page {\n  width: 360px;\n  padding: 8% 0 0;\n  margin: auto;\n}\n\n.form {\n  position: relative;\n  z-index: 1;\n  background: #FFFFFF;\n  max-width: 360px;\n  margin: 0 auto 100px;\n  padding: 45px;\n  text-align: center;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);\n}\n\n.form input {\n  font-family: \"Roboto\", sans-serif;\n  outline: 0;\n  background: #f2f2f2;\n  width: 100%;\n  border: 0;\n  margin: 0 0 15px;\n  padding: 15px;\n  box-sizing: border-box;\n  font-size: 14px;\n}\n\n.form button {\n  font-family: \"Roboto\", sans-serif;\n  text-transform: uppercase;\n  outline: 0;\n  background: #304972;\n  /* background: #4CAF50; */\n  width: 100%;\n  border: 0;\n  padding: 15px;\n  color: #FFFFFF;\n  font-size: 14px;\n  transition: all 0.3 ease;\n  cursor: pointer;\n}\n\n.form button:hover,\n.form button:active,\n.form button:focus {\n  background: #304972;\n}\n\n.form .message {\n  margin: 15px 0 0;\n  color: #b3b3b3;\n  font-size: 12px;\n}\n\n.form .message a {\n  color: #4CAF50;\n  text-decoration: none;\n}\n\n.form .register-form {\n  display: none;\n}\n\n.container {\n  position: relative;\n  z-index: 1;\n  max-width: 300px;\n  margin: 0 auto;\n}\n\n.container:before,\n.container:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.container .info {\n  margin: 50px auto;\n  text-align: center;\n}\n\n.container .info h1 {\n  margin: 0 0 15px;\n  padding: 0;\n  font-size: 36px;\n  font-weight: 300;\n  color: #1a1a1a;\n}\n\n.container .info span {\n  color: #4d4d4d;\n  font-size: 12px;\n}\n\n.container .info span a {\n  color: #000000;\n  text-decoration: none;\n}\n\n.container .info span .fa {\n  color: #EF3B3A;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvbG9naW4vbG9naW4uY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSwrREFBK0Q7O0FBRS9EO0VBQ0UsWUFBWTtFQUNaLGVBQWU7RUFDZixZQUFZO0FBQ2Q7O0FBRUE7RUFDRSxrQkFBa0I7RUFDbEIsVUFBVTtFQUNWLG1CQUFtQjtFQUNuQixnQkFBZ0I7RUFDaEIsb0JBQW9CO0VBQ3BCLGFBQWE7RUFDYixrQkFBa0I7RUFDbEIsMEVBQTBFO0FBQzVFOztBQUVBO0VBQ0UsaUNBQWlDO0VBQ2pDLFVBQVU7RUFDVixtQkFBbUI7RUFDbkIsV0FBVztFQUNYLFNBQVM7RUFDVCxnQkFBZ0I7RUFDaEIsYUFBYTtFQUNiLHNCQUFzQjtFQUN0QixlQUFlO0FBQ2pCOztBQUVBO0VBQ0UsaUNBQWlDO0VBQ2pDLHlCQUF5QjtFQUN6QixVQUFVO0VBQ1YsbUJBQW1CO0VBQ25CLHlCQUF5QjtFQUN6QixXQUFXO0VBQ1gsU0FBUztFQUNULGFBQWE7RUFDYixjQUFjO0VBQ2QsZUFBZTtFQUVmLHdCQUF3QjtFQUN4QixlQUFlO0FBQ2pCOztBQUVBOzs7RUFHRSxtQkFBbUI7QUFDckI7O0FBRUE7RUFDRSxnQkFBZ0I7RUFDaEIsY0FBYztFQUNkLGVBQWU7QUFDakI7O0FBRUE7RUFDRSxjQUFjO0VBQ2QscUJBQXFCO0FBQ3ZCOztBQUVBO0VBQ0UsYUFBYTtBQUNmOztBQUVBO0VBQ0Usa0JBQWtCO0VBQ2xCLFVBQVU7RUFDVixnQkFBZ0I7RUFDaEIsY0FBYztBQUNoQjs7QUFFQTs7RUFFRSxXQUFXO0VBQ1gsY0FBYztFQUNkLFdBQVc7QUFDYjs7QUFFQTtFQUNFLGlCQUFpQjtFQUNqQixrQkFBa0I7QUFDcEI7O0FBRUE7RUFDRSxnQkFBZ0I7RUFDaEIsVUFBVTtFQUNWLGVBQWU7RUFDZixnQkFBZ0I7RUFDaEIsY0FBYztBQUNoQjs7QUFFQTtFQUNFLGNBQWM7RUFDZCxlQUFlO0FBQ2pCOztBQUVBO0VBQ0UsY0FBYztFQUNkLHFCQUFxQjtBQUN2Qjs7QUFFQTtFQUNFLGNBQWM7QUFDaEIiLCJmaWxlIjoic3JjL2FwcC9wYWdlcy9sb2dpbi9sb2dpbi5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiQGltcG9ydCB1cmwoaHR0cHM6Ly9mb250cy5nb29nbGVhcGlzLmNvbS9jc3M/ZmFtaWx5PVJvYm90bzozMDApO1xuXG4ubG9naW4tcGFnZSB7XG4gIHdpZHRoOiAzNjBweDtcbiAgcGFkZGluZzogOCUgMCAwO1xuICBtYXJnaW46IGF1dG87XG59XG5cbi5mb3JtIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB6LWluZGV4OiAxO1xuICBiYWNrZ3JvdW5kOiAjRkZGRkZGO1xuICBtYXgtd2lkdGg6IDM2MHB4O1xuICBtYXJnaW46IDAgYXV0byAxMDBweDtcbiAgcGFkZGluZzogNDVweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBib3gtc2hhZG93OiAwIDAgMjBweCAwIHJnYmEoMCwgMCwgMCwgMC4yKSwgMCA1cHggNXB4IDAgcmdiYSgwLCAwLCAwLCAwLjI0KTtcbn1cblxuLmZvcm0gaW5wdXQge1xuICBmb250LWZhbWlseTogXCJSb2JvdG9cIiwgc2Fucy1zZXJpZjtcbiAgb3V0bGluZTogMDtcbiAgYmFja2dyb3VuZDogI2YyZjJmMjtcbiAgd2lkdGg6IDEwMCU7XG4gIGJvcmRlcjogMDtcbiAgbWFyZ2luOiAwIDAgMTVweDtcbiAgcGFkZGluZzogMTVweDtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgZm9udC1zaXplOiAxNHB4O1xufVxuXG4uZm9ybSBidXR0b24ge1xuICBmb250LWZhbWlseTogXCJSb2JvdG9cIiwgc2Fucy1zZXJpZjtcbiAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbiAgb3V0bGluZTogMDtcbiAgYmFja2dyb3VuZDogIzMwNDk3MjtcbiAgLyogYmFja2dyb3VuZDogIzRDQUY1MDsgKi9cbiAgd2lkdGg6IDEwMCU7XG4gIGJvcmRlcjogMDtcbiAgcGFkZGluZzogMTVweDtcbiAgY29sb3I6ICNGRkZGRkY7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgLXdlYmtpdC10cmFuc2l0aW9uOiBhbGwgMC4zIGVhc2U7XG4gIHRyYW5zaXRpb246IGFsbCAwLjMgZWFzZTtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG4uZm9ybSBidXR0b246aG92ZXIsXG4uZm9ybSBidXR0b246YWN0aXZlLFxuLmZvcm0gYnV0dG9uOmZvY3VzIHtcbiAgYmFja2dyb3VuZDogIzMwNDk3Mjtcbn1cblxuLmZvcm0gLm1lc3NhZ2Uge1xuICBtYXJnaW46IDE1cHggMCAwO1xuICBjb2xvcjogI2IzYjNiMztcbiAgZm9udC1zaXplOiAxMnB4O1xufVxuXG4uZm9ybSAubWVzc2FnZSBhIHtcbiAgY29sb3I6ICM0Q0FGNTA7XG4gIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbn1cblxuLmZvcm0gLnJlZ2lzdGVyLWZvcm0ge1xuICBkaXNwbGF5OiBub25lO1xufVxuXG4uY29udGFpbmVyIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB6LWluZGV4OiAxO1xuICBtYXgtd2lkdGg6IDMwMHB4O1xuICBtYXJnaW46IDAgYXV0bztcbn1cblxuLmNvbnRhaW5lcjpiZWZvcmUsXG4uY29udGFpbmVyOmFmdGVyIHtcbiAgY29udGVudDogXCJcIjtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGNsZWFyOiBib3RoO1xufVxuXG4uY29udGFpbmVyIC5pbmZvIHtcbiAgbWFyZ2luOiA1MHB4IGF1dG87XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxuLmNvbnRhaW5lciAuaW5mbyBoMSB7XG4gIG1hcmdpbjogMCAwIDE1cHg7XG4gIHBhZGRpbmc6IDA7XG4gIGZvbnQtc2l6ZTogMzZweDtcbiAgZm9udC13ZWlnaHQ6IDMwMDtcbiAgY29sb3I6ICMxYTFhMWE7XG59XG5cbi5jb250YWluZXIgLmluZm8gc3BhbiB7XG4gIGNvbG9yOiAjNGQ0ZDRkO1xuICBmb250LXNpemU6IDEycHg7XG59XG5cbi5jb250YWluZXIgLmluZm8gc3BhbiBhIHtcbiAgY29sb3I6ICMwMDAwMDA7XG4gIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbn1cblxuLmNvbnRhaW5lciAuaW5mbyBzcGFuIC5mYSB7XG4gIGNvbG9yOiAjRUYzQjNBO1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/pages/login/login.component.ts":
/*!************************************************!*\
  !*** ./src/app/pages/login/login.component.ts ***!
  \************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");





let LoginComponent = class LoginComponent {
    constructor(router, dataService, http) {
        this.router = router;
        this.dataService = dataService;
        this.http = http;
    }
    ngOnInit() { }
    submit() {
        // alert(this.password)
        // if (this.dataService.password != "123") {
        //   alert("Wrong password");
        //   return;
        // }
        this.http
            .get(this.dataService.serverUrl + "adminlogin", {
            params: { password: this.dataService.password + "" },
        })
            .toPromise()
            .then((data) => {
            if (data.status) {
                this.dataService.login();
                // window.localStorage.setItem("login", "1");
                this.router.navigate(["/dashboard"]);
            }
            else {
                alert("Wrong Password");
            }
        })
            .catch((err) => {
            alert("server err");
            return false;
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClient"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-login",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/pages/login/login.component.css")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/pages/report/report.component.css":
/*!***************************************************!*\
  !*** ./src/app/pages/report/report.component.css ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3JlcG9ydC9yZXBvcnQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/pages/report/report.component.ts":
/*!**************************************************!*\
  !*** ./src/app/pages/report/report.component.ts ***!
  \**************************************************/
/*! exports provided: ReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReportComponent", function() { return ReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_components_upload_report_button_upload_report_button_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/components/upload-report-button/upload-report-button.component */ "./src/app/components/upload-report-button/upload-report-button.component.ts");
/* harmony import */ var src_app_components_view_report_button_component_view_report_button_component_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/components/view-report-button-component/view-report-button-component.component */ "./src/app/components/view-report-button-component/view-report-button-component.component.ts");
/* harmony import */ var src_app_components_download_report_button_component_download_report_button_component_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/components/download-report-button-component/download-report-button-component.component */ "./src/app/components/download-report-button-component/download-report-button-component.component.ts");






// tslint:disable-next-line: max-line-length

let ReportComponent = class ReportComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true
            },
            hideSubHeader: true,
            actions: false,
            columns: {
                city: {
                    title: "City"
                },
                center: {
                    title: "Center "
                },
                course: {
                    title: "Course"
                },
                subject: {
                    title: "Subject"
                },
                timeSlot: {
                    title: "Time"
                },
                date: {
                    title: "Date"
                },
                // amount: {
                //   title: "Amount"
                // },
                upload: {
                    title: "View ",
                    type: "custom",
                    renderComponent: src_app_components_view_report_button_component_view_report_button_component_component__WEBPACK_IMPORTED_MODULE_5__["ViewReportButtonComponentComponent"],
                }
            }
        };
        this.studentSettings = {
            hideSubHeader: true,
            actions: false,
            columns: {
                studentName: {
                    title: "Name"
                },
                phone: {
                    title: "Phone "
                },
                upload: {
                    title: "Upload ",
                    type: "custom",
                    renderComponent: src_app_components_upload_report_button_upload_report_button_component__WEBPACK_IMPORTED_MODULE_4__["UploadReportButtonComponent"],
                },
                download: {
                    title: "Download ",
                    type: "custom",
                    renderComponent: src_app_components_download_report_button_component_download_report_button_component_component__WEBPACK_IMPORTED_MODULE_6__["DownloadReportButtonComponentComponent"],
                }
            }
        };
        this.tests = [];
        this.students = [];
        this.getTests();
        // this.getStudents(1)
        this.dataService.report.testSelected.subscribe(testID => {
            // this.courses = this.dataService.courses;
            // alert(data)
            // data is the testID
            this.getStudents(testID);
        });
    }
    getTests() {
        this.http.get(this.dataService.serverUrl + "test", {}).toPromise().then((data) => {
            console.log(data);
            this.tests = data;
        });
    }
    ngOnInit() {
    }
    getStudents(testID) {
        this.http.get(this.dataService.serverUrl + "report/" + testID, {}).toPromise().then((data) => {
            if (!data.status) {
                alert("Error gettting Students");
                return;
            }
            console.log(data);
            this.students = data.data;
        }).catch(err => {
            console.log(err);
            alert("Connection Error");
        });
    }
    onDeleteConfirm(event) { }
};
ReportComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
ReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-report',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./report.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/report/report.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./report.component.css */ "./src/app/pages/report/report.component.css")).default]
    })
], ReportComponent);



/***/ }),

/***/ "./src/app/pages/result/result.component.css":
/*!***************************************************!*\
  !*** ./src/app/pages/result/result.component.css ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3Jlc3VsdC9yZXN1bHQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/pages/result/result.component.ts":
/*!**************************************************!*\
  !*** ./src/app/pages/result/result.component.ts ***!
  \**************************************************/
/*! exports provided: ResultComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResultComponent", function() { return ResultComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_components_upload_report_button_upload_report_button_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/components/upload-report-button/upload-report-button.component */ "./src/app/components/upload-report-button/upload-report-button.component.ts");
/* harmony import */ var src_app_components_download_report_button_component_download_report_button_component_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/components/download-report-button-component/download-report-button-component.component */ "./src/app/components/download-report-button-component/download-report-button-component.component.ts");
/* harmony import */ var src_app_components_result_upload_result_upload_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/components/result-upload/result-upload.component */ "./src/app/components/result-upload/result-upload.component.ts");





// tslint:disable-next-line: max-line-length


let ResultComponent = class ResultComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true
            },
            hideSubHeader: true,
            actions: false,
            columns: {
                city: {
                    title: "City"
                },
                center: {
                    title: "Center "
                },
                course: {
                    title: "Course"
                },
                subject: {
                    title: "Subject"
                },
                timeSlot: {
                    title: "Time"
                },
                date: {
                    title: "Date"
                },
                // amount: {
                //   title: "Amount"
                // },
                upload: {
                    title: "Upload Result ",
                    type: "custom",
                    renderComponent: src_app_components_result_upload_result_upload_component__WEBPACK_IMPORTED_MODULE_6__["ResultUploadComponent"],
                }
            }
        };
        this.studentSettings = {
            hideSubHeader: true,
            actions: false,
            columns: {
                studentName: {
                    title: "Name"
                },
                phone: {
                    title: "Phone "
                },
                upload: {
                    title: "Upload ",
                    type: "custom",
                    renderComponent: src_app_components_upload_report_button_upload_report_button_component__WEBPACK_IMPORTED_MODULE_4__["UploadReportButtonComponent"],
                },
                download: {
                    title: "Download ",
                    type: "custom",
                    renderComponent: src_app_components_download_report_button_component_download_report_button_component_component__WEBPACK_IMPORTED_MODULE_5__["DownloadReportButtonComponentComponent"],
                }
            }
        };
        this.tests = [];
        this.students = [];
        this.getTests();
        // this.getStudents(1)
        this.dataService.report.testSelected.subscribe(testID => {
            // this.courses = this.dataService.courses;
            // alert(data)
            // data is the testID
            this.getStudents(testID);
        });
    }
    getTests() {
        this.http.get(this.dataService.serverUrl + "test", {}).toPromise().then((data) => {
            console.log(data);
            this.tests = data;
        });
    }
    ngOnInit() {
    }
    getStudents(testID) {
        this.http.get(this.dataService.serverUrl + "report/" + testID, {}).toPromise().then((data) => {
            if (!data.status) {
                alert("Error gettting Students");
                return;
            }
            console.log(data);
            this.students = data.data;
        }).catch(err => {
            console.log(err);
            alert("Connection Error");
        });
    }
    onDeleteConfirm(event) { }
};
ResultComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
ResultComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-result',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./result.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/result/result.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./result.component.css */ "./src/app/pages/result/result.component.css")).default]
    })
], ResultComponent);



/***/ }),

/***/ "./src/app/pages/slider/slider.component.css":
/*!***************************************************!*\
  !*** ./src/app/pages/slider/slider.component.css ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3NsaWRlci9zbGlkZXIuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/pages/slider/slider.component.ts":
/*!**************************************************!*\
  !*** ./src/app/pages/slider/slider.component.ts ***!
  \**************************************************/
/*! exports provided: SliderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliderComponent", function() { return SliderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_components_slider_image_slider_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/components/slider-image/slider-image.component */ "./src/app/components/slider-image/slider-image.component.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var src_app_components_slider_thumbnail_slider_thumbnail_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/components/slider-thumbnail/slider-thumbnail.component */ "./src/app/components/slider-thumbnail/slider-thumbnail.component.ts");
/* harmony import */ var src_app_components_slider_video_slider_video_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/components/slider-video/slider-video.component */ "./src/app/components/slider-video/slider-video.component.ts");
/* harmony import */ var src_app_components_slider_image_testimonial_slider_image_testimonial_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/components/slider-image-testimonial/slider-image-testimonial.component */ "./src/app/components/slider-image-testimonial/slider-image-testimonial.component.ts");
/* harmony import */ var src_app_components_revision_note_component_revision_note_component_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/components/revision-note-component/revision-note-component.component */ "./src/app/components/revision-note-component/revision-note-component.component.ts");









let SliderComponent = class SliderComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.youtubeLink = "";
        this.noteTitle = "";
        this.notes = [];
        this.sliders = [];
        this.slidersTestimonial = [];
        this.slidersVideo = [];
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            add: {
                addButtonContent: "",
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                sliderImage: {
                    title: "Slider Image",
                    type: "custom",
                    renderComponent: src_app_components_slider_image_slider_image_component__WEBPACK_IMPORTED_MODULE_2__["SliderImageComponent"],
                },
            },
        };
        this.settingsNotes = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            add: {
                addButtonContent: "",
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                title: {
                    title: "Tittle",
                },
                sliderImage: {
                    title: "Slider Image",
                    type: "custom",
                    renderComponent: src_app_components_revision_note_component_revision_note_component_component__WEBPACK_IMPORTED_MODULE_8__["RevisionNoteComponentComponent"],
                },
            },
        };
        this.settingsTestimonial = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            add: {
                addButtonContent: "",
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                sliderTestimonial: {
                    title: "Slider Image",
                    type: "custom",
                    renderComponent: src_app_components_slider_image_testimonial_slider_image_testimonial_component__WEBPACK_IMPORTED_MODULE_7__["SliderImageTestimonialComponent"],
                },
            },
        };
        this.settingsVideo = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            add: {
                addButtonContent: "",
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                thumbnail: {
                    title: "Thumbnail Image (.png)",
                    type: "custom",
                    renderComponent: src_app_components_slider_thumbnail_slider_thumbnail_component__WEBPACK_IMPORTED_MODULE_5__["SliderThumbnailComponent"],
                },
                video: {
                    title: "Youtube Link ",
                    type: "custom",
                    renderComponent: src_app_components_slider_video_slider_video_component__WEBPACK_IMPORTED_MODULE_6__["SliderVideoComponent"],
                },
            },
        };
        this.getSliders();
        // this.getSliderVideos();
        // this.getSlidersTestimonials();
        // this.getNotes();
    }
    ngOnInit() { }
    postMethod(files) {
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        this.http
            .post(this.dataService.serverUrl + "slider/uploadImage", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload slider");
            }
            else {
                this.getSliders();
            }
        });
        return false;
    }
    postMethodTestimonial(files) {
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        this.http
            .post(this.dataService.serverUrl + "slider/uploadImageTestimonial", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload slider");
            }
            else {
                this.getSlidersTestimonials();
            }
        });
        return false;
    }
    postMethodNote(files) {
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        formData.append("noteTitle", this.noteTitle);
        this.http
            .post(this.dataService.serverUrl + "note/upload", formData)
            .subscribe((val) => {
            console.log("post note/upload response ", val);
            if (!val.status) {
                alert("Unable to upload note");
            }
            else {
                this.getNotes();
            }
        });
        return false;
    }
    postMethodVideo(files) {
        this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        formData.append("youtubeLink", this.youtubeLink);
        this.http
            .post(this.dataService.serverUrl + "slider/uploadVideo", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload video");
            }
            else {
                this.getSliderVideos();
            }
        });
        return false;
    }
    getSliders() {
        this.http
            .get(this.dataService.serverUrl + "slider")
            .toPromise()
            .then((data) => {
            console.log("slider images", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.sliders = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getNotes() {
        this.http
            .get(this.dataService.serverUrl + "note")
            .toPromise()
            .then((data) => {
            console.log("get note response ", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.notes = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getSlidersTestimonials() {
        this.http
            .get(this.dataService.serverUrl + "slider/testimonial")
            .toPromise()
            .then((data) => {
            console.log("slider images", data);
            if (!data.status) {
                alert("Error getting testimonial");
                return;
            }
            this.slidersTestimonial = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getSliderVideos() {
        this.http
            .get(this.dataService.serverUrl + "slider/video")
            .toPromise()
            .then((data) => {
            console.log("slider videos", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.slidersVideo = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    onDeleteConfirm(event, deleteRevisionNote = false) {
        let endpoint = "slider";
        if (deleteRevisionNote) {
            endpoint = "note";
        }
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + `${endpoint}/` + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    this.getSliders();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the slider");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
SliderComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"] }
];
SliderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-slider",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./slider.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/slider/slider.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./slider.component.css */ "./src/app/pages/slider/slider.component.css")).default]
    })
], SliderComponent);



/***/ }),

/***/ "./src/app/pages/sub-course/sub-course.component.css":
/*!***********************************************************!*\
  !*** ./src/app/pages/sub-course/sub-course.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3N1Yi1jb3Vyc2Uvc3ViLWNvdXJzZS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/pages/sub-course/sub-course.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/pages/sub-course/sub-course.component.ts ***!
  \**********************************************************/
/*! exports provided: SubCourseComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubCourseComponent", function() { return SubCourseComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let SubCourseComponent = class SubCourseComponent {
    constructor(dataService, http) {
        this.dataService = dataService;
        this.http = http;
        this.subCourse = "";
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: false,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                name: {
                    title: "Course Name",
                },
            },
        };
    }
    ngOnInit() { }
    submitSubCourse() {
        console.log("submitting");
        this.http
            .post(this.dataService.serverUrl + "subcourse", {
            subcourse: this.subCourse,
            courseID: this.selectedCourseID,
        })
            .toPromise()
            .then((data) => {
            console.log(data);
            if (data.status) {
                this.dataService.getSubCourses();
            }
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    onDeleteConfirm(event) {
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + "subcourse/" + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    this.dataService.getSubCourses();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the subcourse");
            })
                .catch((err) => {
                alert("Connection Error");
                event.confirm.reject();
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
SubCourseComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
SubCourseComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-sub-course",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./sub-course.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/sub-course/sub-course.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./sub-course.component.css */ "./src/app/pages/sub-course/sub-course.component.css")).default]
    })
], SubCourseComponent);



/***/ }),

/***/ "./src/app/pages/subject/subject.component.css":
/*!*****************************************************!*\
  !*** ./src/app/pages/subject/subject.component.css ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table,\nth,\ntd {\n  border: 1px solid rgb(180, 180, 180);\n  border-collapse: collapse;\n  padding: 8px\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvc3ViamVjdC9zdWJqZWN0LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7OztFQUdFLG9DQUFvQztFQUNwQyx5QkFBeUI7RUFDekI7QUFDRiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3N1YmplY3Qvc3ViamVjdC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsidGFibGUsXG50aCxcbnRkIHtcbiAgYm9yZGVyOiAxcHggc29saWQgcmdiKDE4MCwgMTgwLCAxODApO1xuICBib3JkZXItY29sbGFwc2U6IGNvbGxhcHNlO1xuICBwYWRkaW5nOiA4cHhcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/pages/subject/subject.component.ts":
/*!****************************************************!*\
  !*** ./src/app/pages/subject/subject.component.ts ***!
  \****************************************************/
/*! exports provided: SubjectComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubjectComponent", function() { return SubjectComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let SubjectComponent = class SubjectComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: true,
            actions: {
                edit: true,
                position: "right",
            },
            edit: {
                editButtonContent: '<i class="nb-edit"></i>',
                cancelButtonContent: '<i class="nb-close-circled"></i>',
                saveButtonContent: '<i class="nb-checkmark-circle"></i>',
                confirmSave: true,
            },
            editor: {},
            columns: {
                subCourseName: {
                    editable: false,
                    title: "Subcourse ",
                },
                name: {
                    editable: false,
                    title: "Subject ",
                },
                // amount: {
                //   title: "Amount",
                // },
                // firstInstallmentDate: {
                //   title: "1st Instal. Dt.",
                // },
                // firstInstallmentAmount: {
                //   title: "1st Instal. Amt.",
                // },
                // secondInstallmentDate: {
                //   title: "2nd Instal. Dt.",
                // },
                // secondInstallmentAmount: {
                //   title: "2nd Instal. Amt.",
                // },
                fullInstallmentDate: {
                    title: "Full Instal. Dt.",
                },
                fullInstallmentAmount: {
                    title: "Full Instal. Amt.",
                },
            },
        };
    }
    submitSubject() {
        // console.log("submitting");
        // alert(this.firstInstallmentDate);
        // alert(this.firstInstallmentAmount);
        this.http
            .post(this.dataService.serverUrl + "subject", {
            subCourseID: this.selectedSubCourseID + "",
            subject: this.subject,
            // amount: this.amount,
            // firstInstallmentAmount: this.firstInstallmentAmount,
            // firstInstallmentDate: this.firstInstallmentDate,
            // secondInstallmentAmount: this.secondInstallmentAmount,
            // secondInstallmentDate: this.secondInstallmentDate,
            fullInstallmentAmount: this.fullInstallmentAmount,
            fullInstallmentDate: this.fullInstallmentDate,
        })
            .toPromise()
            .then((data) => {
            console.log(data);
            if (data.status) {
                this.dataService.getSubjects();
            }
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    ngOnInit() { }
    onEdit(event) {
        if (window.confirm("Are you sure you want to save?")) {
            // call to remote api, remember that you have to await this
            event.confirm.resolve(event.newData);
            console.log(event);
            this.http
                .patch(this.dataService.serverUrl + "subject/" + event.newData.id, Object.assign({}, event.newData))
                .subscribe((data) => {
                console.log("PATCH SUBJECT ", data);
                if (!data.status) {
                    alert("Failed to Update");
                    this.dataService.getSubjects();
                    return;
                }
            }, (error) => {
                console.log("ERROR PATCH SUBJECT ", error);
                alert("Connection Error");
                event.confirm.reject();
            });
        }
        else {
        }
    }
    onDeleteConfirm(event) {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + "subject/" + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    // alert("City Deleted !");
                    this.dataService.getSubjects();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the course");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
SubjectComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
SubjectComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-subject",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./subject.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/subject/subject.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./subject.component.css */ "./src/app/pages/subject/subject.component.css")).default]
    })
], SubjectComponent);



/***/ }),

/***/ "./src/app/pages/test-report/test-report.component.css":
/*!*************************************************************!*\
  !*** ./src/app/pages/test-report/test-report.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3Rlc3QtcmVwb3J0L3Rlc3QtcmVwb3J0LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/test-report/test-report.component.ts":
/*!************************************************************!*\
  !*** ./src/app/pages/test-report/test-report.component.ts ***!
  \************************************************************/
/*! exports provided: TestReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TestReportComponent", function() { return TestReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");





let TestReportComponent = class TestReportComponent {
    constructor(dataService, http, route) {
        this.dataService = dataService;
        this.http = http;
        this.route = route;
        this.data = [];
        this.finalList = [];
        this.getData(this.route.snapshot.params.testId);
    }
    getData(testId) {
        this.http
            .get(this.dataService.strapiServerUrl + "student-test-questions", {
            params: {
                "testQuestionID.testID": testId + "",
                _limit: 10000 + "",
            },
        })
            .subscribe((data) => {
            this.data = data;
            this.rankCalculator();
        });
    }
    rankCalculator() {
        this.data.forEach((element) => {
            let studentAdded = this.studentExists(element.studentID.id);
            if (studentAdded.found) {
                this.finalList[studentAdded.index].marks += element.marks;
            }
            else {
                this.finalList.push({
                    student: element.studentID,
                    marks: element.marks,
                });
            }
        });
        this.finalList.sort((a, b) => b.marks - a.marks);
        console.log(this.finalList);
    }
    ngOnInit() { }
    studentExists(studentId) {
        var found = false;
        var index = 0;
        for (var i = 0; i < this.finalList.length; i++) {
            if (this.finalList[i].student.id == studentId) {
                found = true;
                index = i;
                break;
            }
        }
        return { found, index };
    }
};
TestReportComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] }
];
TestReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: "app-test-report",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./test-report.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/test-report/test-report.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./test-report.component.css */ "./src/app/pages/test-report/test-report.component.css")).default]
    })
], TestReportComponent);



/***/ }),

/***/ "./src/app/pages/video/video.component.css":
/*!*************************************************!*\
  !*** ./src/app/pages/video/video.component.css ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3ZpZGVvL3ZpZGVvLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/video/video.component.ts":
/*!************************************************!*\
  !*** ./src/app/pages/video/video.component.ts ***!
  \************************************************/
/*! exports provided: VideoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VideoComponent", function() { return VideoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_components_get_questions_get_questions_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/components/get-questions/get-questions.component */ "./src/app/components/get-questions/get-questions.component.ts");
/* harmony import */ var src_app_components_question_editor_question_editor_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/components/question-editor/question-editor.component */ "./src/app/components/question-editor/question-editor.component.ts");
/* harmony import */ var src_app_components_upload_solution_csv_upload_solution_csv_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/components/upload-solution-csv/upload-solution-csv.component */ "./src/app/components/upload-solution-csv/upload-solution-csv.component.ts");
/* harmony import */ var src_app_components_question_upload_video_question_upload_video_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/components/question-upload-video/question-upload-video.component */ "./src/app/components/question-upload-video/question-upload-video.component.ts");
/* harmony import */ var src_app_components_question_update_number_question_update_number_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/components/question-update-number/question-update-number.component */ "./src/app/components/question-update-number/question-update-number.component.ts");









let VideoComponent = class VideoComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        // showQuestions = true
        this.showQuestions = false;
        this.questionSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true
            },
            hideSubHeader: true,
            actions: false,
            columns: {
                // idx: {
                //   title: "Question Number",
                //   type: "text",
                //   filter: false,
                //   valuePrepareFunction: (row) => {
                //     //   console.log(row); 
                //     //   console.log(row.index);
                //     return `${row.type}`;
                //   }
                // },
                questionNumber: {
                    title: "Ques. Number",
                    type: "custom",
                    renderComponent: src_app_components_question_update_number_question_update_number_component__WEBPACK_IMPORTED_MODULE_8__["QuestionUpdateNumberComponent"],
                },
                value: {
                    title: "Ques. Image",
                    type: "custom",
                    renderComponent: src_app_components_question_editor_question_editor_component__WEBPACK_IMPORTED_MODULE_5__["QuestionEditorComponent"],
                },
                uploadSolution: {
                    title: "Solution Video",
                    type: "custom",
                    renderComponent: src_app_components_question_upload_video_question_upload_video_component__WEBPACK_IMPORTED_MODULE_7__["QuestionUploadVideoComponent"],
                },
            }
        };
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true
            },
            hideSubHeader: true,
            actions: false,
            columns: {
                city: {
                    title: "City"
                },
                center: {
                    title: "Center "
                },
                // course: {
                //   title: "Course"
                // },
                subject: {
                    title: "Subject"
                },
                timeSlot: {
                    title: "Time"
                },
                date: {
                    title: "Date"
                },
                upload: {
                    title: "Upload CSV ",
                    type: "custom",
                    renderComponent: src_app_components_upload_solution_csv_upload_solution_csv_component__WEBPACK_IMPORTED_MODULE_6__["UploadSolutionCSVComponent"],
                },
                show: {
                    title: "Solutions",
                    type: "custom",
                    renderComponent: src_app_components_get_questions_get_questions_component__WEBPACK_IMPORTED_MODULE_4__["GetQuestionsComponent"],
                }
                // amount: {
                //   title: "Amount"
                // },
                // upload: {
                //   title: "Video Solution ",
                //   type: "custom",
                //   renderComponent: VideoUploadComponent,
                // },
                // uploadPDF: {
                //   title: "PDF Solution ",
                //   type: "custom",
                //   renderComponent: PdfSolutionUploadComponent,
                // },
            }
        };
        this.tests = [];
        this.questions = [];
        this.getTests();
        // this.getStudents(1)
        this.dataService.getQuestionsEvent.subscribe(data => {
            console.log('got data in video component', data);
            this.showQuestions = true;
            this.questions = data.data;
            console.log('question', this.questions);
            // this.courses = this.dataService.courses;
            // alert(data)
            // data is the testID
            // this.getQuestions(testID)
            // call the service to get all the questions for the particular test id
        });
    }
    getTests() {
        this.http.get(this.dataService.serverUrl + "test", {}).toPromise().then((data) => {
            console.log(data);
            this.tests = data;
        });
    }
    getQuestions(testID) {
        this.selectedTestID = testID;
        this.http.get(this.dataService.serverUrl + "question?testID=" + testID, {}).toPromise().then((data) => {
            console.log('questions Data', data);
            if (!data.status) {
                alert("Error getting questions !");
                return;
            }
            this.showQuestions = true;
            this.questions = data.data;
        });
    }
    ngOnInit() {
    }
    onDeleteConfirm(event) { }
};
VideoComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
VideoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-video',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./video.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/video/video.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./video.component.css */ "./src/app/pages/video/video.component.css")).default]
    })
], VideoComponent);



/***/ }),

/***/ "./src/app/progress/progress.component.css":
/*!*************************************************!*\
  !*** ./src/app/progress/progress.component.css ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Byb2dyZXNzL3Byb2dyZXNzLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/progress/progress.component.ts":
/*!************************************************!*\
  !*** ./src/app/progress/progress.component.ts ***!
  \************************************************/
/*! exports provided: ProgressComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressComponent", function() { return ProgressComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../components/view-library-pdf/view-library-pdf.component */ "./src/app/components/view-library-pdf/view-library-pdf.component.ts");





let ProgressComponent = class ProgressComponent {
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.filteredSubjects = [];
        this.filteredChapters = [];
        this.pdfs = [];
        this.videos = [];
        this.videoTitle = "";
        this.youtubeLink = "";
        this.noteTitle = "";
        this.notes = [];
        this.slidersTestimonial = [];
        this.slidersVideo = [];
        this.pdfSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                subjectName: {
                    title: "Subject Name",
                },
                chapterName: {
                    title: "Chapter Name",
                },
                name: {
                    title: "Pdf Title",
                },
                sliderImage: {
                    title: "View Pdf",
                    type: "custom",
                    renderComponent: _components_view_library_pdf_view_library_pdf_component__WEBPACK_IMPORTED_MODULE_4__["ViewLibraryPdfComponent"],
                },
            },
        };
        this.videoSettings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            // hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                title: {
                    title: "Video Title",
                },
                sliderImage: {
                    title: "Link Video",
                    type: "custom",
                },
            },
        };
        this.getPdfs();
        this.getVideos();
    }
    pdfFileSelected(files) {
        this.pdfFile = files;
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    getFilteredChapters() {
        this.http
            .get(this.dataService.serverUrl + "chapter", {
            params: { subjectID: this.selectedSubjectID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED CHAPTER :", data);
            this.filteredChapters = data.data;
        });
    }
    ngOnInit() { }
    // postMethod(files: FileList) {
    uploadPdf() {
        console.log(this.pdfFile);
        this.fileToUpload = this.pdfFile.item(0);
        // this.fileToUpload = files.item(0);
        let formData = new FormData();
        formData.append("file", this.fileToUpload, this.fileToUpload.name);
        formData.append("pdfTitle", this.pdfTitle);
        formData.append("chapterID", this.selectedChapterID);
        this.http
            .post(this.dataService.serverUrl + "progress", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to upload slider");
            }
            else {
                this.getPdfs();
            }
        });
        return false;
    }
    getPdfs() {
        this.http
            .get(this.dataService.serverUrl + "progress")
            .toPromise()
            .then((data) => {
            console.log("GET progress ", data);
            if (!data.status) {
                alert("Error getting progress ");
                return;
            }
            this.pdfs = data.data;
            // this.sliders = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    getVideos() {
        this.http
            .get(this.dataService.serverUrl + "video")
            .toPromise()
            .then((data) => {
            console.log("GET VIDEO", data);
            if (!data.status) {
                alert("Error getting sliders");
                return;
            }
            this.videos = data.data;
        })
            .catch((err) => {
            alert("Connection Error");
            console.log(err);
        });
    }
    addVideo() {
        // alert("asdf");
        this.http
            .post(this.dataService.serverUrl + "video", {
            chapterID: this.selectedChapterID,
            youtubeLink: this.youtubeLink,
            title: this.videoTitle,
        })
            .subscribe((data) => {
            console.log("POST important", data);
            this.getVideos();
        }, (error) => {
            alert("Error Adding Video");
        });
    }
    deleteData(event, endpoint = "progress") {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + `${endpoint}/` + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    this.getPdfs();
                    event.confirm.resolve();
                    return;
                }
                event.confirm.reject();
                alert("Unable to delete the slider");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
ProgressComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] }
];
ProgressComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-progress",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./progress.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/progress/progress.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./progress.component.css */ "./src/app/progress/progress.component.css")).default]
    })
], ProgressComponent);



/***/ }),

/***/ "./src/app/services/auth.guard.ts":
/*!****************************************!*\
  !*** ./src/app/services/auth.guard.ts ***!
  \****************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./data.service */ "./src/app/services/data.service.ts");




let AuthGuard = class AuthGuard {
    constructor(ds, router) {
        this.ds = ds;
        this.router = router;
    }
    canActivate(next, state) {
        if (this.ds.environment == "dev")
            return true;
        return this.ds.isAuthenticated().then((authenticated) => {
            if (authenticated) {
                return true;
            }
            else {
                // alert("false");
                this.router.navigate(["/"]);
                return false;
            }
        });
        // if (window.localStorage.get("login")) {
        //   alert(true);
        //   return true;
        // } else {
        //   alert(false);
        //   return false;
        // }
    }
};
AuthGuard.ctorParameters = () => [
    { type: _data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: "root",
    })
], AuthGuard);



/***/ }),

/***/ "./src/app/services/data.service.ts":
/*!******************************************!*\
  !*** ./src/app/services/data.service.ts ***!
  \******************************************/
/*! exports provided: DataService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataService", function() { return DataService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



let DataService = class DataService {
    // dev to prod
    // 1. change serverUrl
    // 2. change node db connection
    constructor(http) {
        this.http = http;
        this.password = "";
        this.loggedIn = false;
        this.environment = "prod";
        this.cities = [];
        this.courses = [];
        this.subCourses = [];
        this.subjects = [];
        this.chapters = [];
        this.subscription = {
            selectedStudentID: undefined,
            selectedStudentName: "",
            studentSubjects: [],
            studentTutorialViews: [],
        };
        this.citiesUpdated = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.coursesUpdated = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.report = {
            testSelected: new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"](),
        };
        this.getQuestionsEvent = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        // this.environment = "dev";
        if (this.environment === "dev") {
            this.serverUrl = "http://localhost:8080/";
            this.strapiServerUrl = "http://localhost:1337/";
        }
        else if (this.environment === "prod") {
            // this.serverUrl = "https://admin.awacademy.in/";
            // this.serverUrl = "https://akash.webmediaindia.com/";
            this.serverUrl = "https://api.knowlify.in/";
            // this.serverUrl = "https://knowlify.webmediaindia.com/";
            if (this.serverUrl.includes("akash")) {
                this.strapiServerUrl = "https://strapi-akash.webmediaindia.com/";
            }
            else if (this.serverUrl.includes("knowlify")) {
                this.strapiServerUrl = "https://strapi.knowlify.in/";
            }
            // this.strapiServerUrl = "http://localhost:1337/";
        }
        this.getCourses();
        this.getSubCourses();
        this.getSubjects();
        this.getChapters();
    }
    isAuthenticated() {
        const promise = new Promise((resolve, reject) => {
            resolve(this.loggedIn);
        });
        return promise;
    }
    login() {
        this.loggedIn = true;
    }
    logout() {
        this.loggedIn = false;
    }
    getCourses() {
        this.http.get(this.serverUrl + "course").subscribe((data) => {
            console.log("GET COURSE :", data);
            this.courses = data.data;
        });
    }
    getSubCourses() {
        this.http.get(this.serverUrl + "subcourse").subscribe((data) => {
            console.log("GET SUBCOURSE :", data);
            this.subCourses = data.data;
        });
    }
    getSubjects() {
        this.http.get(this.serverUrl + "subject").subscribe((data) => {
            console.log("GET SUBJECT :", data);
            this.subjects = data.data;
        });
    }
    getChapters() {
        this.http.get(this.serverUrl + "chapter").subscribe((data) => {
            console.log("GET CHAPTER :", data);
            this.chapters = data.data;
        });
    }
    getStudentSubjects() {
        // NOW GET THE SUBSCRITPION DATA
        this.http
            .get(this.serverUrl + "subscription/" + this.subscription.selectedStudentID)
            .subscribe((data) => {
            console.log("GET SUBSCRIPTION ", data);
            this.subscription.studentSubjects = data.data;
            document
                .getElementById("manageSubscriptionContainer")
                .scrollIntoView();
        }, (error) => {
            console.log("ERROR GET SUBSCRIPTION ", error);
        });
    }
    getStudentTutorialViews(studentId) {
        this.http
            .get(this.strapiServerUrl + "student-tutorials", {
            params: {
                "student.id": studentId + "",
            },
        })
            .subscribe((data) => {
            data.forEach((element) => {
                console.log(element);
                element.studentName = element.student.name;
                element.tutorialName = element.tutorial.title;
            });
            this.subscription.studentTutorialViews = data;
        });
    }
    // console.log(dateRange("2021-01-01", "2021-12-20"));
    dateRange(startDate, endDate) {
        let start = startDate.split("-");
        let end = endDate.split("-");
        let startYear = parseInt(start[0]);
        let endYear = parseInt(end[0]);
        let dates = [];
        for (let i = startYear; i <= endYear; i++) {
            let endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
            let startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
            for (let j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
                let month = j + 1;
                let displayMonth = month < 10 ? "0" + month : month;
                dates.push([i, displayMonth, "01"].join("-"));
            }
        }
        return dates;
    }
};
DataService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
DataService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], DataService);



/***/ }),

/***/ "./src/app/test/add-test-question/add-test-question.component.css":
/*!************************************************************************!*\
  !*** ./src/app/test/add-test-question/add-test-question.component.css ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Rlc3QvYWRkLXRlc3QtcXVlc3Rpb24vYWRkLXRlc3QtcXVlc3Rpb24uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/test/add-test-question/add-test-question.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/test/add-test-question/add-test-question.component.ts ***!
  \***********************************************************************/
/*! exports provided: AddTestQuestionComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddTestQuestionComponent", function() { return AddTestQuestionComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng2_smart_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ng2-smart-table */ "./node_modules/ng2-smart-table/fesm2015/ng2-smart-table.js");





let AddTestQuestionComponent = class AddTestQuestionComponent {
    // quizChapterQuestions = []
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.filteredSubjects = [];
        this.filteredChapters = [];
        this.pdfs = [];
        this.videos = [];
        this.videoTitle = "";
        this.youtubeLink = "";
        this.noteTitle = "";
        this.notes = [];
        this.slidersTestimonial = [];
        this.slidersVideo = [];
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                text: {
                    title: "Text",
                },
                'option 1': {
                    title: "Option 1",
                },
                'option 2': {
                    title: "Option 2",
                },
                'option 3': {
                    title: "Option 3",
                },
                'option 4': {
                    title: "Option 4",
                },
                'correctOption': {
                    title: "Correct Option",
                },
            },
        };
        this.textQuestion = "";
        this.firstOption = "";
        this.secondOption = "";
        this.thirdOption = "";
        this.fourthOption = "";
        this.quizChapterQuestions = new ng2_smart_table__WEBPACK_IMPORTED_MODULE_4__["LocalDataSource"]();
    }
    ngOnInit() { }
    quizImageSelected(files) {
        this.quizImage = files;
    }
    submitQuestion() {
        if (!this.selectedChapterID) {
            return;
        }
        let formData = new FormData();
        let fileToUpload;
        if (this.quizImage) {
            fileToUpload = this.quizImage.item(0);
            formData.append("quizImage", fileToUpload, fileToUpload.name);
        }
        // this.fileToUpload = files.item(0);
        formData.append("chapterID", this.selectedChapterID);
        formData.append("textQuestion", this.textQuestion);
        formData.append("firstOption", this.firstOption);
        formData.append("secondOption", this.secondOption);
        formData.append("thirdOption", this.thirdOption);
        formData.append("fourthOption", this.fourthOption);
        formData.append("correctOption", this.correctOption);
        this.http
            .post(this.dataService.serverUrl + "quiz/question", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to add question");
            }
            else {
                this.getQuizChapterQuestion();
            }
        });
        return false;
    }
    getQuizChapterQuestion() {
        this.http
            .get(this.dataService.serverUrl + "quiz/question/chapter/" + this.selectedChapterID, {})
            .subscribe((data) => {
            console.log("GET QUIZ QUESTION CHAPTER :", data);
            // this.quizChapterQuestions = data.data;
            this.quizChapterQuestions.load(data.data);
        });
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    getFilteredChapters() {
        this.http
            .get(this.dataService.serverUrl + "chapter", {
            params: { subjectID: this.selectedSubjectID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED CHAPTER :", data);
            this.filteredChapters = data.data;
        });
    }
    deleteQuestion(event) {
        console.log("Delete Event In Console");
        console.log(event);
        if (window.confirm("Are you sure you want to delete?")) {
            this.http
                .delete(this.dataService.serverUrl + `quiz/question/` + event.data.id, {})
                .toPromise()
                .then((data) => {
                console.log(data);
                if (data.status) {
                    this.getQuizChapterQuestion();
                    // event.confirm.resolve();
                    return;
                }
                // event.confirm.reject();
                alert("Unable to delete the slider");
            })
                .catch((err) => {
                event.confirm.reject();
                alert("Connection Error");
                console.log(JSON.stringify(err));
            });
        }
        else {
        }
    }
};
AddTestQuestionComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] }
];
AddTestQuestionComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-add-test-question',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./add-test-question.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/test/add-test-question/add-test-question.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./add-test-question.component.css */ "./src/app/test/add-test-question/add-test-question.component.css")).default]
    })
], AddTestQuestionComponent);



/***/ }),

/***/ "./src/app/test/add-test/add-test.component.css":
/*!******************************************************!*\
  !*** ./src/app/test/add-test/add-test.component.css ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Rlc3QvYWRkLXRlc3QvYWRkLXRlc3QuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/test/add-test/add-test.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/test/add-test/add-test.component.ts ***!
  \*****************************************************/
/*! exports provided: AddTestComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddTestComponent", function() { return AddTestComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng2_smart_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ng2-smart-table */ "./node_modules/ng2-smart-table/fesm2015/ng2-smart-table.js");
/* harmony import */ var src_app_app_test_view_test_result_button_view_test_result_button_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/app/test/view-test-result-button/view-test-result-button.component */ "./src/app/app/test/view-test-result-button/view-test-result-button.component.ts");






let AddTestComponent = class AddTestComponent {
    // quizChapterQuestions = []
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.questions = [];
        this.questionsPositiveMarks = [];
        this.questionsNegativeMarks = [];
        this.filteredQuestions = [];
        // selectedChapterID;
        this.filteredSubjects = [];
        this.filteredChapters = [];
        this.tests = new ng2_smart_table__WEBPACK_IMPORTED_MODULE_4__["LocalDataSource"]();
        this.textQuestion = "";
        this.firstOption = "";
        this.secondOption = "";
        this.thirdOption = "";
        this.fourthOption = "";
        this.settings = {
            delete: {
                deleteButtonContent: '<i class="nb-trash"></i>',
                confirmDelete: true,
            },
            hideSubHeader: true,
            actions: {
                add: false,
                edit: false,
                position: "right",
            },
            columns: {
                id: {
                    title: "ID",
                },
                // subcourse: {
                //   title: "Subcourse",
                //   valuePrepareFunction: (data) => {
                //     return data.name
                //   }
                // },
                name: {
                    title: "Test",
                },
                positiveMarks: {
                    title: "Positive Marks",
                },
                minutes: {
                    title: "Minutes",
                },
                negativeMarks: {
                    title: "Negative Marks",
                },
                sliderImage: {
                    title: "View Result",
                    type: "custom",
                    renderComponent: src_app_app_test_view_test_result_button_view_test_result_button_component__WEBPACK_IMPORTED_MODULE_5__["ViewTestResultButtonComponent"],
                },
            },
        };
        this.quizChapterQuestions = new ng2_smart_table__WEBPACK_IMPORTED_MODULE_4__["LocalDataSource"]();
        this.getTests();
    }
    ngOnInit() { }
    addQuestions() {
        this.questions = [];
        this.questionsPositiveMarks = [];
        this.questionsNegativeMarks = [];
        for (let i = 0; i < this.numberOfQuestions; i++) {
            // const element = array[i];
            this.questions.push([0, 0, 0, 0]);
            this.questionsPositiveMarks.push(this.positiveMarks || 0);
            this.questionsNegativeMarks.push(this.negativeMarks || 0);
        }
    }
    answerSelected(i, j) {
        // alert(i)
        // alert(j)
        if (this.questions[i][j] == j + 1) {
            this.questions[i][j] = 0;
        }
        else
            this.questions[i][j] = j + 1;
    }
    testPaperSelected(files) {
        // alert(files.item(0).type)
        if (files.item(0).type != "application/pdf") {
            return alert("Only Pdf is supported");
        }
        this.testFile = files;
    }
    answerPaperSelected(files) {
        // alert(files.item(0).type)
        if (files.item(0).type != "application/pdf") {
            return alert("Only Pdf is supported");
        }
        this.answerTestFile = files;
    }
    createTest() {
        console.log("questions", this.questions);
        // you will get array of array in  this.questions . remove all the zeros and send to backend
        let i = 0;
        this.filteredQuestions = [];
        this.questions.forEach((question) => {
            // i++
            this.filteredQuestions.push([]);
            question.forEach((option) => {
                if (option != 0) {
                    this.filteredQuestions[i].push({ correct_option: option });
                }
            });
            i++;
        });
        console.log("filterest questions", this.filteredQuestions);
        this.submitTest();
    }
    deleteTest(event) {
        console.log(event);
        this.http
            .delete(this.dataService.serverUrl + "test/" + event.data.id)
            .subscribe((data) => {
            this.getTests();
        });
    }
    submitTest() {
        if (!this.selectedSubCourseID) {
            return;
        }
        let formData = new FormData();
        let fileToUpload;
        let answerFileToUpload;
        fileToUpload = this.testFile.item(0);
        answerFileToUpload = this.answerTestFile.item(0);
        // formData.append("subcourseID", this.selectedSubCourseID);
        formData.append("subjectID", this.selectedSubjectID);
        formData.append("testFile", fileToUpload, fileToUpload.name);
        formData.append("testAnswerFile", answerFileToUpload, answerFileToUpload.name);
        formData.append("title", this.title);
        formData.append("positiveMarks", this.positiveMarks);
        formData.append("minutes", this.minutes);
        formData.append("startDateTime", new Date(this.startDateTime).toISOString());
        formData.append("endDateTime", new Date(this.endDateTime).toISOString());
        formData.append("negativeMarks", this.negativeMarks);
        formData.append("questions", JSON.stringify(this.filteredQuestions));
        formData.append("questionsPositiveMarks", JSON.stringify(this.questionsPositiveMarks));
        formData.append("questionsNegativeMarks", JSON.stringify(this.questionsNegativeMarks));
        this.http
            .post(this.dataService.serverUrl + "test", formData)
            .subscribe((val) => {
            console.log(val);
            if (!val.status) {
                alert("Unable to add question");
            }
            else {
                this.getTests();
                // this.getQuizChapterQuestion();
            }
        });
        return false;
    }
    getFilteredSubjects() {
        this.http
            .get(this.dataService.serverUrl + "subject", {
            params: { subCourseID: this.selectedSubCourseID },
        })
            .subscribe((data) => {
            console.log("GET FILTERED SUBJECT :", data);
            this.filteredSubjects = data.data;
        });
    }
    getTests() {
        this.tests.load([]);
        this.http
            .get(this.dataService.serverUrl + "test")
            .subscribe((data) => {
            console.log("GET TESTS :", data);
            this.tests.load(data.data);
            // this.quizChapterQuestions = data.data;
            // this.quizChapterQuestions.load(data.data)
        });
    }
};
AddTestComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] }
];
AddTestComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: "app-add-test",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./add-test.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/test/add-test/add-test.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./add-test.component.css */ "./src/app/test/add-test/add-test.component.css")).default]
    })
], AddTestComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/sachinsaini/Desktop/Projects/akashAngularPanel/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map